export const Email = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.92 0.786744C11.967 0.737673 10.033 0.73767 8.07999 0.786738L8.02182 0.788198C6.497 0.826484 5.27002 0.857291 4.2867 1.02854C3.2572 1.20783 2.42048 1.55171 1.71362 2.26126C1.00971 2.96784 0.66764 3.79253 0.491759 4.80534C0.324289 5.76971 0.298783 6.96674 0.267187 8.44959L0.265935 8.50833C0.244688 9.50467 0.244688 10.4952 0.265936 11.4916L0.267188 11.5503C0.298786 13.0331 0.324293 14.2302 0.491763 15.1945C0.667644 16.2073 1.00972 17.032 1.71362 17.7386C2.42048 18.4482 3.2572 18.792 4.2867 18.9713C5.27001 19.1426 6.49697 19.1734 8.02177 19.2117L8.07999 19.2131C10.033 19.2622 11.967 19.2622 13.92 19.2131L13.9782 19.2117C15.503 19.1734 16.73 19.1426 17.7133 18.9713C18.7428 18.792 19.5795 18.4482 20.2864 17.7386C20.9903 17.032 21.3324 16.2073 21.5082 15.1945C21.6757 14.2302 21.7012 13.0331 21.7328 11.5503L21.7341 11.4916C21.7553 10.4952 21.7553 9.50468 21.7341 8.50834L21.7328 8.44961C21.7012 6.96676 21.6757 5.76973 21.5082 4.80536C21.3324 3.79255 20.9903 2.96786 20.2864 2.26128C19.5795 1.55173 18.7428 1.20785 17.7133 1.02855C16.73 0.857304 15.503 0.826494 13.9782 0.788205L13.92 0.786744ZM8.11766 2.28626C10.0456 2.23783 11.9544 2.23783 13.8823 2.28627C15.479 2.32639 16.5947 2.35632 17.4559 2.50631C18.2835 2.65043 18.7994 2.89405 19.2237 3.31992C19.3977 3.49453 19.5405 3.68249 19.6582 3.89823L13.7173 7.26438C12.4621 7.97564 11.7003 8.24995 11.0001 8.24995C10.2999 8.24995 9.53815 7.97564 8.28285 7.26438L2.34181 3.89814C2.4595 3.68243 2.60237 3.49449 2.77629 3.31991C3.20055 2.89403 3.71652 2.65042 4.54405 2.5063C5.40529 2.35631 6.52099 2.32638 8.11766 2.28626ZM1.92102 5.38377C1.81754 6.17558 1.79468 7.1764 1.76559 8.54031C1.7448 9.51534 1.7448 10.4845 1.7656 11.4596C1.79877 13.0151 1.82385 14.0983 1.96964 14.9379C2.10923 15.7417 2.34907 16.2511 2.77629 16.68C3.20056 17.1058 3.71653 17.3495 4.54406 17.4936C5.4053 17.6436 6.521 17.6735 8.11767 17.7136C10.0456 17.7621 11.9544 17.7621 13.8823 17.7136C15.479 17.6735 16.5947 17.6436 17.4559 17.4936C18.2835 17.3495 18.7994 17.1058 19.2237 16.68C19.6509 16.2511 19.8908 15.7417 20.0304 14.9379C20.1762 14.0983 20.2012 13.0151 20.2344 11.4596C20.2552 10.4845 20.2552 9.51535 20.2344 8.54032C20.2053 7.17647 20.1825 6.17568 20.079 5.38387L14.4568 8.56945C13.1635 9.30223 12.1126 9.74994 11.0001 9.74994C9.88761 9.74994 8.83667 9.30223 7.54339 8.56945L1.92102 5.38377Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Phone = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <path
        fill="#ffffff"
        d="M19.5 22a1.5 1.5 0 0 0 1.5-1.5V17a1.5 1.5 0 0 0-1.5-1.5c-1.17 0-2.32-.18-3.42-.55a1.51 1.51 0 0 0-1.52.37l-1.44 1.44a14.77 14.77 0 0 1-5.89-5.89l1.43-1.43c.41-.39.56-.97.38-1.53c-.36-1.09-.54-2.24-.54-3.41A1.5 1.5 0 0 0 7 3H3.5A1.5 1.5 0 0 0 2 4.5C2 14.15 9.85 22 19.5 22M3.5 4H7a.5.5 0 0 1 .5.5c0 1.28.2 2.53.59 3.72c.05.14.04.34-.12.5L6 10.68c1.65 3.23 4.07 5.65 7.31 7.32l1.95-1.97c.14-.14.33-.18.51-.13c1.2.4 2.45.6 3.73.6a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5C10.4 21 3 13.6 3 4.5a.5.5 0 0 1 .5-.5"
      />
    </svg>
  );
};

export const Lock = () => {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 14.5C5.5 13.9477 5.94772 13.5 6.5 13.5H6.50897C7.06125 13.5 7.50897 13.9477 7.50897 14.5C7.50897 15.0523 7.06125 15.5 6.50897 15.5H6.5C5.94772 15.5 5.5 15.0523 5.5 14.5Z"
        fill="currentColor"
      />
      <path
        d="M10.491 14.5C10.491 13.9477 10.9387 13.5 11.491 13.5H11.5C12.0523 13.5 12.5 13.9477 12.5 14.5C12.5 15.0523 12.0523 15.5 11.5 15.5H11.491C10.9387 15.5 10.491 15.0523 10.491 14.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 7.45909V5.5C3.75 2.6005 6.1005 0.25 9 0.25C11.8995 0.25 14.25 2.6005 14.25 5.5V7.45909C15.9408 7.86285 17.239 9.29844 17.4755 11.0552C17.6236 12.1556 17.75 13.3118 17.75 14.5C17.75 15.6882 17.6236 16.8444 17.4755 17.9448C17.2039 19.9618 15.5328 21.5555 13.4748 21.6501C12.0464 21.7158 10.5958 21.75 9 21.75C7.40416 21.75 5.95364 21.7158 4.52522 21.6501C2.46716 21.5555 0.796088 19.9618 0.524518 17.9448C0.376363 16.8444 0.25 15.6882 0.25 14.5C0.25 13.3118 0.376363 12.1556 0.524518 11.0552C0.761044 9.29844 2.05919 7.86285 3.75 7.45909ZM5.25 5.5C5.25 3.42893 6.92893 1.75 9 1.75C11.0711 1.75 12.75 3.42893 12.75 5.5V7.31937C11.5532 7.27365 10.3269 7.25 9 7.25C7.67315 7.25 6.44676 7.27365 5.25 7.31937V5.5ZM9 8.75C7.42645 8.75 5.9989 8.78372 4.5941 8.8483C3.2851 8.90848 2.18929 9.93188 2.0111 11.2553C1.86573 12.3351 1.75 13.4129 1.75 14.5C1.75 15.5871 1.86573 16.6649 2.0111 17.7447C2.18929 19.0681 3.2851 20.0915 4.5941 20.1517C5.9989 20.2163 7.42645 20.25 9 20.25C10.5736 20.25 12.0011 20.2163 13.4059 20.1517C14.7149 20.0915 15.8107 19.0681 15.9889 17.7447C16.1343 16.6649 16.25 15.5871 16.25 14.5C16.25 13.4129 16.1343 12.3351 15.9889 11.2553C15.8107 9.93188 14.7149 8.90848 13.4059 8.8483C12.0011 8.78372 10.5736 8.75 9 8.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Lock2 = () => {
  return (
    <svg
      width="19"
      height="23"
      viewBox="0 0 19 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.49609 14C8.94381 14 8.49609 14.4477 8.49609 15C8.49609 15.5523 8.94381 16 9.49609 16H9.50508C10.0574 16 10.5051 15.5523 10.5051 15C10.5051 14.4477 10.0574 14 9.50508 14H9.49609Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25 6V7.95909C2.55919 8.36285 1.26104 9.79844 1.02452 11.5552C0.876363 12.6556 0.75 13.8118 0.75 15C0.75 16.1882 0.876363 17.3444 1.02452 18.4448C1.29609 20.4618 2.96716 22.0555 5.02522 22.1501C6.45364 22.2158 7.90416 22.25 9.5 22.25C11.0958 22.25 12.5464 22.2158 13.9748 22.1501C16.0328 22.0555 17.7039 20.4618 17.9755 18.4448C18.1236 17.3444 18.25 16.1882 18.25 15C18.25 13.8118 18.1236 12.6556 17.9755 11.5552C17.739 9.79844 16.4408 8.36285 14.75 7.95909V6C14.75 3.1005 12.3995 0.75 9.5 0.75C6.6005 0.75 4.25 3.1005 4.25 6ZM9.5 2.25C7.42893 2.25 5.75 3.92893 5.75 6V7.81937C6.94676 7.77365 8.17315 7.75 9.5 7.75C10.8269 7.75 12.0532 7.77365 13.25 7.81937V6C13.25 3.92893 11.5711 2.25 9.5 2.25ZM9.5 9.25C7.92645 9.25 6.4989 9.28372 5.0941 9.3483C3.7851 9.40848 2.68929 10.4319 2.5111 11.7553C2.36573 12.8351 2.25 13.9129 2.25 15C2.25 16.0871 2.36573 17.1649 2.5111 18.2447C2.68929 19.5681 3.7851 20.5915 5.0941 20.6517C6.4989 20.7163 7.92645 20.75 9.5 20.75C11.0736 20.75 12.5011 20.7163 13.9059 20.6517C15.2149 20.5915 16.3107 19.5681 16.4889 18.2447C16.6343 17.1649 16.75 16.0871 16.75 15C16.75 13.9129 16.6343 12.8351 16.4889 11.7553C16.3107 10.4319 15.2149 9.40848 13.9059 9.3483C12.5011 9.28372 11.0736 9.25 9.5 9.25Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Document = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2409 21.752C8.03091 21.752 5.7129 21.696 4.0829 21.601C2.7209 21.521 1.6139 20.818 0.882904 19.566C0.301904 18.57 0.0938904 17.456 0.0938904 16.744C0.0781206 15.4913 0.0827451 12.9942 0.0876687 10.3355L0.0878845 10.219C0.0908845 8.79698 0.0938904 7.32597 0.0938904 5.96497C0.0938904 1.30297 3.02389 0.557991 4.31689 0.456991C4.57789 0.419991 6.45288 0.170981 8.85888 0.271981C9.27288 0.288981 9.5939 0.638987 9.5769 1.05299C9.5599 1.46699 9.21089 1.78798 8.79589 1.77098C6.40489 1.67098 4.5269 1.94298 4.5079 1.94598C4.4899 1.94898 4.4709 1.95099 4.4519 1.95199C3.1479 2.04599 1.59291 2.81898 1.59291 5.96598C1.59291 7.32798 1.58991 8.79998 1.58691 10.223L1.58603 10.6933C1.58129 13.2118 1.57691 15.5391 1.59291 16.735C1.59291 17.422 2.02989 19.979 4.16889 20.104C7.23589 20.282 12.7609 20.322 15.2879 20.105C15.2912 20.105 15.2945 20.1048 15.2979 20.1044L15.3089 20.103C15.3319 20.102 17.5999 19.947 17.8599 17.709C18.1209 15.464 18.1029 13.826 18.0959 13.209C18.0959 13.1632 18.0953 13.1229 18.0947 13.0878C18.0943 13.0608 18.0939 13.0369 18.0939 13.016C18.0939 12.602 18.4299 12.266 18.8439 12.266C19.2579 12.266 19.5939 12.602 19.5939 13.016C19.5939 13.06 19.5939 13.119 19.5959 13.192L19.596 13.201C19.6031 13.8509 19.6216 15.5539 19.3499 17.882C19.0279 20.655 16.6359 21.525 15.4059 21.599C14.1719 21.704 12.2499 21.75 10.2399 21.75L10.2409 21.752Z"
        fill="currentColor"
      />
      <path
        d="M14.8132 8.26697H14.7742C14.5042 8.25297 14.2622 8.09498 14.1422 7.85298C13.7092 6.98598 13.2872 6.55198 13.2823 6.54798C12.9893 6.25498 12.9893 5.77999 13.2823 5.48699C13.5752 5.19399 14.0502 5.19399 14.3432 5.48699C14.3792 5.52299 14.5902 5.73997 14.8702 6.14097C15.5212 5.29797 16.5402 4.17299 17.5632 3.80999C17.9532 3.67199 18.3822 3.87597 18.5202 4.26597C18.6582 4.65597 18.4542 5.08498 18.0642 5.22298C17.2142 5.52398 16.0072 7.03597 15.4462 7.91797C15.3082 8.13497 15.0692 8.26597 14.8132 8.26597V8.26697Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0732 6.01709C10.0732 9.18809 12.6553 11.7671 15.8283 11.7671C19.0013 11.7671 21.5833 9.18809 21.5833 6.01709C21.5833 2.84609 19.0013 0.26709 15.8283 0.26709C12.6553 0.26709 10.0732 2.84609 10.0732 6.01709ZM11.5732 6.01709C11.5732 3.67409 13.4823 1.76709 15.8283 1.76709C18.1743 1.76709 20.0833 3.67409 20.0833 6.01709C20.0833 8.36009 18.1743 10.2671 15.8283 10.2671C13.4823 10.2671 11.5732 8.36009 11.5732 6.01709Z"
        fill="currentColor"
      />
      <path
        d="M9.81299 12.7671H5.81299C5.39899 12.7671 5.06299 12.4311 5.06299 12.0171C5.06299 11.6031 5.39899 11.2671 5.81299 11.2671H9.81299C10.227 11.2671 10.563 11.6031 10.563 12.0171C10.563 12.4311 10.227 12.7671 9.81299 12.7671Z"
        fill="currentColor"
      />
      <path
        d="M5.81299 16.7671H13.813C14.227 16.7671 14.563 16.4311 14.563 16.0171C14.563 15.6031 14.227 15.2671 13.813 15.2671H5.81299C5.39899 15.2671 5.06299 15.6031 5.06299 16.0171C5.06299 16.4311 5.39899 16.7671 5.81299 16.7671Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Wallet = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.834 1.75C15.1812 1.75 17.084 3.65279 17.084 6C17.084 6.09029 17.0812 6.17985 17.0757 6.2686C16.4384 6.24321 15.7116 6.24322 14.8889 6.24324L8.59081 6.24324C8.58628 6.16279 8.58398 6.08169 8.58398 6C8.58398 5.05012 8.8956 4.17302 9.42219 3.46536C9.4302 3.45525 9.43796 3.44492 9.44545 3.43439C10.2215 2.41099 11.4506 1.75 12.834 1.75ZM8.47496 2.25C9.52943 1.02538 11.0912 0.25 12.834 0.25C16.0096 0.25 18.584 2.82436 18.584 6C18.584 6.13926 18.579 6.27746 18.5692 6.41442C19.3202 6.55397 19.962 6.81815 20.4858 7.34214C21.0876 7.94428 21.3465 8.70241 21.4675 9.60284C21.584 10.4702 21.584 11.573 21.584 12.9413V15.0519C21.584 16.4202 21.584 17.5231 21.4675 18.3904C21.3465 19.2908 21.0876 20.049 20.4858 20.6511C19.8839 21.2533 19.126 21.5123 18.2258 21.6334C17.3588 21.75 16.2565 21.75 14.8889 21.75H8.77754H8.77749C6.93978 21.75 5.48414 21.75 4.34491 21.5968C3.17243 21.4391 2.22345 21.1068 1.4751 20.3581C0.726801 19.6094 0.394727 18.6601 0.237114 17.4872C0.0839569 16.3475 0.0839692 14.8912 0.0839847 13.0525V13.0525V10.9388V10.9388C0.0839692 9.10008 0.0839569 7.64379 0.237114 6.50407C0.394727 5.33119 0.726801 4.3819 1.4751 3.63324C2.66534 2.44243 4.39564 2.28521 6.82313 2.25008L6.83399 2.25H8.47496ZM7.54087 3.75H6.83943C4.31166 3.78686 3.23145 3.99787 2.53602 4.69365C2.11274 5.11712 1.85903 5.69717 1.72375 6.70385C1.58558 7.73207 1.58399 9.08745 1.58399 10.9952V12.9961C1.58399 14.9039 1.58558 16.2592 1.72375 17.2875C1.85903 18.2941 2.11274 18.8742 2.53602 19.2977C2.95924 19.7211 3.53886 19.9749 4.54488 20.1102C5.57252 20.2484 6.92715 20.25 8.83398 20.25H14.834C16.2694 20.25 17.2705 20.2484 18.0258 20.1468C18.7595 20.0481 19.1481 19.8676 19.4248 19.5907C19.7017 19.3137 19.8822 18.9249 19.9808 18.1906C20.0824 17.4348 20.084 16.4332 20.084 14.9971V12.9961C20.084 11.56 20.0824 10.5584 19.9808 9.80262C19.8822 9.06838 19.7017 8.6795 19.4248 8.40254C19.1481 8.12563 18.7595 7.94512 18.0258 7.84643C17.2705 7.74483 16.2694 7.74324 14.834 7.74324H5.83399C5.41977 7.74324 5.08399 7.40745 5.08399 6.99324C5.08399 6.57902 5.41977 6.24324 5.83399 6.24324H7.08905C7.08568 6.16255 7.08398 6.08145 7.08398 6C7.08398 5.20153 7.24674 4.44108 7.54087 3.75ZM16.334 12.25C16.7482 12.25 17.084 12.5858 17.084 13C17.084 13.4142 16.7482 13.75 16.334 13.75C15.9198 13.75 15.584 13.4142 15.584 13C15.584 12.5858 15.9198 12.25 16.334 12.25ZM18.584 13C18.584 11.7574 17.5766 10.75 16.334 10.75C15.0913 10.75 14.084 11.7574 14.084 13C14.084 14.2426 15.0913 15.25 16.334 15.25C17.5766 15.25 18.584 14.2426 18.584 13Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const BitcoinMoney = () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.833 5.25C11.2472 5.25 11.583 5.58579 11.583 6V6.58333H12.3955C13.3723 6.58333 14.083 7.41317 14.083 8.33333V9C14.083 9.3624 13.9728 9.7108 13.7795 10C13.9728 10.2892 14.083 10.6376 14.083 11V11.6667C14.083 12.5868 13.3723 13.4167 12.3955 13.4167H11.583V14C11.583 14.4142 11.2472 14.75 10.833 14.75C10.4188 14.75 10.083 14.4142 10.083 14V13.4167H8.33301C7.91879 13.4167 7.58301 13.0809 7.58301 12.6667C7.58301 12.2525 7.91879 11.9167 8.33301 11.9167H8.52051V8.08333H8.33301C7.91879 8.08333 7.58301 7.74755 7.58301 7.33333C7.58301 6.91912 7.91879 6.58333 8.33301 6.58333H10.083V6C10.083 5.58579 10.4188 5.25 10.833 5.25ZM10.0205 8.08333V9.25H12.3955C12.4542 9.25 12.583 9.1844 12.583 9V8.33333C12.583 8.14893 12.4542 8.08333 12.3955 8.08333H10.0205ZM12.3955 10.75H10.0205V11.9167H12.3955C12.4542 11.9167 12.583 11.8511 12.583 11.6667V11C12.583 10.8156 12.4542 10.75 12.3955 10.75Z"
        fill="currentColor"
      />
      <path
        d="M5.58128 11.0181C5.61018 10.6049 5.29864 10.2465 4.88543 10.2176C4.56261 10.195 4.24716 10.1611 3.94059 10.1167C3.53065 10.0574 3.15021 10.3416 3.09085 10.7515C3.03148 11.1614 3.31568 11.5419 3.72562 11.6012C4.06928 11.651 4.42154 11.6888 4.78078 11.714C5.19398 11.7429 5.55238 11.4313 5.58128 11.0181Z"
        fill="currentColor"
      />
      <path
        d="M18.5754 9.24947C18.6347 8.83953 18.3505 8.45909 17.9406 8.39973C17.5969 8.34996 17.2447 8.31213 16.8854 8.287C16.4722 8.2581 16.1138 8.56964 16.0849 8.98285C16.056 9.39605 16.3676 9.75445 16.7808 9.78335C17.1036 9.80592 17.4191 9.83985 17.7256 9.88424C18.1356 9.94361 18.516 9.65941 18.5754 9.24947Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.833 0.75C13.8245 0.75 11.9628 1.14454 10.5156 1.82046C9.29776 2.38927 7.65865 2.75 5.83301 2.75C4.821 2.75 3.86289 2.63907 3.00045 2.44153C1.67401 2.13772 0.0830078 3.04678 0.0830078 4.61397V15.386C0.0830078 16.2216 0.215428 17.0082 0.649446 17.6488C1.09825 18.3111 1.78989 18.7031 2.66556 18.9037C3.6425 19.1274 4.71317 19.25 5.83301 19.25C7.8415 19.25 9.70317 18.8555 11.1504 18.1795C12.3683 17.6107 14.0074 17.25 15.833 17.25C16.845 17.25 17.8031 17.3609 18.6656 17.5585C19.992 17.8623 21.583 16.9532 21.583 15.386V4.61397C21.583 3.81712 21.4758 3.03453 21.0548 2.38745C20.6155 1.71217 19.9175 1.30637 19.0005 1.09633C18.0235 0.872567 16.9528 0.75 15.833 0.75ZM11.1504 3.17954C12.3683 2.61073 14.0074 2.25 15.833 2.25C16.845 2.25 17.8031 2.36093 18.6656 2.55847C19.3302 2.7107 19.6322 2.95139 19.7975 3.20542C19.9811 3.48766 20.083 3.91721 20.083 4.61397V15.386C20.083 15.7885 19.5939 16.2323 19.0005 16.0963C18.0235 15.8726 16.9528 15.75 15.833 15.75C13.8245 15.75 11.9628 16.1445 10.5156 16.8205C9.29776 17.3893 7.65866 17.75 5.83301 17.75C4.821 17.75 3.86289 17.6391 3.00046 17.4415C2.3757 17.2984 2.06734 17.0673 1.89125 16.8074C1.70037 16.5257 1.58301 16.0908 1.58301 15.386V4.61397C1.58301 4.2115 2.07207 3.76774 2.66556 3.90367C3.64249 4.12743 4.71317 4.25 5.83301 4.25C7.8415 4.25 9.70317 3.85546 11.1504 3.17954Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ArrowDown = () => {
  return (
    <svg
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.60274 1.16417C1.72463 1.32555 2.08853 1.80729 2.30526 2.085C2.73934 2.64121 3.33245 3.3803 3.97225 4.1172C4.61529 4.85781 5.2908 5.57911 5.89092 6.10935C6.19183 6.37523 6.45617 6.57726 6.6743 6.70876C6.87945 6.83244 7.00063 6.85815 7.00063 6.85815C7.00063 6.85815 7.11826 6.83243 7.3234 6.70877C7.54153 6.57727 7.80586 6.37524 8.10677 6.10936C8.70689 5.57911 9.3824 4.85781 10.0254 4.11719C10.6652 3.38028 11.2584 2.64119 11.6924 2.08497C11.9092 1.80725 12.2726 1.32619 12.3944 1.16482C12.6401 0.831293 13.1101 0.759357 13.4436 1.00499C13.7771 1.25062 13.8484 1.72012 13.6027 2.05364L13.6008 2.05618C13.473 2.22544 13.0961 2.72445 12.875 3.00781C12.4311 3.57659 11.8206 4.3375 11.1581 5.1006C10.4988 5.85997 9.7731 6.63868 9.09998 7.23343C8.76428 7.53005 8.42399 7.79676 8.09783 7.99339C7.79225 8.17761 7.40535 8.35889 6.99884 8.35889C6.59233 8.35888 6.20544 8.1776 5.89987 7.99338C5.5737 7.79676 5.23341 7.53004 4.89771 7.23343C4.22459 6.63868 3.49893 5.85998 2.83961 5.10061C2.17705 4.33752 1.56662 3.57662 1.12274 3.00785C0.901456 2.7243 0.52453 2.22526 0.396953 2.05635L0.395303 2.05417C0.149669 1.72065 0.220564 1.25067 0.554086 1.00504C0.887596 0.759413 1.3571 0.830679 1.60274 1.16417Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ID = () => {
  return (
    <svg
      width="23"
      height="21"
      viewBox="0 0 23 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00018 5.25C6.4814 5.25 5.25018 6.48122 5.25018 8C5.25018 9.51878 6.4814 10.75 8.00018 10.75C9.51896 10.75 10.7502 9.51878 10.7502 8C10.7502 6.48122 9.51896 5.25 8.00018 5.25ZM6.75018 8C6.75018 7.30964 7.30982 6.75 8.00018 6.75C8.69053 6.75 9.25018 7.30964 9.25018 8C9.25018 8.69036 8.69053 9.25 8.00018 9.25C7.30982 9.25 6.75018 8.69036 6.75018 8Z"
        fill="currentColor"
      />
      <path
        d="M5.17943 15.318C5.62793 14.3599 6.74064 13.7687 7.98143 13.7504C9.2131 13.7322 10.3358 14.2818 10.8209 15.318C10.9965 15.6931 11.443 15.8549 11.8182 15.6793C12.1933 15.5036 12.355 15.0572 12.1794 14.682C11.3767 12.9673 9.60359 12.2263 7.95929 12.2506C6.32412 12.2747 4.58074 13.059 3.82093 14.682C3.64531 15.0572 3.80705 15.5036 4.18219 15.6793C4.55733 15.8549 5.00381 15.6931 5.17943 15.318Z"
        fill="currentColor"
      />
      <path
        d="M13.75 8.5C13.75 8.08579 14.0858 7.75 14.5 7.75H18.5C18.9142 7.75 19.25 8.08579 19.25 8.5C19.25 8.91421 18.9142 9.25 18.5 9.25H14.5C14.0858 9.25 13.75 8.91421 13.75 8.5Z"
        fill="currentColor"
      />
      <path
        d="M14.5 11.75C14.0858 11.75 13.75 12.0858 13.75 12.5C13.75 12.9142 14.0858 13.25 14.5 13.25H18.5C18.9142 13.25 19.25 12.9142 19.25 12.5C19.25 12.0858 18.9142 11.75 18.5 11.75H14.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5522 0.75H11.4478C9.13499 0.749991 7.33014 0.749983 5.92355 0.920184C4.49222 1.09338 3.35936 1.45359 2.46274 2.26055C1.55481 3.07769 1.13908 4.12747 0.94129 5.45147C0.749966 6.73221 0.749981 8.36922 0.75 10.4375V10.5625C0.749981 12.6308 0.749966 14.2678 0.94129 15.5485C1.13908 16.8725 1.55481 17.9223 2.46274 18.7395C3.35936 19.5464 4.49222 19.9066 5.92355 20.0798C7.33014 20.25 9.13498 20.25 11.4478 20.25H11.5522C13.865 20.25 15.6699 20.25 17.0765 20.0798C18.5078 19.9066 19.6406 19.5464 20.5373 18.7395C21.4452 17.9223 21.8609 16.8725 22.0587 15.5485C22.25 14.2678 22.25 12.6308 22.25 10.5625V10.4375C22.25 8.3692 22.25 6.73221 22.0587 5.45147C21.8609 4.12747 21.4452 3.07769 20.5373 2.26055C19.6406 1.45359 18.5078 1.09338 17.0765 0.920184C15.6699 0.749983 13.865 0.749991 11.5522 0.75ZM3.46619 3.37549C4.03404 2.86443 4.81193 2.56563 6.10374 2.40932C7.40972 2.2513 9.12385 2.25 11.5 2.25C13.8762 2.25 15.5903 2.2513 16.8963 2.40932C18.1881 2.56563 18.966 2.86443 19.5338 3.37549C20.0903 3.87637 20.4068 4.54626 20.5752 5.67309C20.748 6.83029 20.75 8.3552 20.75 10.5C20.75 12.6448 20.748 14.1697 20.5752 15.3269C20.4068 16.4537 20.0903 17.1236 19.5338 17.6245C18.966 18.1356 18.1881 18.4344 16.8963 18.5907C15.5903 18.7487 13.8762 18.75 11.5 18.75C9.12385 18.75 7.40972 18.7487 6.10374 18.5907C4.81193 18.4344 4.03404 18.1356 3.46619 17.6245C2.90965 17.1236 2.59316 16.4537 2.42483 15.3269C2.25196 14.1697 2.25 12.6448 2.25 10.5C2.25 8.3552 2.25196 6.83029 2.42483 5.67309C2.59316 4.54626 2.90965 3.87637 3.46619 3.37549Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const VAT = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="21"
      viewBox="0 0 23 21"
      fill="none"
    >
      <path
        d="M18.9091 7.74149C21.7207 7.74149 24 10.1677 24 13.1605C24 14.6373 23.4451 15.976 22.5452 16.9534L22.5455 23.2245C22.5455 23.8624 21.8612 24.2265 21.3818 23.8438L19.3455 22.2181C19.0868 22.0117 18.7313 22.0117 18.4727 22.2181L16.4364 23.8438C15.9569 24.2265 15.2727 23.8624 15.2727 23.2245V16.9531C14.3729 15.9756 13.8182 14.6371 13.8182 13.1605C13.8182 10.1677 16.0975 7.74149 18.9091 7.74149ZM21.0909 18.0581C20.4297 18.3925 19.6899 18.5796 18.9091 18.5796C18.2395 18.5796 17.6009 18.4424 17.0155 18.1924L16.7273 18.0581V21.2891L18.535 20.1345C18.7269 20.0119 18.9586 19.9915 19.1638 20.0732L19.2832 20.1345L21.0909 21.2891V18.0581ZM20.3636 0C21.9703 0 23.2727 1.38639 23.2727 3.09659V7.96729C22.8365 7.55174 22.3478 7.19754 21.8182 6.91742V3.09659C21.8182 2.2415 21.167 1.5483 20.3636 1.5483H2.90909C2.10577 1.5483 1.45455 2.2415 1.45455 3.09659V15.483C1.45455 16.3381 2.10577 17.0313 2.90909 17.0313H13.4659C13.5761 17.2067 13.6938 17.3765 13.8182 17.5402V18.5796H2.90909C1.30244 18.5796 0 17.1932 0 15.483V3.09659C0 1.38639 1.30244 0 2.90909 0H20.3636ZM18.9091 9.28978C16.9008 9.28978 15.2727 11.0228 15.2727 13.1605C15.2727 15.2983 16.9008 17.0313 18.9091 17.0313C20.9174 17.0313 22.5455 15.2983 22.5455 13.1605C22.5455 11.0228 20.9174 9.28978 18.9091 9.28978ZM10.9091 12.3864C11.3107 12.3864 11.6364 12.733 11.6364 13.1605C11.6364 13.5405 11.3791 13.8566 11.0398 13.9222L10.9091 13.9347H5.09091C4.68925 13.9347 4.36364 13.588 4.36364 13.1605C4.36364 12.7805 4.62091 12.4644 4.96018 12.3989L5.09091 12.3864H10.9091ZM18.1818 4.64489C18.5834 4.64489 18.9091 4.99149 18.9091 5.41904C18.9091 5.84659 18.5834 6.19319 18.1818 6.19319H5.09091C4.68925 6.19319 4.36364 5.84659 4.36364 5.41904C4.36364 4.99149 4.68925 4.64489 5.09091 4.64489H18.1818Z"
        fill="#CCB16A"
      />
    </svg>
  );
};

export const Upload = (props) => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.7502 11.5C10.7502 11.9142 10.4145 12.25 10.0002 12.25C9.58603 12.25 9.25024 11.9142 9.25024 11.5V3.03807L9.24418 3.04522C9.0335 3.29386 8.82721 3.55663 8.6343 3.80235L8.58958 3.8593C8.39735 4.10404 8.19512 4.36115 8.03806 4.52274C7.74935 4.81977 7.27453 4.82651 6.9775 4.53781C6.68048 4.24911 6.67373 3.77428 6.96243 3.47726C7.05114 3.386 7.19676 3.20419 7.40995 2.93276L7.45699 2.87285C7.64705 2.63071 7.87005 2.34662 8.09978 2.07551C8.34598 1.78495 8.62156 1.48316 8.89703 1.24854C9.03508 1.13096 9.19068 1.01499 9.35807 0.925414C9.51951 0.83902 9.74196 0.75 10.0002 0.75C10.2585 0.75 10.481 0.83902 10.6424 0.925414C10.8098 1.01499 10.9654 1.13096 11.1035 1.24854C11.3789 1.48316 11.6545 1.78495 11.9007 2.07551C12.1304 2.3466 12.3534 2.63064 12.5434 2.87277L12.5905 2.93276C12.8037 3.20419 12.9494 3.386 13.0381 3.47726C13.3268 3.77428 13.32 4.24911 13.023 4.53781C12.726 4.82651 12.2511 4.81977 11.9624 4.52274C11.8054 4.36115 11.6031 4.10404 11.4109 3.85931L11.3662 3.80234C11.1733 3.55662 10.967 3.29385 10.7563 3.04522L10.7502 3.03807V11.5Z"
        fill="currentColor"
      />
      <path
        d="M19.7074 11.7496C19.8453 11.359 19.6404 10.9306 19.2498 10.7927C18.8592 10.6549 18.4308 10.8598 18.293 11.2504L18.0591 11.9129C17.5984 13.2184 17.2725 14.1384 16.9379 14.8281C16.6116 15.5006 16.3082 15.8853 15.9296 16.1531C15.551 16.4209 15.0874 16.579 14.3446 16.6629C13.5829 16.7489 12.6068 16.75 11.2224 16.75H8.77797C7.39359 16.75 6.41753 16.7489 5.65581 16.6629C4.91303 16.579 4.44937 16.4209 4.0708 16.1531C3.69224 15.8853 3.38882 15.5006 3.06254 14.8281C2.72794 14.1384 2.40204 13.2184 1.94129 11.9129L1.70745 11.2504C1.56959 10.8598 1.14119 10.6549 0.750589 10.7927C0.35999 10.9306 0.155103 11.359 0.292962 11.7496L0.54175 12.4545C0.984139 13.708 1.33715 14.7082 1.71299 15.4829C2.10137 16.2834 2.54467 16.9108 3.20444 17.3776C3.86422 17.8444 4.60339 18.0536 5.48754 18.1534C6.34313 18.25 7.40382 18.25 8.73307 18.25H11.2673C12.5966 18.25 13.6573 18.25 14.5129 18.1534C15.397 18.0536 16.1362 17.8444 16.796 17.3776C17.4557 16.9108 17.899 16.2834 18.2874 15.4829C18.6633 14.7082 19.0163 13.708 19.4587 12.4545L19.7074 11.7496Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Passport = () => {
  return (
    <svg
      width="23"
      height="21"
      viewBox="0 0 23 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.7247 1.71575C22.1199 1.59165 22.3396 1.17068 22.2155 0.775494C22.0914 0.380309 21.6705 0.160552 21.2753 0.284654C19.4226 0.866451 17.803 2.52673 16.6963 3.91492C16.2433 4.48314 15.8583 5.0291 15.5591 5.47987C15.1787 4.9407 14.5046 4.2502 13.5 4.2502C13.0858 4.2502 12.75 4.58599 12.75 5.0002C12.75 5.41441 13.0858 5.7502 13.5 5.7502C13.7785 5.7502 14.0828 5.96399 14.3812 6.41437C14.516 6.61802 14.6198 6.82707 14.6902 6.9882C14.725 7.06769 14.7505 7.13286 14.7667 7.17637C14.7748 7.19806 14.7805 7.21418 14.7839 7.22378L14.7869 7.23263L14.7873 7.23371C14.88 7.51688 15.1317 7.71834 15.4285 7.74678C15.7258 7.77527 16.0116 7.62465 16.1562 7.36334L16.1572 7.36165L16.1619 7.35314L16.1831 7.3158C16.2023 7.28216 16.2316 7.23141 16.2704 7.16572C16.348 7.03429 16.4637 6.84337 16.6128 6.61022C16.9117 6.14303 17.3423 5.51091 17.8692 4.84998C18.951 3.493 20.3314 2.15328 21.7247 1.71575Z"
        fill="currentColor"
      />
      <path
        d="M11.4478 1.25L11.5 1.25C11.9142 1.25 12.25 1.58579 12.25 2C12.25 2.41421 11.9142 2.75 11.5 2.75C9.12385 2.75 7.40972 2.7513 6.10374 2.90932C4.81193 3.06563 4.03404 3.36443 3.46619 3.87549C2.90965 4.37637 2.59316 5.04626 2.42483 6.17309C2.25196 7.33029 2.25 8.8552 2.25 11C2.25 13.1448 2.25196 14.6697 2.42483 15.8269C2.59316 16.9537 2.90965 17.6236 3.46619 18.1245C4.03404 18.6356 4.81193 18.9344 6.10374 19.0907C7.40972 19.2487 9.12385 19.25 11.5 19.25C13.8762 19.25 15.5903 19.2487 16.8963 19.0907C18.1881 18.9344 18.966 18.6356 19.5338 18.1245C20.0903 17.6236 20.4068 16.9537 20.5752 15.8269C20.748 14.6697 20.75 13.1448 20.75 11V7.00081C20.75 6.5866 21.0858 6.25 21.5 6.25C21.9142 6.25 22.25 6.58582 22.25 7.00003V11.0625C22.25 13.1308 22.25 14.7678 22.0587 16.0485C21.8609 17.3725 21.4452 18.4223 20.5373 19.2395C19.6406 20.0464 18.5078 20.4066 17.0765 20.5798C15.6699 20.75 13.865 20.75 11.5522 20.75H11.4478C9.13498 20.75 7.33014 20.75 5.92355 20.5798C4.49222 20.4066 3.35936 20.0464 2.46274 19.2395C1.55481 18.4223 1.13908 17.3725 0.94129 16.0485C0.749966 14.7678 0.749981 13.1308 0.75 11.0625V10.9375C0.749981 8.86922 0.749966 7.23221 0.94129 5.95147C1.13908 4.62747 1.55481 3.57769 2.46274 2.76055C3.35936 1.95359 4.49222 1.59338 5.92355 1.42018C7.33014 1.24998 9.13499 1.24999 11.4478 1.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25018 8.5C5.25018 6.98122 6.4814 5.75 8.00018 5.75C9.51896 5.75 10.7502 6.98122 10.7502 8.5C10.7502 10.0188 9.51896 11.25 8.00018 11.25C6.4814 11.25 5.25018 10.0188 5.25018 8.5ZM8.00018 7.25C7.30982 7.25 6.75018 7.80964 6.75018 8.5C6.75018 9.19036 7.30982 9.75 8.00018 9.75C8.69053 9.75 9.25018 9.19036 9.25018 8.5C9.25018 7.80964 8.69053 7.25 8.00018 7.25Z"
        fill="currentColor"
      />
      <path
        d="M7.98143 14.2504C6.74064 14.2687 5.62793 14.8599 5.17943 15.818C5.00381 16.1931 4.55733 16.3549 4.18219 16.1793C3.80705 16.0036 3.64531 15.5572 3.82093 15.182C4.58074 13.559 6.32412 12.7747 7.95929 12.7506C9.60359 12.7263 11.3767 13.4673 12.1794 15.182C12.355 15.5572 12.1933 16.0036 11.8182 16.1793C11.443 16.3549 10.9965 16.1931 10.8209 15.818C10.3358 14.7818 9.2131 14.2322 7.98143 14.2504Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const PersonalPhoto = () => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 13.5C6.75 11.1528 8.65279 9.25 11 9.25C13.3472 9.25 15.25 11.1528 15.25 13.5C15.25 15.8472 13.3472 17.75 11 17.75C8.65279 17.75 6.75 15.8472 6.75 13.5ZM11 10.75C9.48122 10.75 8.25 11.9812 8.25 13.5C8.25 15.0188 9.48122 16.25 11 16.25C12.5188 16.25 13.75 15.0188 13.75 13.5C13.75 11.9812 12.5188 10.75 11 10.75Z"
        fill="currentColor"
      />
      <path
        d="M11 4.5C10.4477 4.5 10 4.94772 10 5.5C10 6.05229 10.4477 6.5 11 6.5H11.009C11.5613 6.5 12.009 6.05229 12.009 5.5C12.009 4.94772 11.5613 4.5 11.009 4.5H11Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0316 0.75H10.9688C10.3647 0.74999 9.86464 0.749982 9.45172 0.78515C9.01898 0.822007 8.62795 0.900686 8.25079 1.08742C7.57885 1.42009 7.15407 1.94877 6.85587 2.479C6.6247 2.89004 6.44527 3.3517 6.29315 3.74306C6.25724 3.83545 6.22286 3.92392 6.18967 4.00689L5.89243 4.75C4.80078 4.74998 4.0143 4.75095 3.40786 4.83452C2.72467 4.92866 2.23063 5.13092 1.71715 5.52493C1.45715 5.72443 1.22443 5.95715 1.02493 6.21715C0.598076 6.77343 0.417248 7.42195 0.332215 8.17622C0.249976 8.90571 0.249987 9.82039 0.250001 10.9548V15.5549C0.24998 16.9225 0.249964 18.0248 0.366525 18.8918C0.487541 19.7919 0.746435 20.5497 1.34835 21.1517C1.95027 21.7536 2.70814 22.0125 3.60825 22.1335C4.47522 22.25 5.57754 22.25 6.94513 22.25H15.0549C16.4225 22.25 17.5248 22.25 18.3918 22.1335C19.2919 22.0125 20.0497 21.7536 20.6517 21.1517C21.2536 20.5497 21.5125 19.7919 21.6335 18.8918C21.75 18.0248 21.75 16.9225 21.75 15.5549V10.9548C21.75 9.82039 21.75 8.90571 21.6678 8.17622C21.5828 7.42195 21.4019 6.77343 20.9751 6.21715C20.7756 5.95715 20.5429 5.72443 20.2829 5.52493C19.7694 5.13092 19.2753 4.92866 18.5921 4.83452C17.9858 4.75096 17.1994 4.74998 16.108 4.75L15.8107 4.00689C15.7775 3.92392 15.7432 3.83545 15.7072 3.74306C15.5551 3.3517 15.3757 2.89004 15.1445 2.479C14.8463 1.94877 14.4215 1.42008 13.7496 1.08742C13.3725 0.900686 12.9814 0.822007 12.5487 0.78515C12.1358 0.749982 11.6357 0.74999 11.0316 0.75ZM16.7076 6.25091C16.8407 6.62807 16.6535 7.04644 16.2787 7.19636C15.8942 7.35019 15.4577 7.16313 15.3038 6.77854L14.418 4.56397C14.373 4.45144 14.3307 4.34296 14.2898 4.23806C14.1412 3.85721 14.011 3.52349 13.8371 3.21429C13.6278 2.84209 13.3949 2.58557 13.0841 2.43169C12.937 2.35887 12.7505 2.30777 12.4214 2.27974C12.0796 2.25063 11.6436 2.25 11.0002 2.25C10.3568 2.25 9.92082 2.25063 9.57902 2.27974C9.2499 2.30777 9.06341 2.35887 8.91632 2.43169C8.6055 2.58557 8.37261 2.84209 8.16329 3.21429C7.9894 3.52348 7.85922 3.85719 7.71065 4.23804C7.66974 4.34291 7.62738 4.45148 7.58239 4.56398L6.69656 6.77854C6.54272 7.16313 6.10624 7.35019 5.72166 7.19636C5.34685 7.04644 5.15965 6.62807 5.29276 6.2509C4.5132 6.25388 4.0037 6.26659 3.61262 6.32048C3.17105 6.38132 2.92473 6.48903 2.63029 6.71496C2.47429 6.83466 2.33466 6.97429 2.21496 7.13029C2.02187 7.38193 1.89273 7.72376 1.82277 8.34426C1.75112 8.97987 1.75 9.80977 1.75 11V15.5C1.75 16.9354 1.75159 17.9365 1.85315 18.6919C1.9518 19.4257 2.13225 19.8142 2.40901 20.091C2.68577 20.3678 3.07435 20.5482 3.80812 20.6469C4.56347 20.7484 5.56459 20.75 7 20.75H15C16.4354 20.75 17.4365 20.7484 18.1919 20.6469C18.9257 20.5482 19.3142 20.3678 19.591 20.091C19.8678 19.8142 20.0482 19.4257 20.1469 18.6919C20.2484 17.9365 20.25 16.9354 20.25 15.5V11C20.25 9.80977 20.2489 8.97987 20.1772 8.34426C20.1073 7.72376 19.9781 7.38193 19.785 7.13029C19.6653 6.97429 19.5257 6.83466 19.3697 6.71496C19.0753 6.48903 18.829 6.38132 18.3874 6.32048C17.9964 6.2666 17.487 6.25388 16.7076 6.25091Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const CommercialRegistration = () => {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 11.1V17.1C25 23.1 22.6 25.5 16.6 25.5H9.4C3.4 25.5 1 23.1 1 17.1V9.9C1 3.9 3.4 1.5 9.4 1.5H15.4"
        stroke="#CCB16A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.0004 11.1H20.2004C16.6004 11.1 15.4004 9.9 15.4004 6.3V1.5L25.0004 11.1Z"
        stroke="#CCB16A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 14.6997H14.2"
        stroke="#CCB16A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 19.5H11.8"
        stroke="#CCB16A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AuthorizationLetter = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_15_6060)">
        <path
          d="M14.9602 0V2.00212H16.7785C17.5946 2.00212 18.449 2.9825 18.5189 3.76069C18.6082 4.75211 18.4627 5.81804 18.5463 6.81332L18.5192 7.57173H17.2167L17.178 7.53319V4.14503C17.178 3.82517 16.6573 3.33652 16.3398 3.33652H14.9599V5.33864H3.56028V3.33652H2.18043C1.82734 3.33652 1.32775 3.85395 1.34117 4.22107V21.7792C1.39198 22.2553 1.78401 22.6163 2.25677 22.6648H16.2634C16.623 22.6818 17.178 22.2062 17.178 21.8553V12.9104H18.5192C18.5677 13.2015 18.5156 13.4997 18.5182 13.797C18.537 16.0611 18.537 18.3325 18.5182 20.5967C18.5127 21.25 18.6244 22.1204 18.3907 22.7288C18.1189 23.4363 17.4344 23.9332 16.6761 23.9997H1.86964C0.890844 23.936 0.0954291 23.1566 0 22.1901V3.81053C0.0105746 2.9974 0.949907 2.00186 1.76776 2.00186H3.56028V0H14.9602ZM13.619 1.33466H4.95303V3.96545L4.99172 4.00398H13.619V1.33466Z"
          fill="#CCB16A"
        />
        <path
          d="M19.645 7.67627L20.5585 8.55902L20.5714 8.62376L11.6601 17.469L7.53397 13.3815C7.52314 13.3204 8.07044 12.8489 8.15194 12.7698C8.20481 12.7187 8.41244 12.4263 8.48672 12.46L11.6457 15.6048L19.645 7.67627Z"
          fill="#CCB16A"
        />
        <path
          d="M14.0445 8.67542C14.5502 8.67542 14.9602 9.08541 14.9602 9.59117V9.94416C14.9602 9.96169 14.9532 9.97849 14.9408 9.99086C14.9285 10.0032 14.9117 10.0101 14.8943 10.0101H3.62622C3.60878 10.0101 3.59205 10.0032 3.5797 9.99086C3.56728 9.97849 3.5603 9.96169 3.5603 9.94416V9.59117C3.5603 9.08541 3.9703 8.67542 4.47606 8.67542H14.0445Z"
          fill="#CCB16A"
        />
        <path
          d="M8.64126 17.0769C8.64126 17.5826 8.23126 17.9926 7.7255 17.9926H4.47606C3.9703 17.9926 3.5603 17.5826 3.5603 17.0769V16.7239C3.5603 16.7063 3.56728 16.6895 3.5797 16.6772C3.59205 16.6649 3.60878 16.658 3.62622 16.658H8.57535C8.59278 16.658 8.60951 16.6649 8.62186 16.6772C8.63428 16.6895 8.64126 16.7063 8.64126 16.7239V17.0769Z"
          fill="#CCB16A"
        />
        <path
          d="M3.5603 12.6794H6.08789L6.11368 13.9237C6.11651 13.9506 6.06132 14.0141 6.0492 14.0141H3.59899L3.5603 13.9756V12.6794Z"
          fill="#CCB16A"
        />
      </g>
      <defs>
        <clipPath id="clip0_15_6060">
          <rect width="20.5714" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Checked = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="97"
      height="96"
      viewBox="0 0 97 96"
      fill="currentColor"
      {...props}
    >
      <path
        d="M41.7042 60.2319C42.2522 60.7279 42.9643 60.996 43.7003 60.996C43.7723 60.996 43.8443 60.9922 43.9163 60.9882C44.7283 60.9282 45.4803 60.5441 46.0003 59.9241L62.8003 39.9241C63.8643 38.6561 63.7003 36.764 62.4323 35.696C61.1643 34.632 59.2682 34.796 58.2042 36.064L43.3923 53.696L38.5003 49.328C37.2643 48.224 35.3684 48.3319 34.2644 49.5679C33.1604 50.8039 33.2682 52.6998 34.5042 53.8038L41.7042 60.2319Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.3486 84.8006C40.7806 87.4165 44.1083 90.9961 48.5 90.9961C52.8917 90.9961 56.2195 87.4165 58.6514 84.8006L58.7142 84.7332C59.1312 84.2858 59.5257 83.8626 59.8801 83.5082C62.0921 81.3002 63.168 80.852 66.292 80.852C66.7519 80.852 67.2454 80.8669 67.7545 80.8824L67.808 80.884C71.084 80.98 75.568 81.1081 78.576 78.1281C81.608 75.1201 81.48 70.6042 81.384 67.3082L81.3824 67.2547C81.3669 66.7456 81.352 66.2521 81.352 65.7922C81.352 62.6682 81.8319 61.556 84.2199 59.168C88.9119 54.48 91.4961 51.892 91.4961 48C91.4961 44.1082 88.9122 41.5243 84.2206 36.8327C81.8366 34.4447 81.352 33.3322 81.352 30.2082C81.352 29.7483 81.3669 29.2548 81.3824 28.7457L81.384 28.6922C81.48 25.3922 81.608 20.8802 78.576 17.8682C75.568 14.8882 71.0879 15.0161 67.8119 15.1121L67.7364 15.1144C67.2318 15.1296 66.7492 15.1441 66.292 15.1441C63.556 15.1441 61.76 14.3682 59.668 12.2762C54.98 7.58417 52.392 5 48.5 5C44.6082 5 42.0243 7.5839 37.3328 12.2754C35.2408 14.3674 33.444 15.1441 30.708 15.1441C30.2473 15.1441 29.7609 15.1294 29.2557 15.114L29.192 15.1121C25.892 15.0161 21.38 14.8881 18.368 17.9201C15.388 20.9281 15.5159 25.4122 15.6119 28.6842L15.6142 28.7603C15.6294 29.2647 15.6439 29.7469 15.6439 30.2039C15.6439 32.9399 14.868 34.7361 12.776 36.8281C8.08398 41.5161 5.5 44.1041 5.5 47.9961C5.5 51.8881 8.08397 54.4721 12.776 59.164C15.16 61.552 15.6439 62.6643 15.6439 65.7883C15.6439 66.248 15.629 66.741 15.6136 67.2499L15.6119 67.3039C15.5159 70.5999 15.388 75.1161 18.424 78.1281C21.432 81.1081 25.916 80.98 29.192 80.884L29.2455 80.8824C29.7546 80.8669 30.2481 80.852 30.708 80.852C33.832 80.852 34.9119 81.2959 37.1199 83.5039C37.4919 83.8799 37.9086 84.3246 38.3486 84.8006ZM41.36 79.2602C38.016 75.9242 35.428 74.852 30.708 74.852L30.7 74.848C30.1878 74.848 29.6421 74.8629 29.0773 74.8783L28.9854 74.8808C26.674 74.9447 23.8155 75.0237 22.64 73.8602C21.456 72.6802 21.5359 69.792 21.6039 67.468L21.6057 67.4028C21.6211 66.838 21.6359 66.2924 21.6359 65.7801C21.6359 61.0601 20.448 58.36 17.008 54.916L16.9595 54.8675C13.5485 51.4525 11.492 49.3936 11.492 47.9883C11.492 46.5763 13.568 44.5002 17.008 41.0602C20.208 37.8642 21.6359 34.5121 21.6359 30.1961C21.6359 29.683 21.6213 29.1406 21.606 28.5759L21.6039 28.5C21.5359 26.192 21.452 23.3161 22.624 22.1361C23.804 20.9521 26.692 21.032 29.016 21.1L29.0812 21.1018C29.646 21.1172 30.1916 21.132 30.7039 21.132C35.0159 21.132 38.368 19.7041 41.568 16.5041C45.008 13.0641 47.0841 10.9881 48.4961 10.9881C49.908 10.9881 51.9838 13.0639 55.4234 16.5035C58.6194 19.7035 61.9721 21.132 66.2881 21.132C66.801 21.132 67.3431 21.1174 67.9076 21.1021L67.984 21.1C70.292 21.032 73.168 20.9481 74.348 22.1201C75.5321 23.3001 75.452 26.1881 75.384 28.5121L75.3822 28.5781C75.3668 29.1426 75.352 29.6879 75.352 30.2C75.352 34.92 76.5401 37.6201 79.9801 41.0641L80.0257 41.1098C83.4384 44.5264 85.4961 46.5864 85.4961 47.9922C85.4961 49.4042 83.4841 51.4199 79.9801 54.9199C76.4761 58.4199 75.352 61.06 75.352 65.784C75.352 66.2964 75.3668 66.8425 75.3822 67.4074L75.384 67.4723C75.452 69.7923 75.5321 72.6802 74.348 73.8602C73.168 75.0322 70.288 74.9481 67.976 74.8801L67.91 74.8783C67.3455 74.8629 66.8002 74.848 66.2881 74.848C61.5681 74.848 58.9799 75.9202 55.6359 79.2602C55.2138 79.6823 54.7882 80.1399 54.3389 80.623L54.2396 80.7297C52.5611 82.5322 50.2702 84.9922 48.5 84.9922C46.724 84.9922 44.4239 82.5201 42.7439 80.7121C42.6765 80.6401 42.6095 80.5686 42.5431 80.4976C42.1369 80.0636 41.7484 79.6486 41.36 79.2602Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Approval = () => {
  return (
    <svg
      width="211"
      height="186"
      viewBox="0 0 211 186"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M70.333 176.312C44.5383 176.312 30.3309 176.312 20.6601 167.803C10.9893 159.301 10.9893 146.762 10.9893 124V62C10.9893 39.2382 10.9893 26.7065 20.6601 18.197C30.3221 9.6875 44.5382 9.6875 70.3329 9.6875H96.708C122.503 9.6875 136.71 9.6875 146.381 18.197C156.052 26.6987 156.052 39.2382 156.052 62V69.75C156.052 72.9585 153.098 75.5625 149.458 75.5625C145.818 75.5625 142.864 72.9585 142.864 69.75V62C142.864 41.7129 142.864 31.5268 137.062 26.4276C131.251 21.3126 119.707 21.3125 96.708 21.3125H70.333C47.334 21.3125 35.7814 21.3126 29.9789 26.4276C24.1768 31.5345 24.1768 41.717 24.1768 61.9964V124C24.1768 144.287 24.1768 154.473 29.9789 159.572C35.7902 164.687 47.334 164.688 70.333 164.688C73.9728 164.688 76.9268 167.292 76.9268 170.5C76.9268 173.708 73.9728 176.312 70.333 176.312Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.148 176.312C96.8571 176.312 90.1143 170.368 90.1143 163.06C90.1143 153.326 97.5959 145.049 108.322 142.894L124.182 139.167L122.951 133.788C122.432 131.401 121.386 128.983 120.27 126.426C118.995 123.496 117.685 120.466 116.955 117.11L116.894 116.785C116.709 115.568 116.489 114.049 116.489 112.383C116.489 98.4946 129.308 87.1951 145.062 87.1951C160.817 87.1951 173.635 98.4946 173.635 112.383C173.635 114.165 173.477 115.723 173.16 117.157C172.439 120.474 171.13 123.504 169.855 126.434L169.804 126.55C168.715 129.065 167.684 131.445 167.191 133.734L165.942 139.175L181.803 142.902C192.528 145.057 200.01 153.334 200.01 163.068C200.01 170.376 193.267 176.32 184.977 176.32L105.148 176.312ZM132.737 149.188L111.32 154.209C106.599 155.132 103.302 158.774 103.302 163.06C103.302 163.959 104.128 164.688 105.148 164.688H184.977C185.997 164.688 186.823 163.959 186.823 163.06C186.823 158.774 183.526 155.132 178.804 154.209L178.532 154.147L157.388 149.18L132.737 149.188ZM137.272 137.562H152.861L154.25 131.487C154.961 128.202 156.271 125.189 157.536 122.276C158.653 119.711 159.71 117.281 160.211 114.94C160.369 114.22 160.448 113.398 160.448 112.383C160.448 104.904 153.546 98.8201 145.062 98.8201C136.578 98.8201 129.677 104.904 129.677 112.383C129.677 113.235 129.817 114.212 129.949 115.088C130.468 117.382 131.496 119.761 132.586 122.272L132.609 122.323C133.868 125.229 135.167 128.228 135.893 131.549L137.272 137.562Z"
        fill="currentColor"
      />
      <path
        d="M72.1884 83.3122H72.5309L72.5138 83.3198C74.826 83.3198 76.9794 82.2428 78.1751 80.4835C84.4875 71.168 98.1144 55.1797 107.82 51.9402C111.232 50.801 112.946 47.4453 111.654 44.446C110.361 41.439 106.555 39.9279 103.152 41.0671C91.3364 45.0119 79.4502 58.1091 72.5927 66.7659C67.6958 61.8601 63.168 61.3564 61.5328 61.3564C57.893 61.3564 54.939 63.9604 54.939 67.1689C54.939 70.1216 57.4268 72.5628 60.6622 72.9348C61.1985 73.1673 63.6517 74.4771 66.5442 79.9564C67.5816 81.9094 69.7531 83.2037 72.1884 83.3122Z"
        fill="currentColor"
      />
      <path
        d="M87.9163 114.312H52.7497C49.1099 114.312 46.1559 111.708 46.1559 108.5C46.1559 105.292 49.1099 102.688 52.7497 102.688H87.9163C91.5561 102.688 94.5101 105.292 94.5101 108.5C94.5101 111.708 91.5561 114.312 87.9163 114.312Z"
        fill="currentColor"
      />
      <path
        d="M52.7497 137.562H87.9163C91.5561 137.562 94.5101 134.958 94.5101 131.75C94.5101 128.542 91.5561 125.938 87.9163 125.938H52.7497C49.1099 125.938 46.1559 128.542 46.1559 131.75C46.1559 134.958 49.1099 137.562 52.7497 137.562Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ApprovedDoc = (props) => {
  return (
    <svg
      width="211"
      height="177"
      viewBox="0 0 211 177"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M135.135 170.156C121.223 170.156 113.56 170.156 108.345 164.804C103.129 159.456 103.129 151.568 103.129 137.25V98.25C103.129 83.9321 103.129 76.0492 108.345 70.6965C113.556 65.3438 121.223 65.3438 135.134 65.3438H149.359C163.271 65.3438 170.933 65.3438 176.149 70.6965C181.365 76.0444 181.365 83.9321 181.365 98.25V103.125C181.365 105.143 179.772 106.781 177.809 106.781C175.846 106.781 174.253 105.143 174.253 103.125V98.25C174.253 85.4888 174.253 79.0814 171.123 75.8738C167.989 72.6563 161.763 72.6562 149.359 72.6562H135.135C122.731 72.6562 116.5 72.6563 113.371 75.8738C110.241 79.0862 110.241 85.4914 110.241 98.2477V137.25C110.241 150.011 110.241 156.419 113.371 159.626C116.505 162.844 122.731 162.844 135.135 162.844C137.098 162.844 138.691 164.482 138.691 166.5C138.691 168.518 137.098 170.156 135.135 170.156Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M153.911 170.156C149.44 170.156 145.803 166.417 145.803 161.82C145.803 155.697 149.838 150.49 155.623 149.135L164.177 146.79L163.513 143.407C163.233 141.906 162.669 140.385 162.067 138.776C161.379 136.933 160.673 135.027 160.279 132.916L160.246 132.711C160.146 131.946 160.028 130.99 160.028 129.942C160.028 121.206 166.941 114.099 175.438 114.099C183.935 114.099 190.848 121.206 190.848 129.942C190.848 131.064 190.763 132.043 190.592 132.945C190.203 135.032 189.497 136.938 188.809 138.781L188.782 138.854C188.195 140.436 187.639 141.933 187.372 143.373L186.699 146.795L195.253 149.14C201.038 150.495 205.073 155.702 205.073 161.825C205.073 166.422 201.436 170.161 196.965 170.161L153.911 170.156ZM168.79 153.094L157.24 156.253C154.694 156.833 152.915 159.124 152.915 161.82C152.915 162.385 153.361 162.844 153.911 162.844H196.965C197.515 162.844 197.96 162.385 197.96 161.82C197.96 159.124 196.182 156.833 193.636 156.253L193.489 156.214L182.085 153.089L168.79 153.094ZM171.237 145.781H179.644L180.393 141.959C180.777 139.893 181.483 137.998 182.165 136.166C182.768 134.552 183.338 133.023 183.608 131.551C183.693 131.098 183.736 130.581 183.736 129.942C183.736 125.238 180.014 121.411 175.438 121.411C170.862 121.411 167.14 125.238 167.14 129.942C167.14 130.479 167.216 131.093 167.287 131.644C167.567 133.087 168.121 134.583 168.709 136.163L168.721 136.195C169.4 138.023 170.101 139.91 170.493 141.998L171.237 145.781Z"
        fill="currentColor"
      />
      <path
        d="M136.135 111.656H136.32L136.311 111.661C137.558 111.661 138.719 110.983 139.364 109.877C142.768 104.017 150.118 93.9598 155.352 91.9221C157.192 91.2054 158.117 89.0946 157.42 87.208C156.723 85.3165 154.67 84.3659 152.835 85.0825C146.462 87.5639 140.052 95.8025 136.353 101.248C133.712 98.162 131.27 97.8451 130.388 97.8451C128.425 97.8451 126.832 99.4831 126.832 101.501C126.832 103.359 128.174 104.894 129.919 105.128C130.208 105.275 131.531 106.099 133.091 109.545C133.651 110.774 134.822 111.588 136.135 111.656Z"
        fill="currentColor"
      />
      <path
        d="M144.618 131.156H125.651C123.688 131.156 122.095 129.518 122.095 127.5C122.095 125.482 123.688 123.844 125.651 123.844H144.618C146.581 123.844 148.174 125.482 148.174 127.5C148.174 129.518 146.581 131.156 144.618 131.156Z"
        fill="currentColor"
      />
      <path
        d="M125.651 145.781H144.618C146.581 145.781 148.174 144.143 148.174 142.125C148.174 140.107 146.581 138.469 144.618 138.469H125.651C123.688 138.469 122.095 140.107 122.095 142.125C122.095 144.143 123.688 145.781 125.651 145.781Z"
        fill="currentColor"
      />
      <path
        d="M48.843 74.1577C49.4926 74.7622 50.3367 75.0889 51.2091 75.0889C51.2945 75.0889 51.3799 75.0842 51.4652 75.0794C52.4278 75.0062 53.3191 74.5382 53.9356 73.7825L73.8502 49.4075C75.1114 47.8622 74.9171 45.5561 73.414 44.2545C71.9109 42.9578 69.6632 43.1576 68.402 44.703L50.844 66.192L45.0451 60.8685C43.58 59.523 41.3325 59.6545 40.0238 61.1609C38.7152 62.6672 38.843 64.9779 40.3082 66.3234L48.843 74.1577Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.8653 104.101C47.7481 107.289 51.6928 111.651 56.8987 111.651C62.1045 111.651 66.0493 107.289 68.9321 104.101L69.0065 104.019C69.5008 103.473 69.9684 102.958 70.3885 102.526C73.0106 99.8346 74.286 99.2883 77.9892 99.2883C78.5344 99.2883 79.1194 99.3066 79.7228 99.3254L79.7863 99.3274C83.6696 99.4444 88.9849 99.6005 92.5505 95.9687C96.1446 92.3027 95.9929 86.7989 95.8791 82.7819L95.8772 82.7167C95.8589 82.0962 95.8412 81.4947 95.8412 80.9342C95.8412 77.1269 96.4101 75.7713 99.2408 72.861C104.803 67.1475 107.866 63.9934 107.866 59.25C107.866 54.5069 104.803 51.3577 99.2417 45.6399C96.4157 42.7295 95.8412 41.3736 95.8412 37.5662C95.8412 37.0057 95.8589 36.4043 95.8772 35.7838L95.8791 35.7186C95.9929 31.6967 96.1446 26.1977 92.5505 22.5268C88.9849 18.895 83.6742 19.0509 79.7909 19.1679L79.7013 19.1707C79.1032 19.1892 78.5312 19.2069 77.9892 19.2069C74.7459 19.2069 72.617 18.2612 70.1371 15.7116C64.58 9.99321 61.5122 6.84375 56.8987 6.84375C52.2854 6.84375 49.2224 9.99288 43.6611 15.7107C41.1813 18.2603 39.0514 19.2069 35.8082 19.2069C35.2621 19.2069 34.6854 19.1889 34.0866 19.1702L34.0111 19.1679C30.0993 19.0509 24.7508 18.8949 21.1804 22.5901C17.6479 26.2561 17.7996 31.7211 17.9134 35.7088L17.9161 35.8017C17.9341 36.4163 17.9513 37.004 17.9513 37.561C17.9513 40.8955 17.0315 43.0847 14.5517 45.6343C8.98979 51.3478 5.92676 54.5019 5.92676 59.2452C5.92676 63.9886 8.98978 67.1378 14.5516 72.8562C17.3776 75.7665 17.9513 77.1221 17.9513 80.9295C17.9513 81.4898 17.9336 82.0906 17.9153 82.7108L17.9134 82.7766C17.7996 86.7936 17.648 92.2978 21.2468 95.9687C24.8125 99.6005 30.1277 99.4444 34.0111 99.3274L34.0745 99.3254C34.678 99.3066 35.263 99.2883 35.8082 99.2883C39.5113 99.2883 40.7915 99.8294 43.4088 102.52C43.8498 102.979 44.3437 103.521 44.8653 104.101ZM48.4349 97.3483C44.471 93.2826 41.4032 91.9758 35.8082 91.9758L35.7987 91.9711C35.1915 91.9711 34.5446 91.9892 33.8752 92.0079L33.7662 92.011C31.0263 92.0889 27.6379 92.1851 26.2444 90.7671C24.8409 89.3289 24.9356 85.809 25.0162 82.9766L25.0183 82.8971C25.0366 82.2088 25.0542 81.5439 25.0542 80.9195C25.0542 75.167 23.646 71.8763 19.5683 67.6789L19.5108 67.6198C15.4674 63.4578 13.0296 60.9485 13.0296 59.2357C13.0296 57.5148 15.4905 54.9846 19.5683 50.7921C23.3615 46.8969 25.0542 42.8116 25.0542 37.5515C25.0542 36.9262 25.0368 36.2651 25.0187 35.5768L25.0162 35.4844C24.9356 32.6715 24.8362 29.1665 26.2255 27.7284C27.6242 26.2854 31.0476 26.3827 33.8025 26.4656L33.8798 26.4678C34.5493 26.4865 35.196 26.5047 35.8033 26.5047C40.9147 26.5047 44.8882 24.7644 48.6815 20.8644C52.7592 16.6719 55.2203 14.1417 56.894 14.1417C58.5677 14.1417 61.0283 16.6716 65.1056 20.8636C68.8942 24.7636 72.8684 26.5047 77.9846 26.5047C78.5925 26.5047 79.2352 26.4868 79.9043 26.4681L79.9949 26.4656C82.7307 26.3827 86.14 26.2805 87.5388 27.7089C88.9423 29.147 88.8474 32.6668 88.7668 35.4991L88.7646 35.5796C88.7464 36.2675 88.7288 36.9322 88.7288 37.5563C88.7288 43.3088 90.1372 46.5995 94.215 50.7968L94.269 50.8525C98.3145 55.0166 100.754 57.5272 100.754 59.2405C100.754 60.9614 98.3686 63.418 94.215 67.6837C90.0613 71.9493 88.7288 75.1669 88.7288 80.9242C88.7288 81.5487 88.7464 82.2142 88.7647 82.9027L88.7668 82.9818C88.8474 85.8093 88.9423 89.3289 87.5388 90.7671C86.14 92.1954 82.726 92.093 79.9854 92.0101L79.9071 92.0079C79.238 91.9892 78.5916 91.9711 77.9846 91.9711C72.3895 91.9711 69.3215 93.2777 65.3576 97.3483C64.8572 97.8628 64.3527 98.4205 63.8201 99.0093L63.7024 99.1394C61.7127 101.336 58.9971 104.334 56.8987 104.334C54.7934 104.334 52.0669 101.321 50.0755 99.1179C49.9955 99.0302 49.9162 98.943 49.8374 98.8565C49.3559 98.3275 48.8954 97.8217 48.4349 97.3483Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Collapse = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 1V13M2.33333 1H11.6667C12.403 1 13 1.59695 13 2.33333V11.6667C13 12.403 12.403 13 11.6667 13H2.33333C1.59695 13 1 12.403 1 11.6667V2.33333C1 1.59695 1.59695 1 2.33333 1Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 1V13M2.33333 1H11.6667C12.403 1 13 1.59695 13 2.33333V11.6667C13 12.403 12.403 13 11.6667 13H2.33333C1.59695 13 1 12.403 1 11.6667V2.33333C1 1.59695 1.59695 1 2.33333 1Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const User = () => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0.25C7.1005 0.25 4.75 2.6005 4.75 5.5C4.75 8.39949 7.1005 10.75 10 10.75C12.8995 10.75 15.25 8.39949 15.25 5.5C15.25 2.6005 12.8995 0.25 10 0.25ZM6.25 5.5C6.25 3.42893 7.92893 1.75 10 1.75C12.0711 1.75 13.75 3.42893 13.75 5.5C13.75 7.57107 12.0711 9.25 10 9.25C7.92893 9.25 6.25 7.57107 6.25 5.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2288 14.0792C16.0662 13.9874 15.9226 13.9064 15.8063 13.8372C12.2523 11.7209 7.74809 11.7209 4.19404 13.8372C4.07773 13.9064 3.93405 13.9875 3.77139 14.0793C3.05857 14.4814 1.98106 15.0893 1.2429 15.8118C0.781228 16.2637 0.342574 16.8592 0.262828 17.5888C0.178022 18.3646 0.516485 19.0927 1.1955 19.7396C2.36695 20.8556 3.77274 21.75 5.59104 21.75H14.4093C16.2276 21.75 17.6334 20.8556 18.8048 19.7396C19.4839 19.0927 19.8223 18.3646 19.7375 17.5888C19.6578 16.8592 19.2191 16.2637 18.7575 15.8118C18.0193 15.0893 16.9417 14.4813 16.2288 14.0792ZM4.96146 15.126C8.04264 13.2913 11.9577 13.2913 15.0389 15.126C15.2068 15.226 15.3907 15.3303 15.5834 15.4397C16.296 15.8439 17.1281 16.316 17.7082 16.8838C18.0683 17.2363 18.2218 17.5271 18.2464 17.7517C18.2659 17.9301 18.2208 18.2242 17.7702 18.6535C16.7343 19.6404 15.6818 20.25 14.4093 20.25H5.59104C4.3186 20.25 3.26602 19.6404 2.23017 18.6535C1.77954 18.2242 1.73445 17.9301 1.75395 17.7517C1.77851 17.5271 1.93202 17.2363 2.29214 16.8838C2.87223 16.316 3.70426 15.844 4.41686 15.4397C4.60953 15.3304 4.7936 15.226 4.96146 15.126Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Dashboard = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2781 12.1951C15.7898 13.3498 15.0262 14.3672 14.0539 15.1586C13.0815 15.9499 11.9302 16.491 10.7004 16.7345C9.4707 16.9781 8.20002 16.9167 6.99948 16.5557C5.79894 16.1948 4.70511 15.5452 3.81361 14.6638C2.92211 13.7824 2.26009 12.6961 1.88543 11.4998C1.51077 10.3034 1.43487 9.03352 1.66437 7.80107C1.89387 6.56863 2.42179 5.41116 3.20196 4.42988C3.98213 3.44859 4.99081 2.67336 6.1398 2.17196M16.1169 9.20966C16.5406 9.20966 16.8882 8.86507 16.846 8.44372C16.6691 6.68174 15.8883 5.03516 14.6359 3.78312C13.3836 2.53109 11.7369 1.75064 9.97485 1.5741C9.55274 1.53189 9.20892 1.87955 9.20892 2.30319V8.44296C9.20892 8.6465 9.28977 8.84171 9.4337 8.98564C9.57763 9.12957 9.77284 9.21043 9.97639 9.21043L16.1169 9.20966Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Users = () => {
  return (
    <svg
      width="21"
      height="16"
      viewBox="0 0 21 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0714 0.128967C8.05953 0.128967 6.42857 1.75993 6.42857 3.77182C6.42857 5.78372 8.05953 7.41468 10.0714 7.41468C12.0833 7.41468 13.7143 5.78372 13.7143 3.77182C13.7143 1.75993 12.0833 0.128967 10.0714 0.128967ZM7.71429 3.77182C7.71429 2.47001 8.76961 1.41468 10.0714 1.41468C11.3732 1.41468 12.4286 2.47001 12.4286 3.77182C12.4286 5.07364 11.3732 6.12897 10.0714 6.12897C8.76961 6.12897 7.71429 5.07364 7.71429 3.77182Z"
        fill="currentColor"
      />
      <path
        d="M4.50004 1.84325C2.96153 1.84325 1.71432 3.09046 1.71432 4.62897C1.71432 6.16748 2.96153 7.41468 4.50004 7.41468C4.85508 7.41468 5.14289 7.12686 5.14289 6.77182C5.14289 6.41678 4.85508 6.12897 4.50004 6.12897C3.67161 6.12897 3.00004 5.45739 3.00004 4.62897C3.00004 3.80054 3.67161 3.12897 4.50004 3.12897C4.85508 3.12897 5.14289 2.84115 5.14289 2.48611C5.14289 2.13107 4.85508 1.84325 4.50004 1.84325Z"
        fill="currentColor"
      />
      <path
        d="M4.71171 8.42819C4.67972 8.07459 4.36714 7.81388 4.01354 7.84587C3.20909 7.91864 2.42691 8.22813 1.73751 8.759C1.69779 8.78959 1.64547 8.82765 1.58399 8.87238C1.29197 9.08482 0.793367 9.44755 0.457358 9.87289C0.242659 10.1447 0.041882 10.5003 0.00573388 10.928C-0.0321233 11.3759 0.118027 11.811 0.439933 12.2076C0.932665 12.8147 1.60878 13.4147 2.55086 13.4147C2.9059 13.4147 3.19372 13.1269 3.19372 12.7718C3.19372 12.4168 2.9059 12.129 2.55086 12.129C2.20842 12.129 1.86284 11.9206 1.43822 11.3974C1.29064 11.2156 1.28139 11.1013 1.28688 11.0363C1.29408 10.9511 1.33941 10.8304 1.46625 10.6699C1.67988 10.3995 1.97936 10.1793 2.27045 9.9654C2.35579 9.90267 2.44042 9.84046 2.52195 9.77768C3.02798 9.38801 3.58055 9.17601 4.12939 9.12635C4.48298 9.09436 4.7437 8.78179 4.71171 8.42819Z"
        fill="currentColor"
      />
      <path
        d="M15.2143 1.84325C14.8592 1.84325 14.5714 2.13107 14.5714 2.48611C14.5714 2.84115 14.8592 3.12897 15.2143 3.12897C16.0427 3.12897 16.7143 3.80054 16.7143 4.62897C16.7143 5.45739 16.0427 6.12897 15.2143 6.12897C14.8592 6.12897 14.5714 6.41678 14.5714 6.77182C14.5714 7.12686 14.8592 7.41468 15.2143 7.41468C16.7528 7.41468 18 6.16748 18 4.62897C18 3.09046 16.7528 1.84325 15.2143 1.84325Z"
        fill="currentColor"
      />
      <path
        d="M16.1294 7.84587C15.7758 7.81388 15.4632 8.07459 15.4312 8.42819C15.3992 8.78179 15.6599 9.09436 16.0135 9.12635C16.5623 9.17601 17.1149 9.38801 17.6209 9.77768C17.7025 9.84045 17.7871 9.90264 17.8724 9.96536C18.1635 10.1793 18.463 10.3995 18.6766 10.6699C18.8035 10.8304 18.8488 10.9511 18.856 11.0363C18.8615 11.1013 18.8523 11.2156 18.7047 11.3974C18.2801 11.9206 17.9345 12.129 17.592 12.129C17.237 12.129 16.9492 12.4168 16.9492 12.7718C16.9492 13.1269 17.237 13.4147 17.592 13.4147C18.5341 13.4147 19.2102 12.8147 19.703 12.2076C20.0249 11.811 20.175 11.3759 20.1372 10.928C20.101 10.5003 19.9002 10.1447 19.6855 9.87289C19.3495 9.44755 18.851 9.08489 18.559 8.87245C18.4975 8.82772 18.4451 8.78958 18.4054 8.759C17.716 8.22813 16.9338 7.91864 16.1294 7.84587Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.37672 9.74893C8.63767 8.35089 11.5054 8.35089 13.7664 9.74893C13.833 9.79014 13.9174 9.83952 14.0144 9.89626C14.4535 10.1532 15.1506 10.5611 15.6262 11.0446C15.925 11.3482 16.2229 11.7622 16.2772 12.2783C16.3353 12.8304 16.101 13.3415 15.6539 13.7838C14.9154 14.5144 14.0006 15.129 12.801 15.129H7.34209C6.14256 15.129 5.2277 14.5144 4.48917 13.7838C4.04211 13.3415 3.80777 12.8304 3.86588 12.2783C3.92021 11.7622 4.21815 11.3482 4.51688 11.0446C4.99252 10.5611 5.68953 10.1533 6.12862 9.89632C6.22564 9.83955 6.31006 9.79015 6.37672 9.74893ZM13.0902 10.8425C11.2436 9.70066 8.89948 9.70066 7.05291 10.8425C6.94206 10.911 6.82321 10.9811 6.70058 11.0534C6.26183 11.3121 5.77474 11.5993 5.43341 11.9463C5.22342 12.1597 5.15478 12.3155 5.14453 12.4129C5.13808 12.4742 5.14118 12.6202 5.39343 12.8698C6.02131 13.491 6.6283 13.8433 7.34209 13.8433H12.801C13.5148 13.8433 14.1218 13.491 14.7497 12.8698C15.0019 12.6202 15.005 12.4742 14.9986 12.4129C14.9883 12.3155 14.9197 12.1597 14.7097 11.9463C14.3684 11.5993 13.8813 11.3121 13.4426 11.0534C13.3199 10.9811 13.2011 10.911 13.0902 10.8425Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Admin = (props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width="22"
      height="22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#000000"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#CCCCCC"
        strokeWidth="0.048"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M15.6311 7.15517C15.9018 7.05482 16.1945 7 16.5001 7C17.8808 7 19.0001 8.11929 19.0001 9.5C19.0001 10.8807 17.8808 12 16.5001 12C16.1945 12 15.9018 11.9452 15.6311 11.8448"
          stroke="#323232"
          strokeWidth="2"
          strokeLinecap="round"
        ></path>{" "}
        <path
          d="M3 19C3.69137 16.6928 5.46998 16 9.5 16C13.53 16 15.3086 16.6928 16 19"
          stroke="#323232"
          strokeWidth="2"
          strokeLinecap="round"
        ></path>{" "}
        <path
          d="M17 15C19.403 15.095 20.5292 15.6383 21 17"
          stroke="#323232"
          strokeWidth="2"
          strokeLinecap="round"
        ></path>{" "}
        <path
          d="M13 9.5C13 11.433 11.433 13 9.5 13C7.567 13 6 11.433 6 9.5C6 7.567 7.567 6 9.5 6C11.433 6 13 7.567 13 9.5Z"
          stroke="#323232"
          strokeWidth="2"
        ></path>{" "}
      </g>
    </svg>
  );
};
export const Contracts = () => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7445 2.37354V5.44342C10.7445 5.85051 10.9062 6.24093 11.1941 6.52878C11.482 6.81664 11.8724 6.97836 12.2795 6.97836H15.3494M7.67465 7.74583H6.13971M12.2795 10.8157H6.13971M12.2795 13.8856H6.13971M11.512 2.37354H4.60477C4.19767 2.37354 3.80726 2.53525 3.5194 2.82311C3.23154 3.11097 3.06982 3.50138 3.06982 3.90848V16.188C3.06982 16.5951 3.23154 16.9855 3.5194 17.2734C3.80726 17.5612 4.19767 17.7229 4.60477 17.7229H13.8144C14.2215 17.7229 14.6119 17.5612 14.8998 17.2734C15.1876 16.9855 15.3494 16.5951 15.3494 16.188V6.21089L11.512 2.37354Z"
        stroke="currentColor"
        strokeWidth="1.53494"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7445 2.37354V5.44342C10.7445 5.85051 10.9062 6.24093 11.1941 6.52878C11.482 6.81664 11.8724 6.97836 12.2795 6.97836H15.3494M7.67465 7.74583H6.13971M12.2795 10.8157H6.13971M12.2795 13.8856H6.13971M11.512 2.37354H4.60477C4.19767 2.37354 3.80726 2.53525 3.5194 2.82311C3.23154 3.11097 3.06982 3.50138 3.06982 3.90848V16.188C3.06982 16.5951 3.23154 16.9855 3.5194 17.2734C3.80726 17.5612 4.19767 17.7229 4.60477 17.7229H13.8144C14.2215 17.7229 14.6119 17.5612 14.8998 17.2734C15.1876 16.9855 15.3494 16.5951 15.3494 16.188V6.21089L11.512 2.37354Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.53494"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const MetalStonePools = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.75 0.257874C8.23122 0.257874 7 1.48909 7 3.00787C7 4.52666 8.23122 5.75787 9.75 5.75787C11.2688 5.75787 12.5 4.52666 12.5 3.00787C12.5 1.48909 11.2688 0.257874 9.75 0.257874ZM8.5 3.00787C8.5 2.31752 9.05964 1.75787 9.75 1.75787C10.4404 1.75787 11 2.31752 11 3.00787C11 3.69823 10.4404 4.25787 9.75 4.25787C9.05964 4.25787 8.5 3.69823 8.5 3.00787Z"
        fill="black"
      />
      <path
        d="M13.132 9.4328C11.5645 7.15224 7.91795 7.24506 6.36207 9.4415C6.12264 9.7795 5.65454 9.85941 5.31653 9.61998C4.97853 9.38055 4.89862 8.91245 5.13805 8.57445C7.25909 5.58017 12.1731 5.38963 14.3681 8.58315C14.6028 8.9245 14.5162 9.39143 14.1749 9.62605C13.8335 9.86068 13.3666 9.77415 13.132 9.4328Z"
        fill="black"
      />
      <path
        d="M8.75 13.2579C8.33579 13.2579 8 13.5937 8 14.0079C8 14.4221 8.33579 14.7579 8.75 14.7579H10.75C11.1642 14.7579 11.5 14.4221 11.5 14.0079C11.5 13.5937 11.1642 13.2579 10.75 13.2579H8.75Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.41302 10.2579H13.087C13.8395 10.2579 14.4592 10.2578 14.9537 10.3064C15.4638 10.3566 15.9382 10.4653 16.351 10.7509C16.7948 11.0579 17.1391 11.4879 17.3401 11.9884C17.5275 12.455 17.5259 12.9411 17.4585 13.4467C17.3932 13.936 17.2517 14.5348 17.0801 15.2604L17.0638 15.3293C16.8935 16.05 16.7551 16.6354 16.6021 17.1054C16.4605 17.5403 16.2935 17.9197 16.0444 18.2579H18.75C19.1642 18.2579 19.5 18.5937 19.5 19.0079C19.5 19.4221 19.1642 19.7579 18.75 19.7579H0.75C0.335786 19.7579 0 19.4221 0 19.0079C0 18.5937 0.335786 18.2579 0.75 18.2579H3.45565C3.20652 17.9197 3.03955 17.5403 2.89799 17.1054C2.74496 16.6354 2.60658 16.05 2.43624 15.3294L2.41997 15.2605C2.24842 14.5349 2.10683 13.936 2.04159 13.4467C1.97418 12.9411 1.97255 12.455 2.15997 11.9884C2.36099 11.4879 2.70522 11.0579 3.14905 10.7509C3.56181 10.4653 4.03623 10.3566 4.54641 10.3064C5.04088 10.2578 5.66061 10.2579 6.41302 10.2579ZM13.1603 18.2225C12.7325 18.2573 12.1879 18.2579 11.4021 18.2579H8.09793C7.31219 18.2579 6.76756 18.2573 6.33979 18.2225C5.92291 18.1885 5.67435 18.1253 5.4759 18.0294C5.17861 17.8857 4.91695 17.6799 4.7088 17.4266C4.57044 17.2583 4.45236 17.0345 4.32432 16.6411C4.19276 16.237 4.06809 15.7122 3.88873 14.9535C3.70594 14.1803 3.58258 13.6546 3.52843 13.2484C3.47531 12.85 3.50467 12.665 3.55188 12.5475C3.64281 12.3211 3.79911 12.1251 4.00242 11.9845C4.10977 11.9102 4.28802 11.8391 4.69311 11.7993C5.10547 11.7587 5.65095 11.7579 6.45157 11.7579H13.0485C13.8491 11.7579 14.3946 11.7587 14.8069 11.7993C15.212 11.8391 15.3903 11.9102 15.4976 11.9845C15.7009 12.1251 15.8572 12.3211 15.9482 12.5475C15.9954 12.665 16.0247 12.85 15.9716 13.2484C15.9175 13.6546 15.7941 14.1803 15.6113 14.9535C15.432 15.7122 15.3073 16.237 15.1757 16.6411C15.0477 17.0345 14.9296 17.2583 14.7913 17.4266C14.5831 17.6799 14.3214 17.8857 14.0242 18.0294C13.8257 18.1253 13.5771 18.1885 13.1603 18.2225Z"
        fill="black"
      />
    </svg>
  );
};
export const PurchaseManagement = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.6665 5.79956C5.32133 5.79956 5.0415 6.07938 5.0415 6.42456C5.0415 6.76974 5.32133 7.04956 5.6665 7.04956H7.33317C7.67835 7.04956 7.95817 6.76974 7.95817 6.42456C7.95817 6.07938 7.67835 5.79956 7.33317 5.79956H5.6665Z"
        fill="currentColor"
      />
      <path
        d="M5.97982 13.9946C6.17129 13.7074 6.55934 13.6298 6.84654 13.8213L7.67667 14.3747C7.84778 14.4888 8.04883 14.5496 8.25448 14.5496H9.74523C9.95088 14.5496 10.1519 14.4888 10.323 14.3747L11.1532 13.8213C11.4404 13.6298 11.8284 13.7074 12.0199 13.9946C12.2114 14.2818 12.1337 14.6699 11.8465 14.8613L11.0164 15.4147C10.64 15.6657 10.1977 15.7996 9.74523 15.7996H8.25448C7.80205 15.7996 7.35974 15.6657 6.98329 15.4147L6.15317 14.8613C5.86596 14.6699 5.78835 14.2818 5.97982 13.9946Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.58317 0.799561C8.23799 0.799561 7.95817 1.07938 7.95817 1.42456C7.95817 1.76974 8.23799 2.04956 8.58317 2.04956L10.0415 2.04956V3.29956L7.59897 3.29956C6.57096 3.29955 5.73946 3.29953 5.07849 3.38428C4.39074 3.47247 3.8064 3.66068 3.31999 4.09604C2.83358 4.53139 2.58199 5.09138 2.41839 5.76518C2.26117 6.41275 2.16936 7.23917 2.05585 8.26089L1.73414 11.1563C1.60967 11.2149 1.48975 11.2837 1.37408 11.3647C1.07547 11.5738 0.815746 11.8335 0.606656 12.1321C0.294903 12.5774 0.163408 13.0856 0.101465 13.6733C0.0414888 14.2423 0.0414959 14.9528 0.0415048 15.8339L0.0415048 15.9005C0.0414868 16.329 0.0414713 16.6986 0.0732075 16.9996C0.106893 17.3192 0.181874 17.6329 0.380597 17.9167C0.50605 18.0958 0.661883 18.2517 0.841051 18.3771C1.12486 18.5759 1.43852 18.6508 1.7581 18.6845C2.05919 18.7163 2.4287 18.7162 2.85721 18.7162L15.1425 18.7162C15.571 18.7162 15.9405 18.7163 16.2416 18.6845C16.5612 18.6508 16.8748 18.5759 17.1586 18.3771C17.3378 18.2517 17.4936 18.0959 17.6191 17.9167C17.8178 17.6329 17.8928 17.3192 17.9265 16.9996C17.9582 16.6986 17.9582 16.3291 17.9582 15.9006V15.834C17.9582 14.9528 17.9582 14.2423 17.8982 13.6733C17.8363 13.0856 17.7048 12.5774 17.393 12.1321C17.1839 11.8335 16.9242 11.5738 16.6256 11.3647C16.5099 11.2837 16.39 11.2149 16.2655 11.1563L15.9438 8.26093C15.8303 7.23919 15.7385 6.41276 15.5813 5.76518C15.4177 5.09138 15.1661 4.53139 14.6797 4.09604C14.1933 3.66068 13.6089 3.47247 12.9212 3.38428C12.4629 3.32551 11.9225 3.3075 11.2915 3.30199V2.04956L12.7498 2.04956C13.095 2.04956 13.3748 1.76974 13.3748 1.42456C13.3748 1.07938 13.095 0.799561 12.7498 0.799561L8.58317 0.799561ZM14.7062 8.44142L14.9737 10.8487C14.424 10.7995 13.7486 10.7996 12.9238 10.7996L5.07593 10.7996C4.25107 10.7996 3.5757 10.7995 3.026 10.8487L3.29348 8.44142C3.41285 7.3671 3.49699 6.62071 3.6331 6.06011C3.76502 5.51679 3.92815 5.22927 4.15364 5.02745C4.37913 4.82562 4.6829 4.69524 5.23747 4.62413C5.80967 4.55076 6.56079 4.54956 7.64172 4.54956L10.358 4.54956C11.4389 4.54956 12.19 4.55076 12.7622 4.62413C13.3168 4.69524 13.6206 4.82562 13.846 5.02745C14.0715 5.22927 14.2347 5.51679 14.3666 6.06011C14.5027 6.62071 14.5868 7.3671 14.7062 8.44142ZM3.04624 12.1026C2.56157 12.1537 2.29152 12.2483 2.09105 12.3887C1.91188 12.5141 1.75605 12.6699 1.6306 12.8491C1.49023 13.0496 1.39567 13.3196 1.34458 13.8043C1.29232 14.3001 1.29151 14.9446 1.29151 15.869C1.29151 16.338 1.29232 16.6409 1.31632 16.8686C1.33915 17.0852 1.3772 17.1607 1.40454 17.1997C1.44636 17.2594 1.4983 17.3114 1.55802 17.3532C1.59706 17.3805 1.67254 17.4186 1.88913 17.4414C2.11684 17.4654 2.41977 17.4662 2.88873 17.4662L15.1109 17.4662C15.5799 17.4662 15.8828 17.4654 16.1105 17.4414C16.3271 17.4186 16.4026 17.3805 16.4417 17.3532C16.5014 17.3114 16.5533 17.2594 16.5951 17.1997C16.6225 17.1607 16.6605 17.0852 16.6834 16.8686C16.7074 16.6409 16.7082 16.338 16.7082 15.869C16.7082 14.9446 16.7074 14.3001 16.6551 13.8043C16.604 13.3196 16.5094 13.0496 16.3691 12.8491C16.2436 12.6699 16.0878 12.5141 15.9086 12.3887C15.7082 12.2483 15.4381 12.1537 14.9534 12.1026C14.4576 12.0504 13.8131 12.0496 12.8887 12.0496L5.11095 12.0496C4.18654 12.0496 3.54203 12.0504 3.04624 12.1026Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ManufactureManagement = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.58331 4.79948C3.23813 4.79948 2.95831 5.0793 2.95831 5.42448C2.95831 10.1203 2.21311 13.276 1.10827 15.6328H0.666504C0.321326 15.6328 0.0415039 15.9126 0.0415039 16.2578C0.0415039 16.603 0.321326 16.8828 0.666504 16.8828H1.48644C1.49515 16.883 1.50385 16.883 1.51254 16.8828H11.4874C11.4961 16.883 11.5048 16.883 11.5135 16.8828H16.4998C16.845 16.8828 17.1248 16.603 17.1248 16.2578C17.1248 15.9126 16.845 15.6328 16.4998 15.6328H15.8266C14.553 14.1883 13.955 12.8582 13.6566 11.7209C13.4114 10.7864 13.3656 9.98632 13.3255 9.2871C13.3153 9.10824 13.3054 8.93571 13.2927 8.76948C13.2677 8.44378 12.9961 8.19222 12.6695 8.19222H10.1371C10.0747 7.33328 10.0416 6.413 10.0416 5.42448C10.0416 5.0793 9.76182 4.79948 9.41664 4.79948H3.58331ZM14.2161 15.6328H11.8917C11.1364 14.0216 10.5491 12.037 10.2532 9.44222H12.0815C12.1209 10.1312 12.1839 11.0333 12.4475 12.0381C12.7335 13.1279 13.2526 14.3442 14.2161 15.6328ZM10.5223 15.6328H2.47761C3.49101 13.26 4.14487 10.2294 4.20394 6.04948H8.79601C8.85508 10.2294 9.50894 13.26 10.5223 15.6328Z"
        fill="currentColor"
      />
      <path
        d="M14.66 2.64088C15.0757 2.05074 15.4615 1.88281 15.7358 1.88281C16.0114 1.88281 16.4014 2.05226 16.8248 2.64444C17.0256 2.92523 17.4159 2.99011 17.6967 2.78936C17.9775 2.5886 18.0424 2.19823 17.8416 1.91743C17.2897 1.14545 16.5681 0.632813 15.7358 0.632812C14.9031 0.632812 14.1851 1.14572 13.6401 1.91817C13.3995 2.25155 13.219 2.29794 13.1541 2.29943C13.1009 2.30064 12.9363 2.27509 12.7098 1.95266L12.7068 1.94843C12.1546 1.17612 11.433 0.663813 10.5991 0.663813C9.76529 0.663813 9.04365 1.17612 8.49147 1.94843C8.29071 2.22923 8.35559 2.6196 8.63638 2.82036C8.91718 3.02111 9.30755 2.95623 9.50831 2.67544C9.93146 2.08359 10.3214 1.91381 10.5991 1.91381C10.8766 1.91381 11.266 2.08323 11.6886 2.67355C12.0501 3.18702 12.5591 3.56336 13.1826 3.5491C13.7952 3.53509 14.2954 3.14764 14.6563 2.64601L14.66 2.64088Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Settings = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.99984 5.21634C7.04383 5.21634 5.45817 6.802 5.45817 8.75801C5.45817 10.714 7.04383 12.2997 8.99984 12.2997C10.9558 12.2997 12.5415 10.714 12.5415 8.75801C12.5415 6.802 10.9558 5.21634 8.99984 5.21634ZM6.70817 8.75801C6.70817 7.49235 7.73418 6.46634 8.99984 6.46634C10.2655 6.46634 11.2915 7.49235 11.2915 8.75801C11.2915 10.0237 10.2655 11.0497 8.99984 11.0497C7.73418 11.0497 6.70817 10.0237 6.70817 8.75801Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25157 0.381892C6.01457 0.349964 5.81477 0.418938 5.67875 0.478655C5.5537 0.533554 5.41263 0.613692 5.27578 0.691435L3.79689 1.5311C3.65717 1.61039 3.51402 1.69163 3.40148 1.77173C3.27997 1.85821 3.11578 1.99588 3.02154 2.21866C2.91866 2.46188 2.95185 2.70701 2.97629 2.84879C3.00274 3.00222 3.05163 3.19044 3.10413 3.39258L3.11011 3.4156C3.44031 4.6873 2.63372 6.05534 1.32799 6.40741L1.30499 6.41361C1.10744 6.46685 0.922331 6.51674 0.77756 6.56926C0.642122 6.61838 0.415773 6.7106 0.256271 6.91881C0.109688 7.11015 0.0708323 7.31984 0.0555405 7.46825C0.0414348 7.60515 0.0414717 7.76891 0.0415075 7.92823V9.58757C0.0414717 9.74689 0.0414348 9.91064 0.0555394 10.0475C0.0708298 10.1959 0.109682 10.4056 0.256254 10.597C0.415748 10.8052 0.642095 10.8974 0.777524 10.9465C0.92229 10.999 1.10739 11.0489 1.30494 11.1022L1.32795 11.1084C2.63319 11.4604 3.43926 12.8282 3.10886 14.1001L3.10288 14.1231C3.05035 14.3252 3.00144 14.5134 2.97498 14.6668C2.95052 14.8086 2.91731 15.0538 3.02018 15.297C3.11442 15.5198 3.27861 15.6575 3.40013 15.744C3.51269 15.8241 3.65587 15.9053 3.79561 15.9846L5.27444 16.8243C5.41129 16.902 5.55242 16.9822 5.67746 17.0371C5.8135 17.0968 6.01332 17.1658 6.25033 17.1338C6.50798 17.0991 6.69896 16.9512 6.80877 16.8588C6.92538 16.7607 7.05935 16.627 7.20181 16.4848L7.21858 16.468C8.19131 15.4974 9.80972 15.4973 10.7824 16.468L10.7992 16.4847C10.9417 16.6269 11.0757 16.7606 11.1922 16.8587C11.3021 16.9511 11.493 17.099 11.7507 17.1337C11.9877 17.1657 12.1875 17.0967 12.3236 17.037C12.4486 16.9821 12.5897 16.902 12.7265 16.8242L14.2055 15.9845C14.3452 15.9052 14.4884 15.824 14.6009 15.7439C14.7224 15.6574 14.8866 15.5197 14.9809 15.2968C15.0837 15.0536 15.0505 14.8085 15.026 14.6667C14.9996 14.5133 14.9506 14.3251 14.8981 14.1231L14.8921 14.0999C14.5615 12.8279 15.367 11.4604 16.6718 11.1084L16.6947 11.1022C16.8923 11.0489 17.0774 10.999 17.2222 10.9465C17.3576 10.8974 17.584 10.8051 17.7435 10.5969C17.89 10.4056 17.9289 10.1959 17.9442 10.0475C17.9583 9.91062 17.9582 9.74688 17.9582 9.58757V7.92824C17.9582 7.76892 17.9583 7.60517 17.9442 7.46827C17.9289 7.31986 17.89 7.11018 17.7434 6.91884C17.5839 6.71064 17.3576 6.61841 17.2222 6.56928C17.0774 6.51676 16.8923 6.46686 16.6947 6.4136L16.6717 6.4074C15.3665 6.05539 14.5604 4.68759 14.8908 3.41574L14.8968 3.39275C14.9493 3.19063 14.9983 3.00239 15.0247 2.84897C15.0492 2.70717 15.0824 2.46204 14.9795 2.21881C14.8853 1.996 14.7211 1.85832 14.5996 1.77182C14.487 1.69172 14.3439 1.61048 14.2041 1.53119L12.7252 0.691526C12.5884 0.61378 12.4473 0.533637 12.3223 0.478737C12.1862 0.41902 11.9864 0.350046 11.7494 0.381972C11.4918 0.416679 11.3008 0.564612 11.191 0.656975C11.0744 0.755045 10.9404 0.888733 10.7979 1.0309L10.7811 1.04767C9.80906 2.01741 8.19197 2.01738 7.21988 1.0476L7.20308 1.03084C7.0606 0.888668 6.92661 0.754974 6.81001 0.6569C6.7002 0.564535 6.50921 0.416601 6.25157 0.381892ZM5.87221 1.79023C5.95131 1.74532 6.01345 1.71007 6.06737 1.68082L6.07572 1.6763C6.13865 1.73499 6.22054 1.8163 6.33704 1.93253C7.79702 3.38904 10.2039 3.38912 11.664 1.93261C11.7805 1.81638 11.8624 1.73507 11.9253 1.67638L11.9336 1.6809C11.9876 1.71015 12.0497 1.7454 12.1288 1.79031L13.566 2.60633C13.6466 2.65208 13.7101 2.68813 13.764 2.72012L13.7748 2.72657C13.7551 2.81501 13.7248 2.93294 13.681 3.10144C13.1725 5.05898 14.4009 7.08964 16.3463 7.61428C16.5088 7.65812 16.6227 7.68911 16.7067 7.7149L16.707 7.72579C16.7082 7.78791 16.7082 7.86025 16.7082 7.95222V9.56358C16.7082 9.65555 16.7082 9.72789 16.707 9.79L16.7067 9.80089C16.6227 9.82669 16.5088 9.85769 16.3462 9.90154C14.4009 10.4263 13.1736 12.4571 13.6823 14.4144C13.7261 14.5828 13.7564 14.7007 13.7761 14.7891L13.7653 14.7956C13.7114 14.8276 13.6479 14.8636 13.5674 14.9094L12.1301 15.7254C12.051 15.7703 11.9889 15.8056 11.9349 15.8348L11.9266 15.8393C11.8637 15.7807 11.7818 15.6993 11.6654 15.5831C10.2047 14.1256 7.79628 14.1257 6.33563 15.5832C6.21917 15.6994 6.13731 15.7807 6.0744 15.8394L6.06606 15.8349C6.01214 15.8057 5.94999 15.7704 5.87089 15.7255L4.43364 14.9095C4.35307 14.8637 4.28963 14.8277 4.23573 14.7957L4.2249 14.7892C4.24458 14.7008 4.27493 14.5829 4.3187 14.4144C4.82723 12.4568 3.59882 10.4262 1.65343 9.90152C1.49087 9.85768 1.37702 9.82669 1.29296 9.8009L1.29274 9.79001C1.29154 9.7279 1.29151 9.65555 1.29151 9.56358V7.95222C1.29151 7.86024 1.29154 7.7879 1.29274 7.72578L1.29296 7.7149C1.37702 7.68911 1.49086 7.65813 1.6534 7.61431C3.59884 7.08976 4.82833 5.05924 4.31999 3.10145C4.27623 2.93291 4.24588 2.81495 4.22621 2.72649L4.23706 2.72003C4.29095 2.68805 4.3544 2.652 4.43496 2.60626L5.87221 1.79023Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Logout = () => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.83291 1.47136C5.09331 1.37945 5.22991 1.09385 5.138 0.833452C5.04609 0.573052 4.76049 0.436461 4.50009 0.528366L4.03016 0.694225C3.19451 0.98915 2.52769 1.22449 2.01125 1.47505C1.47757 1.73397 1.0593 2.0295 0.748096 2.46935C0.436895 2.9092 0.29742 3.40199 0.23088 3.99142C0.16649 4.56181 0.166496 5.26894 0.166504 6.1551V7.84462C0.166496 8.73078 0.16649 9.43791 0.23088 10.0083C0.29742 10.5977 0.436895 11.0905 0.748096 11.5304C1.0593 11.9702 1.47757 12.2658 2.01125 12.5247C2.5277 12.7752 3.19452 13.0106 4.03018 13.3055L4.5001 13.4714C4.7605 13.5633 5.04609 13.4267 5.138 13.1663C5.22991 12.9059 5.09331 12.6203 4.83291 12.5284L4.39121 12.3725C3.5209 12.0653 2.90753 11.848 2.44775 11.625C1.9994 11.4074 1.743 11.2052 1.56444 10.9528C1.38588 10.7004 1.28047 10.3913 1.22457 9.89613C1.16724 9.38832 1.1665 8.73761 1.1665 7.81468V6.18504C1.1665 5.26212 1.16724 4.61141 1.22457 4.1036C1.28047 3.60841 1.38588 3.2993 1.56444 3.04693C1.743 2.79455 1.9994 2.59227 2.44775 2.37475C2.90753 2.15169 3.5209 1.93442 4.39121 1.62725L4.83291 1.47136Z"
        fill="currentColor"
      />
      <path
        d="M10.015 4.97468C9.81698 4.78221 9.50043 4.78671 9.30796 4.98473C9.1155 5.18274 9.11999 5.49929 9.31801 5.69176C9.42574 5.79647 9.59715 5.93129 9.7603 6.05944L9.79827 6.08926C9.96209 6.21786 10.1373 6.35539 10.303 6.49585L10.3078 6.49989H4.6665C4.39036 6.49989 4.1665 6.72375 4.1665 6.99989C4.1665 7.27603 4.39036 7.49989 4.6665 7.49989H10.3078L10.303 7.50393C10.1373 7.64437 9.96211 7.78189 9.79831 7.91049L9.7603 7.94033C9.59715 8.06849 9.42574 8.20331 9.31801 8.30801C9.11999 8.50048 9.1155 8.81703 9.30796 9.01505C9.50043 9.21307 9.81698 9.21756 10.015 9.0251C10.0758 8.96596 10.197 8.86888 10.378 8.72675L10.418 8.69537C10.5794 8.56866 10.7688 8.42001 10.9495 8.26686C11.1432 8.10273 11.3444 7.91901 11.5008 7.73536C11.5792 7.64333 11.6565 7.5396 11.7162 7.42801C11.7738 7.32038 11.8332 7.17208 11.8332 6.99989C11.8332 6.8277 11.7738 6.6794 11.7162 6.57177C11.6565 6.46018 11.5792 6.35644 11.5008 6.26441C11.3444 6.08076 11.1432 5.89705 10.9495 5.73291C10.7688 5.57976 10.5794 5.43111 10.418 5.3044L10.378 5.27303C10.197 5.1309 10.0758 5.03382 10.015 4.97468Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Announcement = () => {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 9.5V7.5H20V9.5H16ZM17.2 16.5L14 14.1L15.2 12.5L18.4 14.9L17.2 16.5ZM15.2 4.5L14 2.9L17.2 0.5L18.4 2.1L15.2 4.5ZM3 15.5V11.5H2C1.45 11.5 0.979167 11.3042 0.5875 10.9125C0.195833 10.5208 0 10.05 0 9.5V7.5C0 6.95 0.195833 6.47917 0.5875 6.0875C0.979167 5.69583 1.45 5.5 2 5.5H6L11 2.5V14.5L6 11.5H5V15.5H3ZM9 10.95V6.05L6.55 7.5H2V9.5H6.55L9 10.95ZM12 11.85V5.15C12.45 5.55 12.8125 6.0375 13.0875 6.6125C13.3625 7.1875 13.5 7.81667 13.5 8.5C13.5 9.18333 13.3625 9.8125 13.0875 10.3875C12.8125 10.9625 12.45 11.45 12 11.85Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Notification = () => {
  return (
    <svg
      width="20"
      height="23"
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.3 20.5C8.46738 20.8044 8.71345 21.0583 9.01249 21.2352C9.31153 21.412 9.65258 21.5053 10 21.5053C10.3474 21.5053 10.6885 21.412 10.9875 21.2352C11.2866 21.0583 11.5326 20.8044 11.7 20.5M4 7.5C4 5.9087 4.63214 4.38258 5.75736 3.25736C6.88258 2.13214 8.4087 1.5 10 1.5C11.5913 1.5 13.1174 2.13214 14.2426 3.25736C15.3679 4.38258 16 5.9087 16 7.5C16 14.5 19 16.5 19 16.5H1C1 16.5 4 14.5 4 7.5Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3 20.5C8.46738 20.8044 8.71345 21.0583 9.01249 21.2352C9.31153 21.412 9.65258 21.5053 10 21.5053C10.3474 21.5053 10.6885 21.412 10.9875 21.2352C11.2866 21.0583 11.5326 20.8044 11.7 20.5M4 7.5C4 5.9087 4.63214 4.38258 5.75736 3.25736C6.88258 2.13214 8.4087 1.5 10 1.5C11.5913 1.5 13.1174 2.13214 14.2426 3.25736C15.3679 4.38258 16 5.9087 16 7.5C16 14.5 19 16.5 19 16.5H1C1 16.5 4 14.5 4 7.5Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Eye = () => {
  return (
    <svg
      width="16"
      height="11"
      viewBox="0 0 16 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00016 8.00001C6.61945 8.00001 5.50016 6.88072 5.50016 5.50001C5.50016 4.1193 6.61945 3.00001 8.00016 3.00001C9.38087 3.00001 10.5002 4.1193 10.5002 5.50001C10.5002 6.88072 9.38087 8.00001 8.00016 8.00001ZM6.50016 5.50001C6.50016 6.32844 7.17174 7.00001 8.00016 7.00001C8.82859 7.00001 9.50016 6.32844 9.50016 5.50001C9.50016 4.67158 8.82859 4.00001 8.00016 4.00001C7.17174 4.00001 6.50016 4.67158 6.50016 5.50001Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00016 0.333344C6.28646 0.333344 4.81746 1.08762 3.68037 1.97533C2.54225 2.86385 1.70101 3.91317 1.23044 4.57302L1.19496 4.6225C1.02619 4.85722 0.833496 5.12521 0.833496 5.50001C0.833496 5.87481 1.02619 6.1428 1.19496 6.37752L1.23044 6.427C1.70101 7.08685 2.54225 8.13617 3.68037 9.02469C4.81746 9.91241 6.28646 10.6667 8.00016 10.6667C9.71387 10.6667 11.1829 9.91241 12.32 9.02469C13.4581 8.13617 14.2993 7.08685 14.7699 6.427L14.8054 6.37752C14.9741 6.1428 15.1668 5.87481 15.1668 5.50001C15.1668 5.12521 14.9741 4.85722 14.8054 4.6225L14.7699 4.57302C14.2993 3.91317 13.4581 2.86385 12.32 1.97533C11.1829 1.08761 9.71387 0.333344 8.00016 0.333344ZM2.04461 5.15364C2.48474 4.53647 3.26175 3.5708 4.29574 2.76357C5.33075 1.95555 6.58772 1.33334 8.00016 1.33334C9.4126 1.33334 10.6696 1.95555 11.7046 2.76357C12.7386 3.57079 13.5156 4.53647 13.9557 5.15364C14.0646 5.30632 14.1164 5.38088 14.1473 5.44023C14.1669 5.47795 14.1669 5.48829 14.1668 5.49842L14.1668 5.50001L14.1668 5.50161C14.1669 5.51173 14.1669 5.52207 14.1473 5.5598C14.1164 5.61914 14.0646 5.6937 13.9557 5.84638C13.5156 6.46355 12.7386 7.42923 11.7046 8.23645C10.6696 9.04447 9.4126 9.66668 8.00016 9.66668C6.58772 9.66668 5.33075 9.04447 4.29574 8.23645C3.26175 7.42923 2.48475 6.46355 2.04461 5.84638C1.93573 5.6937 1.88391 5.61914 1.85302 5.5598C1.83338 5.52207 1.83344 5.51173 1.83349 5.50161L1.8335 5.50001L1.83349 5.49842C1.83344 5.48829 1.83338 5.47795 1.85302 5.44023C1.88391 5.38088 1.93573 5.30632 2.04461 5.15364Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Confirm = () => {
  return (
    <svg
      height="18"
      width="18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 39.428 39.428"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M38.783,8.467c-0.578-0.751-1.514-1.199-2.502-1.199c-0.688,0-1.354,0.222-1.881,0.625
     L12.209,24.942l-6.95-6.487c-1.172-1.096-3.325-1.02-4.417,0.152c-0.569,0.61-0.867,1.405-0.84,2.241
     c0.029,0.833,0.382,1.607,0.992,2.176l8.887,8.295c0.582,0.543,1.34,0.842,2.133,0.842c0.693,0,1.352-0.225,1.904-0.648
     L38.21,12.85C39.574,11.802,39.833,9.835,38.783,8.467z M36.99,11.264L12.699,29.927c-0.406,0.312-1.081,0.278-1.455-0.068
     l-8.886-8.295c-0.22-0.205-0.347-0.483-0.356-0.785c-0.011-0.3,0.096-0.587,0.301-0.806c0.216-0.231,0.509-0.358,0.824-0.358
     c0.286,0,0.559,0.108,0.769,0.303l8.188,7.644L35.617,9.481c0.459-0.352,1.232-0.248,1.58,0.205
     C37.574,10.178,37.483,10.886,36.99,11.264z"
        />
      </g>
    </svg>
  );
};
export const Reject = () => {
  return (
    <svg
      fill="#000000"
      width="18"
      height="18"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="M10,1a9,9,0,1,0,9,9A9,9,0,0,0,10,1Zm0,16.4A7.4,7.4,0,1,1,17.4,10,7.41,7.41,0,0,1,10,17.4ZM13.29,5.29,10,8.59,6.71,5.29,5.29,6.71,8.59,10l-3.3,3.29,1.42,1.42L10,11.41l3.29,3.3,1.42-1.42L11.41,10l3.3-3.29Z" />
      </g>
    </svg>
  );
};
export const Check = (props) => {
  return (
    <svg
      width="11"
      height="9"
      viewBox="0 0 11 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7621 0.471667C10.9618 0.662336 10.9692 0.978833 10.7785 1.17858L3.77851 8.51192C3.68555 8.6093 3.55726 8.66508 3.42264 8.66664C3.28803 8.66821 3.15847 8.61543 3.06328 8.52023L0.729943 6.1869C0.534681 5.99164 0.534681 5.67505 0.729943 5.47979C0.925205 5.28453 1.24179 5.28453 1.43705 5.47979L3.40851 7.45125L10.0552 0.488106C10.2458 0.288357 10.5623 0.280997 10.7621 0.471667Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Close = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.72994 3.4797C3.9252 3.28444 4.24179 3.28444 4.43705 3.4797L8.75016 7.79281L13.0633 3.4797C13.2585 3.28444 13.5751 3.28444 13.7704 3.4797C13.9656 3.67496 13.9656 3.99154 13.7704 4.18681L9.45727 8.49992L13.7704 12.813C13.9656 13.0083 13.9656 13.3249 13.7704 13.5201C13.5751 13.7154 13.2585 13.7154 13.0633 13.5201L8.75016 9.20702L4.43705 13.5201C4.24179 13.7154 3.9252 13.7154 3.72994 13.5201C3.53468 13.3249 3.53468 13.0083 3.72994 12.813L8.04306 8.49992L3.72994 4.18681C3.53468 3.99154 3.53468 3.67496 3.72994 3.4797Z"
        fill="currentColor"
      />
    </svg>
  );
};

// export const SortIcon = ({ active = "none", activeColor = "blue", defaultColor = "black" }) => {
//   return (
//     <svg
//       width="17"
//       height="17"
//       viewBox="0 0 17 17"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       {/* Right Arrow */}
//       <path
//         d="M14.0996 11.1667L11.4329 13.8334L8.76628 11.1667"
//         fill={active === "right" ? activeColor : defaultColor}
//       />
//       <path
//         d="M11.4329 13.8334V3.16669"
//         stroke={active === "right" ? activeColor : defaultColor}
//         strokeWidth="1.33333"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />

//       {/* Left Arrow */}
//       <path
//         d="M2.09961 5.83335L4.76628 3.16669L7.43294 5.83335"
//         fill={active === "left" ? activeColor : defaultColor}
//       />
//       <path
//         d="M4.76628 3.16669V13.8334"
//         stroke={active === "left" ? activeColor : defaultColor}
//         strokeWidth="1.33333"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   );
// };

export const SortIcon = ({
  sortType = "0",
  deActiveColor = "#33333373",
  defaultColor = "black",
}) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* <!-- Right Arrow (Blue) --> */}
      <path
        d="M14.0996 11.1667L11.4329 14L8.76628 11.1667"
        fill={sortType === "1" ? deActiveColor : defaultColor}
      />
      <path
        d="M11.4329 13V2.66669"
        stroke={sortType === "1" ? deActiveColor : defaultColor}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* <!-- Left Arrow (Red) - Moved Slightly Up --> */}
      <path
        d="M2.09961 5.33335L4.76628 2.49999L7.43294 5.33335"
        fill={sortType === "2" ? deActiveColor : defaultColor}
      />
      <path
        d="M4.76628 2.99999V13.8334"
        stroke={sortType === "2" ? deActiveColor : defaultColor}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SortUpSideIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0996 11.1667L11.4329 13.8334L8.76628 11.1667"
        fill="currentColor"
      />
      <path d="M11.4329 13.8334V3.16669V13.8334Z" fill="currentColor" />
      <path
        d="M2.09961 5.83335L4.76628 3.16669L7.43294 5.83335"
        fill="currentColor"
      />
      <path d="M4.76628 3.16669V13.8334V3.16669Z" fill="currentColor" />
      <path
        d="M14.0996 11.1667L11.4329 13.8334M11.4329 13.8334L8.76628 11.1667M11.4329 13.8334V3.16669M2.09961 5.83335L4.76628 3.16669M4.76628 3.16669L7.43294 5.83335M4.76628 3.16669V13.8334"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Search = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 14L11.6333 11.1333M13.1667 7.33333C13.1667 10.2789 10.7789 12.6667 7.83333 12.6667C4.88781 12.6667 2.5 10.2789 2.5 7.33333C2.5 4.38781 4.88781 2 7.83333 2C10.7789 2 13.1667 4.38781 13.1667 7.33333Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Filter = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="white"
    >
      <path
        d="M11 8L20 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M4 16L14 16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <ellipse
        cx="7"
        cy="8"
        rx="3"
        ry="3"
        transform="rotate(90 7 8)"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <ellipse
        cx="17"
        cy="16"
        rx="3"
        ry="3"
        transform="rotate(90 17 16)"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const UserSystem = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0837 7.54169C13.7385 7.54169 13.4587 7.82151 13.4587 8.16669C13.4587 8.51187 13.7385 8.79169 14.0837 8.79169H14.917C15.2622 8.79169 15.542 8.51187 15.542 8.16669C15.542 7.82151 15.2622 7.54169 14.917 7.54169H14.0837Z"
        fill="#9DA4AE"
      />
      <path
        d="M14.0837 10.875C13.7385 10.875 13.4587 11.1548 13.4587 11.5C13.4587 11.8452 13.7385 12.125 14.0837 12.125H14.917C15.2622 12.125 15.542 11.8452 15.542 11.5C15.542 11.1548 15.2622 10.875 14.917 10.875H14.0837Z"
        fill="#9DA4AE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.12126 0.0416874H6.21272C7.35236 0.0416707 8.27096 0.0416572 8.99343 0.138791C9.74352 0.239638 10.3751 0.455383 10.8767 0.956975C11.3783 1.45857 11.594 2.09013 11.6949 2.84023C11.775 3.43601 11.789 4.16517 11.7915 5.04169L14.5437 5.04169C15.2924 5.04166 15.9167 5.04164 16.4124 5.10828C16.9355 5.17862 17.4079 5.33335 17.7874 5.7129C18.167 6.09245 18.3217 6.5648 18.3921 7.08796C18.4587 7.58361 18.4587 8.20797 18.4587 8.95669V14.0433C18.4587 14.7921 18.4587 15.4164 18.3921 15.9121C18.3217 16.4352 18.167 16.9076 17.7874 17.2871C17.4079 17.6667 16.9355 17.8214 16.4124 17.8918C15.9167 17.9584 15.2924 17.9584 14.5437 17.9584H11.167C10.8218 17.9584 10.542 17.6785 10.542 17.3334V5.66669C10.542 4.47051 10.5407 3.63625 10.456 3.00679C10.3738 2.39531 10.2234 2.07151 9.99281 1.84087C9.76216 1.61023 9.43834 1.45986 8.82687 1.37764C8.19741 1.29302 7.36316 1.29169 6.16699 1.29169C4.97081 1.29169 4.13655 1.29302 3.50709 1.37764C2.89561 1.45986 2.5718 1.61023 2.34117 1.84086C2.11053 2.0715 1.96016 2.39531 1.87795 3.00679C1.79332 3.63625 1.79199 4.47051 1.79199 5.66669V7.33335C1.79199 7.67853 1.51217 7.95835 1.16699 7.95835C0.821816 7.95835 0.541993 7.67853 0.541993 7.33335V5.62096C0.541976 4.48131 0.541962 3.5627 0.639096 2.84023C0.739943 2.09014 0.955688 1.45858 1.45729 0.95698C1.95888 0.455383 2.59044 0.239638 3.34053 0.138791C4.063 0.0416572 4.98161 0.0416707 6.12126 0.0416874ZM11.792 6.29169V16.7084H14.5003C15.3037 16.7084 15.8433 16.707 16.2458 16.6529C16.6304 16.6012 16.7949 16.5119 16.9036 16.4032C17.0122 16.2946 17.1015 16.1301 17.1532 15.7455C17.2073 15.343 17.2087 14.8034 17.2087 14V9.00002C17.2087 8.19669 17.2073 7.65705 17.1532 7.25452C17.1015 6.86997 17.0122 6.70539 16.9036 6.5968C16.795 6.48819 16.6304 6.39884 16.2458 6.34713C15.8433 6.29302 15.3037 6.29169 14.5003 6.29169H11.792Z"
        fill="#9DA4AE"
      />
      <path
        d="M4.08366 3.37502C3.73848 3.37502 3.45866 3.65484 3.45866 4.00002C3.45866 4.3452 3.73848 4.62502 4.08366 4.62502H4.91699C5.26217 4.62502 5.54199 4.3452 5.54199 4.00002C5.54199 3.65484 5.26217 3.37502 4.91699 3.37502H4.08366Z"
        fill="#9DA4AE"
      />
      <path
        d="M7.41699 3.37502C7.07181 3.37502 6.79199 3.65484 6.79199 4.00002C6.79199 4.3452 7.07181 4.62502 7.41699 4.62502H8.25033C8.5955 4.62502 8.87533 4.3452 8.87533 4.00002C8.87533 3.65484 8.5955 3.37502 8.25033 3.37502H7.41699Z"
        fill="#9DA4AE"
      />
      <path
        d="M4.08366 5.87502C3.73848 5.87502 3.45866 6.15484 3.45866 6.50002C3.45866 6.8452 3.73848 7.12502 4.08366 7.12502H4.91699C5.26217 7.12502 5.54199 6.8452 5.54199 6.50002C5.54199 6.15484 5.26217 5.87502 4.91699 5.87502H4.08366Z"
        fill="#9DA4AE"
      />
      <path
        d="M7.41699 5.87502C7.07181 5.87502 6.79199 6.15484 6.79199 6.50002C6.79199 6.8452 7.07181 7.12502 7.41699 7.12502H8.25033C8.5955 7.12502 8.87533 6.8452 8.87533 6.50002C8.87533 6.15484 8.5955 5.87502 8.25033 5.87502H7.41699Z"
        fill="#9DA4AE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.52109 8.3384C3.2559 8.3384 2.22948 9.36342 2.22948 10.6288C2.22948 11.8942 3.2559 12.9192 4.52109 12.9192C5.78629 12.9192 6.81271 11.8942 6.81271 10.6288C6.81271 9.36342 5.78629 8.3384 4.52109 8.3384ZM3.47948 10.6288C3.47948 10.0546 3.9454 9.5884 4.52109 9.5884C5.09679 9.5884 5.56271 10.0546 5.56271 10.6288C5.56271 11.203 5.09679 11.6692 4.52109 11.6692C3.9454 11.6692 3.47948 11.203 3.47948 10.6288Z"
        fill="#9DA4AE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.52174 13.3526C3.3247 13.3513 1.71307 13.9444 0.701164 15.5011C0.551843 15.7309 0.465468 16.0919 0.659607 16.4359C0.798694 16.6823 1.05183 17.0024 1.33036 17.2689C1.47238 17.4048 1.63557 17.5408 1.80992 17.6503C1.97672 17.7551 2.1973 17.8635 2.44706 17.8901C3.01539 17.9505 4.47721 17.9581 4.5189 17.9583L4.52611 17.9582C4.56816 17.958 5.98622 17.9505 6.55408 17.8901C6.80384 17.8635 7.02443 17.7551 7.19122 17.6503C7.36557 17.5408 7.52876 17.4048 7.67078 17.2689C7.94932 17.0024 8.20245 16.6823 8.34154 16.4359C8.53567 16.0919 8.4493 15.7309 8.29998 15.5011C7.29116 13.9492 5.72404 13.3538 4.52174 13.3526ZM2.19446 16.3656C2.06824 16.2449 1.95614 16.1148 1.87236 16.0046C2.62632 14.9818 3.73471 14.6017 4.52044 14.6025C5.30132 14.6034 6.37595 14.9778 7.12894 16.0043C7.04515 16.1147 6.93299 16.2448 6.80669 16.3656C6.70501 16.4629 6.60847 16.5402 6.52621 16.5919C6.46265 16.6319 6.42758 16.6439 6.41906 16.6468C6.41767 16.6473 6.41698 16.6475 6.417 16.6476C6.41698 16.6476 6.417 16.6476 6.417 16.6476C5.9279 16.6987 4.61684 16.7077 4.52207 16.7082C4.42517 16.7077 3.0735 16.6987 2.58414 16.6476C2.58416 16.6475 2.58348 16.6473 2.58208 16.6468C2.57356 16.6439 2.53849 16.6319 2.47494 16.5919C2.39267 16.5402 2.29613 16.4629 2.19446 16.3656ZM6.417 16.6476C6.41712 16.6476 6.41759 16.6476 6.41834 16.6475C6.41916 16.6474 6.42037 16.6473 6.42195 16.6471C6.42032 16.6473 6.41865 16.6474 6.417 16.6476Z"
        fill="#9DA4AE"
      />
    </svg>
  );
};
export const Clock = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.29199 9.00002C1.29199 4.74283 4.74313 1.29169 9.00033 1.29169C13.2575 1.29169 16.7087 4.74283 16.7087 9.00002C16.7087 9.5288 16.6555 10.0445 16.5545 10.5424C16.4858 10.8806 16.7044 11.2105 17.0426 11.2792C17.3809 11.3479 17.7108 11.1293 17.7795 10.791C17.897 10.2118 17.9587 9.61279 17.9587 9.00002C17.9587 4.05247 13.9479 0.041687 9.00033 0.041687C4.05277 0.041687 0.0419922 4.05247 0.0419922 9.00002C0.0419922 13.9476 4.05277 17.9584 9.00033 17.9584C9.31022 17.9584 9.61664 17.9426 9.9188 17.9118C10.2622 17.8768 10.5122 17.57 10.4772 17.2266C10.4422 16.8832 10.1354 16.6332 9.79204 16.6682C9.53193 16.6948 9.26782 16.7084 9.00033 16.7084C4.74313 16.7084 1.29199 13.2572 1.29199 9.00002Z"
        fill="#9DA4AE"
      />
      <path
        d="M9.00033 5.04169C9.3455 5.04169 9.62533 5.32151 9.62533 5.66669V8.74114L10.6923 9.80808C10.9363 10.0522 10.9363 10.4479 10.6923 10.692C10.4482 10.936 10.0525 10.936 9.80838 10.692L8.55838 9.44196C8.44117 9.32475 8.37533 9.16578 8.37533 9.00002V5.66669C8.37533 5.32151 8.65515 5.04169 9.00033 5.04169Z"
        fill="#9DA4AE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6189 11.6394L15.6315 12.1862C16.2737 12.533 16.8207 12.8283 17.2006 13.1172C17.5993 13.4204 17.9587 13.8244 17.9587 14.4167C17.9587 15.0089 17.5993 15.413 17.2006 15.7162C16.8207 16.0051 16.2737 16.3004 15.6315 16.6472L14.6189 17.1939C14.1275 17.4594 13.7078 17.686 13.3793 17.8156C13.2099 17.8824 13.0172 17.9434 12.8205 17.956C12.6084 17.9695 12.3585 17.9276 12.1416 17.7505C11.795 17.4674 11.6978 17.0781 11.7096 16.7431C11.7207 16.4285 11.8255 16.1205 11.9336 15.8705C12.0452 15.6124 12.1835 15.3651 12.3006 15.1647C12.3481 15.0836 12.3891 15.0147 12.4245 14.9554C12.4859 14.8525 12.5303 14.7781 12.5613 14.7177C12.6634 14.5188 12.6704 14.446 12.6703 14.4154C12.6702 14.3843 12.6625 14.3129 12.5613 14.1157C12.5303 14.0553 12.486 13.9811 12.4247 13.8782C12.3893 13.8189 12.3481 13.7498 12.3006 13.6686C12.1835 13.4683 12.0452 13.2209 11.9336 12.9629C11.8255 12.7129 11.7207 12.4048 11.7096 12.0903C11.6978 11.7553 11.795 11.366 12.1416 11.0829C12.3585 10.9058 12.6084 10.8639 12.8205 10.8774C13.0172 10.89 13.2099 10.9509 13.3793 11.0178C13.7078 11.1473 14.1275 11.374 14.6189 11.6394ZM12.9874 12.208C13.0069 12.2795 13.0372 12.3657 13.0809 12.4667C13.1619 12.654 13.2696 12.8493 13.3798 13.0378C13.4079 13.0859 13.4385 13.1372 13.4694 13.1891C13.5456 13.3171 13.624 13.4488 13.6733 13.5448C13.8072 13.8056 13.9193 14.0874 13.9203 14.4116C13.9213 14.7364 13.8107 15.021 13.6733 15.2886C13.624 15.3846 13.5456 15.5162 13.4694 15.6442C13.4385 15.6961 13.4079 15.7475 13.3798 15.7956C13.2696 15.9841 13.1619 16.1794 13.0809 16.3667C13.0372 16.4677 13.0069 16.5539 12.9874 16.6254C13.2324 16.521 13.5695 16.3401 14.0626 16.0737L14.9912 15.5723C15.6926 15.1935 16.1512 14.9438 16.444 14.7211C16.7152 14.515 16.7097 14.4324 16.7087 14.4182L16.7087 14.4167L16.7087 14.4152C16.7097 14.401 16.7152 14.3184 16.444 14.1122C16.1512 13.8896 15.6926 13.6399 14.9912 13.2611L14.0626 12.7596C13.5695 12.4933 13.2324 12.3124 12.9874 12.208Z"
        fill="#9DA4AE"
      />
    </svg>
  );
};
export const Money = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1031 4.83167C10.1031 4.48649 9.82329 4.20667 9.47811 4.20667C9.13293 4.20667 8.85311 4.48649 8.85311 4.83167V5.1674C7.59338 5.40669 6.93227 6.20461 6.74516 6.78998C6.60677 7.18423 6.53935 7.80652 6.8569 8.38117C7.19944 9.00105 7.88936 9.39134 8.91836 9.46424C10.0623 9.54531 10.7073 9.65026 11.0599 9.83542C11.2074 9.91285 11.2682 9.98755 11.3026 10.061C11.343 10.1471 11.3779 10.2996 11.3547 10.5781C11.3163 11.0384 11.1098 11.2726 10.8367 11.4192C10.5245 11.5868 10.0923 11.6502 9.65445 11.636C9.22919 11.6224 8.67476 11.5154 8.2417 11.297C7.80681 11.0777 7.61657 10.8183 7.60171 10.529C7.58399 10.1843 7.29018 9.91918 6.94546 9.93689C6.60073 9.9546 6.33564 10.2484 6.35335 10.5931C6.40097 11.5198 7.04703 12.0945 7.67887 12.4131C8.05237 12.6014 8.46378 12.7256 8.85311 12.7995V13.165C8.85311 13.5102 9.13293 13.79 9.47811 13.79C9.82329 13.79 10.1031 13.5102 10.1031 13.165V12.8762C10.5372 12.8449 11.0077 12.7461 11.4279 12.5206C12.0518 12.1856 12.5249 11.5886 12.6004 10.6818C12.6341 10.2767 12.5999 9.88354 12.4346 9.53075C12.2634 9.16529 11.9822 8.90785 11.641 8.72868C11.0162 8.40065 10.0967 8.29462 9.00673 8.21737C8.24865 8.16366 8.02474 7.9101 7.95097 7.7766C7.85575 7.60428 7.86448 7.37114 7.92606 7.19988L7.93094 7.18632L7.93519 7.17254C7.97901 7.03041 8.34209 6.39629 9.49741 6.34951L9.50816 6.3491C9.54921 6.34757 9.59125 6.34678 9.63431 6.34678C10.5946 6.3468 11.0918 7.10153 11.139 7.46473C11.1835 7.80703 11.4971 8.04846 11.8394 8.00397C12.1817 7.95949 12.4231 7.64594 12.3786 7.30364C12.2722 6.48473 11.4789 5.3476 10.1031 5.13261V4.83167Z"
        fill="#9DA4AE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.50033 0.041626C4.55277 0.041626 0.541992 4.05241 0.541992 8.99996C0.541992 13.9475 4.55277 17.9583 9.50033 17.9583C14.4478 17.9583 18.4587 13.9475 18.4587 8.99996C18.4587 4.0524 14.4478 0.041626 9.50033 0.041626ZM1.79199 8.99996C1.79199 4.74276 5.24313 1.29163 9.50033 1.29163C13.7575 1.29163 17.2087 4.74276 17.2087 8.99996C17.2087 13.2571 13.7575 16.7083 9.50033 16.7083C5.24313 16.7083 1.79199 13.2571 1.79199 8.99996Z"
        fill="#9DA4AE"
      />
    </svg>
  );
};
export const Exchange = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.20833 0.666626C4.20833 0.321448 3.92851 0.041626 3.58333 0.041626C3.23816 0.041626 2.95833 0.321448 2.95833 0.666626V1.14115C2.49978 1.22755 2.07889 1.40817 1.73519 1.66594C1.23979 2.03749 0.875 2.59849 0.875 3.27079C0.875 3.94309 1.23979 4.5041 1.73519 4.87565C2.2304 5.24705 2.88588 5.45829 3.58333 5.45829C4.03647 5.45829 4.42266 5.59683 4.68147 5.79094C4.94009 5.9849 5.04167 6.20515 5.04167 6.39579C5.04167 6.58644 4.94009 6.80668 4.68147 7.00065C4.42266 7.19476 4.03647 7.33329 3.58333 7.33329C2.84493 7.33329 2.3388 6.97886 2.18391 6.65019C2.03676 6.33795 1.66435 6.20411 1.35211 6.35126C1.03987 6.49841 0.906033 6.87082 1.05318 7.18306C1.38837 7.89431 2.12403 8.36667 2.95833 8.52478V8.99996C2.95833 9.34514 3.23816 9.62496 3.58333 9.62496C3.92851 9.62496 4.20833 9.34514 4.20833 8.99996V8.52543C4.66688 8.43904 5.08778 8.25842 5.43147 8.00065C5.92687 7.6291 6.29167 7.0681 6.29167 6.39579C6.29167 5.72349 5.92687 5.16249 5.43147 4.79094C4.93626 4.41953 4.28078 4.20829 3.58333 4.20829C3.13019 4.20829 2.744 4.06976 2.48519 3.87565C2.22658 3.68168 2.125 3.46144 2.125 3.27079C2.125 3.08015 2.22658 2.8599 2.48519 2.66594C2.744 2.47183 3.13019 2.33329 3.58333 2.33329C4.32174 2.33329 4.82787 2.68773 4.98276 3.0164C5.12991 3.32864 5.50232 3.46247 5.81456 3.31532C6.1268 3.16817 6.26063 2.79576 6.11348 2.48352C5.7783 1.77228 5.04264 1.29992 4.20833 1.14181V0.666626Z"
        fill="#9DA4AE"
      />
      <path
        d="M8.16667 3.79163C9.35489 3.79163 10.4145 3.79221 11.2683 3.87212C11.6934 3.9119 12.0451 3.9696 12.3219 4.04851C12.6044 4.12903 12.7644 4.21933 12.8473 4.29476C13.1039 4.52799 13.2235 4.73948 13.2928 5.13639C13.3441 5.43056 13.3635 5.80106 13.3707 6.31986L12.6128 5.94094C12.3041 5.78657 11.9287 5.91171 11.7743 6.22045C11.6199 6.52919 11.7451 6.90461 12.0538 7.05898L13.7205 7.89231C13.9142 7.98918 14.1443 7.97883 14.3286 7.86495C14.5128 7.75107 14.625 7.5499 14.625 7.33329L14.625 7.26535C14.6251 6.25426 14.6251 5.49942 14.5242 4.92138C14.4104 4.2699 14.1639 3.80226 13.6882 3.36983C13.405 3.11242 13.0389 2.95309 12.6646 2.84639C12.2846 2.73809 11.8487 2.67097 11.3847 2.62755C10.4665 2.54162 9.35053 2.54162 8.19015 2.54163L8.16667 2.54163C7.82149 2.54163 7.54167 2.82145 7.54167 3.16663C7.54167 3.5118 7.82149 3.79163 8.16667 3.79163Z"
        fill="#9DA4AE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.625 9.83329C14.625 9.48812 14.3452 9.20829 14 9.20829C13.6548 9.20829 13.375 9.48812 13.375 9.83329V10.4583H11.5C11.1548 10.4583 10.875 10.7381 10.875 11.0833C10.875 11.4285 11.1548 11.7083 11.5 11.7083H11.8125V15.4583H11.5C11.1548 15.4583 10.875 15.7381 10.875 16.0833C10.875 16.4285 11.1548 16.7083 11.5 16.7083H13.375V17.3333C13.375 17.6785 13.6548 17.9583 14 17.9583C14.3452 17.9583 14.625 17.6785 14.625 17.3333V16.7083H15.5625C16.4254 16.7083 17.125 16.0087 17.125 15.1458V14.5208C17.125 14.169 17.0088 13.8444 16.8126 13.5833C17.0088 13.3222 17.125 12.9975 17.125 12.6458V12.0208C17.125 11.1578 16.4254 10.4583 15.5625 10.4583H14.625V9.83329ZM13.0625 12.9583V11.7083H15.5625C15.7351 11.7083 15.875 11.8482 15.875 12.0208V12.6458C15.875 12.8184 15.7351 12.9583 15.5625 12.9583H13.0625ZM13.0625 14.2083H15.5625C15.7351 14.2083 15.875 14.3482 15.875 14.5208V15.1458C15.875 15.3184 15.7351 15.4583 15.5625 15.4583H13.0625V14.2083Z"
        fill="#9DA4AE"
      />
      <path
        d="M2.83809 10.9683C3.02235 10.8544 3.25244 10.8441 3.44618 10.9409L5.11285 11.7743C5.42158 11.9286 5.54672 12.3041 5.39235 12.6128C5.23799 12.9215 4.86257 13.0467 4.55383 12.8923L3.79598 12.5134C3.80322 13.0322 3.82252 13.4027 3.87388 13.6969C3.94319 14.0938 4.06277 14.3053 4.31932 14.5385C4.40229 14.6139 4.56224 14.7042 4.84473 14.7847C5.12158 14.8637 5.47325 14.9214 5.89839 14.9611C6.75218 15.041 7.81178 15.0416 9 15.0416C9.34518 15.0416 9.625 15.3214 9.625 15.6666C9.625 16.0118 9.34518 16.2916 9 16.2916H8.97652C7.81614 16.2916 6.70018 16.2916 5.78192 16.2057C5.31795 16.1623 4.88205 16.0952 4.50208 15.9869C4.12775 15.8802 3.76163 15.7208 3.47848 15.4634C3.00281 15.031 2.75627 14.5634 2.64251 13.9119C2.54158 13.3338 2.54162 12.579 2.54167 11.5679L2.54167 11.5C2.54167 11.2833 2.65383 11.0822 2.83809 10.9683Z"
        fill="#9DA4AE"
      />
    </svg>
  );
};
export const Fees = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.4995 5.04163C8.00373 5.04163 6.79117 6.25419 6.79117 7.74996C6.79117 9.24573 8.00373 10.4583 9.4995 10.4583C10.9953 10.4583 12.2078 9.24573 12.2078 7.74996C12.2078 6.25419 10.9953 5.04163 9.4995 5.04163ZM8.04117 7.74996C8.04117 6.94454 8.69409 6.29163 9.4995 6.29163C10.3049 6.29163 10.9578 6.94454 10.9578 7.74996C10.9578 8.55538 10.3049 9.20829 9.4995 9.20829C8.69409 9.20829 8.04117 8.55538 8.04117 7.74996Z"
        fill="#9DA4AE"
      />
      <path
        d="M4.08283 7.74996C4.54307 7.74996 4.91617 8.12306 4.91617 8.58329V8.59078C4.91617 9.05102 4.54307 9.42411 4.08283 9.42411C3.6226 9.42411 3.2495 9.05102 3.2495 8.59078V8.58329C3.2495 8.12306 3.6226 7.74996 4.08283 7.74996Z"
        fill="#9DA4AE"
      />
      <path
        d="M15.7495 6.91012C15.7495 6.44988 15.3764 6.07678 14.9162 6.07678C14.4559 6.07678 14.0828 6.44988 14.0828 6.91012V6.9176C14.0828 7.37784 14.4559 7.75093 14.9162 7.75093C15.3764 7.75093 15.7495 7.37784 15.7495 6.9176V6.91012Z"
        fill="#9DA4AE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.23503 0.933678C10.441 0.37041 11.9924 0.041626 13.6662 0.041626C14.5994 0.041626 15.4916 0.143765 16.3057 0.330233L16.3543 0.341351C16.8101 0.445455 17.1814 0.530263 17.5882 0.852156C17.8315 1.04472 18.102 1.38419 18.2354 1.66441C18.4589 2.13397 18.4585 2.5985 18.4579 3.17365L18.4578 12.2383C18.4578 13.5443 17.132 14.3019 16.0266 14.0487C15.3079 13.8841 14.5095 13.7916 13.6662 13.7916C12.1448 13.7916 10.7789 14.0922 9.76399 14.5662C8.55798 15.1295 7.00659 15.4583 5.33284 15.4583C4.39965 15.4583 3.50742 15.3562 2.69331 15.1697L2.64467 15.1586C2.18893 15.0545 1.81766 14.9697 1.41085 14.6478C1.16748 14.4552 0.896975 14.1157 0.763603 13.8355C0.540111 13.3659 0.540562 12.9014 0.541122 12.3263L0.541178 3.2616C0.541178 1.95561 1.86701 1.19806 2.97238 1.45124C3.69108 1.61585 4.48951 1.70829 5.33284 1.70829C6.85422 1.70829 8.22014 1.40768 9.23503 0.933678ZM13.6662 1.29163C12.1448 1.29163 10.7789 1.59224 9.76399 2.06624C8.55798 2.62951 7.00659 2.95829 5.33284 2.95829C4.39964 2.95829 3.50742 2.85615 2.69331 2.66969C2.19873 2.55641 1.79118 2.92621 1.79118 3.2616L1.79118 12.2383C1.79118 12.9404 1.80352 13.1118 1.89228 13.2983C1.94343 13.4058 2.09315 13.5937 2.18648 13.6675C2.35564 13.8014 2.46523 13.8351 2.97238 13.9512C3.69108 14.1159 4.48951 14.2083 5.33284 14.2083C6.85422 14.2083 8.22014 13.9077 9.23503 13.4337C10.441 12.8704 11.9924 12.5416 13.6662 12.5416C14.5994 12.5416 15.4916 12.6438 16.3057 12.8302C16.8003 12.9435 17.2078 12.5737 17.2078 12.2383V3.2616C17.2078 2.55953 17.1955 2.38809 17.1067 2.20162C17.0556 2.09415 16.9059 1.90626 16.8125 1.83241C16.6434 1.69855 16.5338 1.66484 16.0266 1.54868C15.3079 1.38407 14.5095 1.29163 13.6662 1.29163Z"
        fill="#9DA4AE"
      />
      <path
        d="M5.33283 16.7083C3.81146 16.7083 2.44554 16.4077 1.43065 15.9337C1.1179 15.7876 0.745953 15.9227 0.599883 16.2355C0.453814 16.5482 0.588934 16.9202 0.901682 17.0662C2.10769 17.6295 3.65909 17.9583 5.33283 17.9583C7.00658 17.9583 8.55797 17.6295 9.76398 17.0662C10.7789 16.5922 12.1448 16.2916 13.6662 16.2916C15.1875 16.2916 16.5535 16.5922 17.5683 17.0662C17.8811 17.2123 18.253 17.0772 18.3991 16.7644C18.5452 16.4517 18.4101 16.0797 18.0973 15.9337C16.8913 15.3704 15.3399 15.0416 13.6662 15.0416C11.9924 15.0416 10.441 15.3704 9.23502 15.9337C8.22013 16.4077 6.8542 16.7083 5.33283 16.7083Z"
        fill="#9DA4AE"
      />
    </svg>
  );
};
export const Percentage = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1083 0.891432C15.3524 1.13551 15.3524 1.53124 15.1083 1.77532L1.77495 15.1086C1.53087 15.3527 1.13514 15.3527 0.891066 15.1086C0.646988 14.8646 0.646988 14.4688 0.891066 14.2248L14.2244 0.891432C14.4685 0.647355 14.8642 0.647355 15.1083 0.891432Z"
        fill="#9DA4AE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.50126 1.50163C2.55893 0.443957 4.27375 0.443957 5.33142 1.50163C6.38909 2.5593 6.38909 4.27412 5.33142 5.33179C4.27375 6.38946 2.55893 6.38946 1.50126 5.33179C0.44359 4.27412 0.44359 2.5593 1.50126 1.50163ZM4.44754 2.38551C3.87802 1.816 2.95466 1.816 2.38514 2.38551C1.81563 2.95502 1.81563 3.87839 2.38514 4.4479C2.95466 5.01742 3.87802 5.01742 4.44754 4.4479C5.01705 3.87839 5.01705 2.95502 4.44754 2.38551Z"
        fill="#9DA4AE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4981 10.6683C13.4404 9.61062 11.7256 9.61062 10.6679 10.6683C9.61026 11.726 9.61026 13.4408 10.6679 14.4985C11.7256 15.5561 13.4404 15.5561 14.4981 14.4985C15.5558 13.4408 15.5558 11.726 14.4981 10.6683ZM11.5518 11.5522C12.1213 10.9827 13.0447 10.9827 13.6142 11.5522C14.1837 12.1217 14.1837 13.0451 13.6142 13.6146C13.0447 14.1841 12.1213 14.1841 11.5518 13.6146C10.9823 13.0451 10.9823 12.1217 11.5518 11.5522Z"
        fill="#9DA4AE"
      />
    </svg>
  );
};
export const Metals = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1254 0.666626C10.1254 0.321448 9.84557 0.041626 9.5004 0.041626C9.15522 0.041626 8.8754 0.321448 8.8754 0.666626V2.33329C8.8754 2.67847 9.15522 2.95829 9.5004 2.95829C9.84557 2.95829 10.1254 2.67847 10.1254 2.33329V0.666626Z"
        fill="#9DA4AE"
      />
      <path
        d="M6.19234 1.47468C5.94826 1.23061 5.55253 1.23061 5.30845 1.47468C5.06438 1.71876 5.06438 2.11449 5.30845 2.35857L6.55845 3.60857C6.80253 3.85265 7.19826 3.85265 7.44234 3.60857C7.68642 3.36449 7.68642 2.96876 7.44234 2.72468L6.19234 1.47468Z"
        fill="#9DA4AE"
      />
      <path
        d="M13.6923 2.35857C13.9364 2.11449 13.9364 1.71876 13.6923 1.47468C13.4483 1.23061 13.0525 1.23061 12.8085 1.47468L11.5585 2.72468C11.3144 2.96876 11.3144 3.36449 11.5585 3.60857C11.8025 3.85265 12.1983 3.85265 12.4423 3.60857L13.6923 2.35857Z"
        fill="#9DA4AE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.52581 5.04163H9.47499C9.08 5.04162 8.7448 5.04161 8.46674 5.06543C8.1723 5.09066 7.89579 5.14536 7.62709 5.28026C7.40155 5.39349 7.19659 5.54383 7.02041 5.72482C6.81117 5.93977 6.67403 6.18688 6.55826 6.46087C6.44856 6.72051 6.3429 7.0429 6.21777 7.42468L5.92423 8.32018C5.77194 8.78464 5.63698 9.19625 5.57777 9.5346C5.5144 9.89664 5.51152 10.3101 5.77507 10.682C6.04057 11.0566 6.4332 11.1873 6.79653 11.2415C7.13307 11.2917 7.56161 11.2917 8.04165 11.2916H10.9592C11.4392 11.2917 11.8677 11.2917 12.2043 11.2415C12.5676 11.1873 12.9602 11.0566 13.2257 10.682C13.4893 10.3101 13.4864 9.89664 13.423 9.5346C13.3638 9.19625 13.2289 8.78464 13.0766 8.32018L12.783 7.42472C12.6579 7.04292 12.5522 6.72052 12.4425 6.46087C12.3268 6.18688 12.1896 5.93977 11.9804 5.72482C11.8042 5.54383 11.5992 5.39349 11.3737 5.28026C11.105 5.14536 10.8285 5.09066 10.5341 5.06543C10.256 5.04161 9.9208 5.04162 9.52581 5.04163ZM8.18793 6.39738C8.26222 6.36008 8.36553 6.32869 8.57346 6.31087C8.79184 6.29216 9.07318 6.29163 9.5004 6.29163C9.92762 6.29163 10.209 6.29216 10.4273 6.31087C10.6353 6.32869 10.7386 6.36008 10.8129 6.39738C10.9132 6.44777 11.0052 6.51503 11.0847 6.59673C11.1445 6.65822 11.2078 6.75031 11.2911 6.94737C11.3782 7.15344 11.468 7.42599 11.603 7.83772L11.875 8.66759C12.0453 9.18699 12.15 9.51156 12.1917 9.75009C12.2114 9.8621 12.2102 9.92125 12.2067 9.94866C12.2063 9.9524 12.2058 9.95533 12.2054 9.95754L12.2018 9.95936C12.1805 9.96976 12.1288 9.98896 12.0199 10.0052C11.7868 10.04 11.4534 10.0416 10.9141 10.0416H8.08671C7.54736 10.0416 7.214 10.04 6.98091 10.0052C6.87201 9.98896 6.82027 9.96976 6.79902 9.95936L6.79545 9.95754L6.7948 9.95387L6.79406 9.94866C6.79061 9.92125 6.78945 9.8621 6.80905 9.75009C6.8508 9.51156 6.95555 9.18699 7.1258 8.66759L7.39782 7.83772C7.53277 7.42599 7.62264 7.15344 7.7097 6.94737C7.79297 6.75031 7.85625 6.65822 7.91611 6.59673C7.99563 6.51503 8.08756 6.44777 8.18793 6.39738Z"
        fill="#9DA4AE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1093 11.7083H14.0585C13.6635 11.7083 13.3283 11.7083 13.0502 11.7321C12.7558 11.7573 12.4793 11.812 12.2106 11.9469C11.985 12.0602 11.7801 12.2105 11.6039 12.3915C11.3946 12.6064 11.2575 12.8535 11.1417 13.1275C11.032 13.3872 10.9264 13.7096 10.8012 14.0914L10.5077 14.9868C10.3554 15.4513 10.2204 15.8629 10.1612 16.2013C10.0979 16.5633 10.095 16.9768 10.3585 17.3486C10.624 17.7232 11.0167 17.854 11.38 17.9082C11.7165 17.9584 12.1451 17.9583 12.6251 17.9583H15.5426C16.0226 17.9583 16.4512 17.9584 16.7877 17.9082C17.1511 17.854 17.5437 17.7232 17.8092 17.3486C18.0727 16.9768 18.0699 16.5633 18.0065 16.2013C17.9473 15.8629 17.8123 15.4513 17.66 14.9868L17.3665 14.0914C17.2414 13.7096 17.1357 13.3872 17.026 13.1275C16.9102 12.8535 16.7731 12.6064 16.5639 12.3915C16.3877 12.2105 16.1827 12.0602 15.9572 11.9469C15.6885 11.812 15.412 11.7573 15.1175 11.7321C14.8395 11.7083 14.5043 11.7083 14.1093 11.7083ZM12.7714 13.064C12.8457 13.0268 12.949 12.9954 13.1569 12.9775C13.3753 12.9588 13.6566 12.9583 14.0839 12.9583C14.5111 12.9583 14.7924 12.9588 15.0108 12.9775C15.2187 12.9954 15.322 13.0268 15.3963 13.064C15.4967 13.1144 15.5886 13.1817 15.6681 13.2634C15.728 13.3249 15.7913 13.417 15.8746 13.614C15.9616 13.8201 16.0515 14.0927 16.1864 14.5044L16.4585 15.3343C16.6287 15.8537 16.7335 16.1782 16.7752 16.4168C16.7948 16.5288 16.7936 16.5879 16.7902 16.6153C16.7897 16.6191 16.7892 16.622 16.7888 16.6242L16.7852 16.626C16.764 16.6364 16.7122 16.6556 16.6034 16.6719C16.3703 16.7066 16.0369 16.7083 15.4976 16.7083H12.6702C12.1308 16.7083 11.7975 16.7066 11.5644 16.6719C11.4555 16.6556 11.4037 16.6364 11.3825 16.626L11.3789 16.6242C11.3785 16.622 11.378 16.6191 11.3775 16.6153C11.3741 16.5879 11.3729 16.5288 11.3925 16.4168C11.4343 16.1782 11.539 15.8537 11.7093 15.3343L11.9813 14.5044C12.1162 14.0927 12.2061 13.8201 12.2932 13.614C12.3764 13.417 12.4397 13.3249 12.4996 13.2634C12.5791 13.1817 12.671 13.1144 12.7714 13.064Z"
        fill="#9DA4AE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.89179 11.7083H4.9426C5.33759 11.7083 5.67279 11.7083 5.95085 11.7321C6.24529 11.7573 6.5218 11.812 6.7905 11.9469C7.01604 12.0602 7.221 12.2105 7.39718 12.3915C7.60642 12.6064 7.74356 12.8535 7.85933 13.1275C7.96903 13.3872 8.0747 13.7096 8.19984 14.0914L8.49336 14.9868C8.64565 15.4513 8.78061 15.8629 8.83983 16.2013C8.90319 16.5633 8.90608 16.9768 8.64252 17.3486C8.37702 17.7232 7.98439 17.854 7.62106 17.9082C7.28452 17.9584 6.85598 17.9583 6.37595 17.9583H3.45844C2.97841 17.9583 2.54987 17.9584 2.21332 17.9082C1.84999 17.854 1.45736 17.7232 1.19187 17.3486C0.92831 16.9768 0.931197 16.5633 0.994561 16.2013C1.05378 15.8629 1.18874 15.4513 1.34103 14.9868L1.63455 14.0914C1.75969 13.7096 1.86535 13.3872 1.97506 13.1275C2.09082 12.8535 2.22796 12.6064 2.4372 12.3915C2.61338 12.2105 2.81834 12.0602 3.04389 11.9469C3.31259 11.812 3.58909 11.7573 3.88354 11.7321C4.1616 11.7083 4.4968 11.7083 4.89179 11.7083ZM3.99026 12.9775C3.78232 12.9954 3.67902 13.0268 3.60472 13.064C3.50435 13.1144 3.41243 13.1817 3.33291 13.2634C3.27304 13.3249 3.20976 13.417 3.1265 13.614C3.03943 13.8201 2.94957 14.0927 2.81461 14.5044L2.54259 15.3343C2.37234 15.8537 2.26759 16.1782 2.22585 16.4168C2.20624 16.5288 2.20741 16.5879 2.21085 16.6153C2.21132 16.6191 2.21181 16.622 2.21224 16.6242L2.21582 16.626C2.23706 16.6364 2.2888 16.6556 2.3977 16.6719C2.6308 16.7066 2.96415 16.7083 3.5035 16.7083H6.33088C6.87023 16.7083 7.20359 16.7066 7.43668 16.6719C7.54558 16.6556 7.59732 16.6364 7.61857 16.626L7.62214 16.6242C7.62257 16.622 7.62306 16.6191 7.62353 16.6153C7.62698 16.5879 7.62814 16.5288 7.60854 16.4168C7.56679 16.1782 7.46205 15.8537 7.29179 15.3343L7.01978 14.5044C6.88482 14.0927 6.79495 13.8201 6.70789 13.614C6.62463 13.417 6.56134 13.3249 6.50148 13.2634C6.42196 13.1817 6.33004 13.1144 6.22966 13.064C6.15537 13.0268 6.05206 12.9954 5.84413 12.9775C5.62575 12.9588 5.34441 12.9583 4.91719 12.9583C4.48997 12.9583 4.20863 12.9588 3.99026 12.9775Z"
        fill="#9DA4AE"
      />
    </svg>
  );
};

export const AccountVerified = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="191"
      height="168"
      viewBox="0 0 191 168"
      fill="currentColor"
      {...props}
    >
      <path
        d="M60.333 167.312C34.5383 167.312 20.3309 167.312 10.6601 158.803C0.989258 150.301 0.989258 137.762 0.989258 115V53C0.989258 30.2382 0.989258 17.7065 10.6601 9.19698C20.3221 0.6875 34.5382 0.6875 60.3329 0.6875H86.708C112.503 0.6875 126.71 0.6875 136.381 9.19698C146.052 17.6987 146.052 30.2382 146.052 53V60.75C146.052 63.9585 143.098 66.5625 139.458 66.5625C135.818 66.5625 132.864 63.9585 132.864 60.75V53C132.864 32.7129 132.864 22.5268 127.062 17.4276C121.251 12.3126 109.707 12.3125 86.708 12.3125H60.333C37.334 12.3125 25.7814 12.3126 19.9789 17.4276C14.1768 22.5345 14.1768 32.717 14.1768 52.9964V115C14.1768 135.287 14.1768 145.473 19.9789 150.572C25.7902 155.687 37.334 155.688 60.333 155.688C63.9728 155.688 66.9268 158.292 66.9268 161.5C66.9268 164.708 63.9728 167.312 60.333 167.312Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M95.1477 167.312C86.8571 167.312 80.1143 161.368 80.1143 154.06C80.1143 144.326 87.5959 136.049 98.3218 133.894L114.182 130.167L112.951 124.788C112.432 122.401 111.386 119.983 110.27 117.426C108.995 114.496 107.685 111.466 106.955 108.11L106.894 107.785C106.709 106.568 106.489 105.049 106.489 103.383C106.489 89.4946 119.308 78.1951 135.062 78.1951C150.817 78.1951 163.635 89.4946 163.635 103.383C163.635 105.165 163.477 106.723 163.16 108.157C162.439 111.474 161.13 114.504 159.855 117.434L159.804 117.55C158.715 120.065 157.684 122.445 157.191 124.734L155.942 130.175L171.803 133.902C182.528 136.057 190.01 144.334 190.01 154.068C190.01 161.376 183.267 167.32 174.977 167.32L95.1477 167.312ZM122.737 140.188L101.32 145.209C96.5987 146.132 93.3018 149.774 93.3018 154.06C93.3018 154.959 94.1278 155.688 95.1477 155.688H174.977C175.997 155.688 176.823 154.959 176.823 154.06C176.823 149.774 173.526 146.132 168.804 145.209L168.532 145.147L147.388 140.18L122.737 140.188ZM127.272 128.562H142.861L144.25 122.487C144.961 119.202 146.271 116.189 147.536 113.276C148.653 110.711 149.71 108.281 150.211 105.94C150.369 105.22 150.448 104.398 150.448 103.383C150.448 95.9038 143.546 89.8201 135.062 89.8201C126.578 89.8201 119.677 95.9038 119.677 103.383C119.677 104.235 119.817 105.212 119.949 106.088C120.468 108.382 121.496 110.761 122.586 113.272L122.609 113.323C123.868 116.229 125.167 119.228 125.893 122.549L127.272 128.562Z"
        fill="currentColor"
      />
      <path
        d="M62.1884 74.3122H62.5309L62.5138 74.3198C64.826 74.3198 66.9794 73.2428 68.1751 71.4835C74.4875 62.168 88.1144 46.1797 97.8204 42.9402C101.232 41.801 102.946 38.4453 101.654 35.446C100.361 32.439 96.5547 30.9279 93.1524 32.0671C81.3364 36.0119 69.4502 49.1091 62.5927 57.7659C57.6958 52.8601 53.168 52.3564 51.5328 52.3564C47.893 52.3564 44.939 54.9604 44.939 58.1689C44.939 61.1216 47.4268 63.5628 50.6622 63.9348C51.1985 64.1673 53.6517 65.4771 56.5442 70.9564C57.5816 72.9094 59.7531 74.2037 62.1884 74.3122Z"
        fill="currentColor"
      />
      <path
        d="M77.9163 105.312H42.7497C39.1099 105.312 36.1559 102.708 36.1559 99.5C36.1559 96.2915 39.1099 93.6875 42.7497 93.6875H77.9163C81.5561 93.6875 84.5101 96.2915 84.5101 99.5C84.5101 102.708 81.5561 105.312 77.9163 105.312Z"
        fill="currentColor"
      />
      <path
        d="M42.7497 128.562H77.9163C81.5561 128.562 84.5101 125.958 84.5101 122.75C84.5101 119.542 81.5561 116.938 77.9163 116.938H42.7497C39.1099 116.938 36.1559 119.542 36.1559 122.75C36.1559 125.958 39.1099 128.562 42.7497 128.562Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Edit = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      width="14"
      height="14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.8477 1.87868C19.6761 0.707109 17.7766 0.707105 16.605 1.87868L2.44744 16.0363C2.02864 16.4551 1.74317 16.9885 1.62702 17.5692L1.03995 20.5046C0.760062 21.904 1.9939 23.1379 3.39334 22.858L6.32868 22.2709C6.90945 22.1548 7.44285 21.8693 7.86165 21.4505L22.0192 7.29289C23.1908 6.12132 23.1908 4.22183 22.0192 3.05025L20.8477 1.87868ZM18.0192 3.29289C18.4098 2.90237 19.0429 2.90237 19.4335 3.29289L20.605 4.46447C20.9956 4.85499 20.9956 5.48815 20.605 5.87868L17.9334 8.55027L15.3477 5.96448L18.0192 3.29289ZM13.9334 7.3787L3.86165 17.4505C3.72205 17.5901 3.6269 17.7679 3.58818 17.9615L3.00111 20.8968L5.93645 20.3097C6.13004 20.271 6.30784 20.1759 6.44744 20.0363L16.5192 9.96448L13.9334 7.3787Z"
          fill="#0F0F0F"
        ></path>{" "}
      </g>
    </svg>
  );
};
export const Edit2 = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.49935 11.1667V11.6667H1.99935H2.94935H3.15646L3.3029 11.5202L9.81957 5.00355L10.1731 4.65L9.81957 4.29645L8.86957 3.34645L8.51602 2.99289L8.16246 3.34645L1.6458 9.86311L1.49935 10.0096V10.2167V11.1667ZM10.9968 1.23719L11.0029 1.24389L11.0093 1.25035L11.926 2.18369L11.9351 2.19305L11.9448 2.20191C12.0205 2.27128 12.0722 2.34895 12.1054 2.43935C12.1476 2.55397 12.1663 2.66183 12.166 2.76533V2.76667C12.166 2.88603 12.1458 2.99563 12.1069 3.09878C12.0736 3.18709 12.0181 3.27473 11.9303 3.36194L11.9291 3.36311L3.29224 12H1.16602V9.87405L9.81102 1.24542C9.90075 1.16456 9.99637 1.1045 10.099 1.0621C10.1988 1.02086 10.3031 1 10.416 1C10.529 1 10.6384 1.0209 10.7474 1.06441C10.8441 1.10299 10.9258 1.1594 10.9968 1.23719Z"
        fill="black"
        stroke="currentColor"
      />
    </svg>
  );
};
export const Delete = () => {
  return (
    <svg
      width="10"
      height="13"
      viewBox="4 4 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M10 12V17"
          stroke="#000000"
          strokeWidth="0.696"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M14 12V17"
          stroke="#000000"
          strokeWidth="0.696"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M4 7H20"
          stroke="#000000"
          strokeWidth="0.696"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{" "}
        <path
          d="M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10"
          stroke="#000000"
          strokeWidth="0.696"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
          stroke="#000000"
          strokeWidth="0.696"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{" "}
      </g>
    </svg>
  );
};

export const Transaction = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      version="1.1"
      height="18"
      width="18"
      {...props}
    >
      <path d="M318.002 562.435c14.735 14.742 38.636 14.742 53.374 0 14.739-14.733 14.739-38.631 0-53.374l-157.952-157.955h684.784c20.842 0 37.742-16.896 37.742-37.74 0-20.842-16.898-37.738-37.742-37.738h-684.784l157.952-157.954c14.739-14.74 14.739-38.636 0-53.375s-38.635-14.74-53.374 0l-222.379 222.383c-7.373 7.371-11.054 17.025-11.054 26.686 0 9.657 3.685 19.317 11.054 26.687l222.379 222.383z" />
      <path d="M933.185 687.497c-0.439-1.085-0.94-2.148-1.483-3.197-0.023-0.050-0.045-0.101-0.070-0.15-1.726-3.29-3.974-6.372-6.737-9.137l-222.38-222.386c-14.74-14.74-38.636-14.74-53.375 0-7.372 7.372-11.055 17.028-11.055 26.687 0 9.657 3.687 19.319 11.055 26.687l157.952 157.954h-684.783c-20.842 0-37.738 16.896-37.738 37.74 0 20.842 16.896 37.738 37.738 37.738h684.784l-157.954 157.954c-7.373 7.371-11.055 17.025-11.055 26.686 0 9.657 3.687 19.322 11.054 26.687 14.74 14.74 38.636 14.74 53.375 0l222.383-222.375c11.054-11.049 13.819-27.254 8.29-40.889z" />
    </svg>
  );
};

export const TransactionLight = () => {
  return (
    <svg
      fill="#ffffff"
      width="15px"
      height="15px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#ffffff"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path d="M17.0020048,14 C17.5542895,14 18.0020048,14.4477153 18.0020048,15 C18.0020048,15.5128358 17.6159646,15.9355072 17.1186259,15.9932723 L17.0020048,16 L5.41700475,16 L8.70911154,19.2928932 C9.0695955,19.6533772 9.09732503,20.2206082 8.79230014,20.6128994 L8.70911154,20.7071068 C8.34862757,21.0675907 7.78139652,21.0953203 7.38910531,20.7902954 L7.29489797,20.7071068 L2.29489797,15.7071068 C1.69232289,15.1045317 2.07433707,14.0928192 2.88837381,14.0059833 L3.00200475,14 L17.0020048,14 Z M16.6128994,3.20970461 L16.7071068,3.29289322 L21.7071068,8.29289322 C22.3096819,8.8954683 21.9276677,9.9071808 21.1136309,9.9940167 L21,10 L7,10 C6.44771525,10 6,9.5522847 6,9 C6,8.48716416 6.38604019,8.06449284 6.88337887,8.00672773 L7,8 L18.585,8 L15.2928932,4.70710678 C14.9324093,4.34662282 14.9046797,3.77939176 15.2097046,3.38710056 L15.2928932,3.29289322 C15.6533772,2.93240926 16.2206082,2.90467972 16.6128994,3.20970461 Z" />{" "}
      </g>
    </svg>
  );
};
export const Material = () => {
  return (
    <svg
      fill="#000000"
      width="20px"
      height="20px"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M25.89,7.88V2c0-.41-.34-.75-.75-.75H7.39c-.41,0-.75,.34-.75,.75V7.87l-2.87,3.37s-.03,.06-.05,.09c-.03,.04-.06,.09-.08,.14-.02,.05-.02,.1-.03,.15,0,.03-.02,.07-.02,.1V30c0,.41,.34,.75,.75,.75H22.62s0,0,0,0c0,0,0,0,0,0,.09,0,.19-.02,.28-.06l5.03-2.05c.28-.12,.47-.39,.47-.69V11.73c0-.15-.05-.3-.13-.43l-2.38-3.42Zm-3.64,3.1H5.97l1.68-1.98H23.73l-1.48,1.98ZM8.14,2.75H24.39V7.5H8.14V2.75Zm-3.05,9.73H21.87V29.25H5.1V12.48Zm21.8,14.97l-3.53,1.44V11.98l1.84-2.45,1.69,2.43v15.49Z"></path>
      </g>
    </svg>
  );
};
export const Amount = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      width="15px"
      height="15px"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M8.5 14.6667C8.5 15.9553 9.54467 17 10.8333 17H13C14.3807 17 15.5 15.8807 15.5 14.5C15.5 13.1193 14.3807 12 13 12H11C9.61929 12 8.5 10.8807 8.5 9.5C8.5 8.11929 9.61929 7 11 7H13.1667C14.4553 7 15.5 8.04467 15.5 9.33333M12 5.5V7M12 17V18.5M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
          stroke="#ffffff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{" "}
      </g>
    </svg>
  );
};
export const Details = () => {
  return (
    <svg
      viewBox="0 0 1024 1024"
      className="icon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#ffffff"
      height="15"
      width="15"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M320 89.6h640v76.8H320V89.6z m0 768h640v76.8H320v-76.8z m-256-768h128v76.8H64V89.6z m256 384h640v76.8H320V473.6z m-256 0h128v76.8H64V473.6z m0 384h128v76.8H64v-76.8z"
          fill="#ffffff"
        ></path>
      </g>
    </svg>
  );
};
export const Treatment = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="svg-icon"
      fill="#ffffff"
      height="18"
      width="18"
      viewBox="0 0 1024 1024"
      version="1.1"
    >
      <path d="M918.2 210.3c-22.9-53-59.5-86.3-108.8-99-56.5-14.5-126.9-0.8-209.3 40.7-37 18.6-67.8 38.7-86.2 51.4C472.5 169.2 363.5 90 258 105.1c-57.8 8.2-104.9 42.6-140 102.2-36.6 62.2-45.8 131.1-26.5 199.4 16.3 57.5 52 111.6 100.7 152.3 1.9 1.6 3.8 3.1 5.7 4.7 2.3 23.9 7.3 49.9 15.2 78 15.1 53.7 35.1 95.1 35.9 96.9 1.3 2.7 3 5 5 7.1-17 19.6-27.3 45.1-27.3 73.1 0 61.6 50 111.6 111.6 111.6s111.6-50 111.6-111.6S399.8 707 338.2 707c-14.1 0-27.7 2.7-40.1 7.5-1.2-2.6-19.3-40.8-32.6-88.5-2.4-8.5-4.4-16.7-6.2-24.7 58.1 25.5 115.2 22.6 154.3-11 20.8-17.9 34.2-43 37.7-70.7 3.3-25.6-1.9-52.3-14.5-75.2-13.1-23.7-32.8-41.4-57-51.3-26.5-10.8-57.2-11.4-88.8-1.7-38.3 11.8-65.4 35.5-80.7 70.6-4 9.3-7.2 19.2-9.4 29.9-26.8-29.3-46.5-63.9-56.7-99.9-15.2-53.6-7.9-107.8 21-156.8 26.6-45.1 59.4-69.9 100.5-75.8 105-15.1 226.8 97.9 228 99 9.8 9.2 24.8 9.9 35.4 1.7 0.4-0.3 41.1-31.6 95.6-59.1 69.3-34.9 128.4-47.6 171.1-36.6 32.5 8.4 56.1 30.5 72.2 67.8 26.4 60.9 28.7 122.6 6.8 183.4-18 50.2-52.4 100.3-102.1 149.1-86.9 85.3-191.2 136.4-192.2 136.9-13.6 6.6-19.2 22.9-12.7 36.5 6.6 13.6 22.9 19.3 36.5 12.7 4.5-2.2 112.4-55 205.7-146.2 128.2-125.4 165.6-261.7 108.2-394.3zM260.4 483.6c8.7-20 24-33.1 46.6-40.1 51.6-15.9 74.5 13.7 81.9 27.2 12.8 23.1 13.1 57.4-11 78.1-19.8 17-45.7 16.3-64.1 12.8-20.2-3.9-41.7-13.2-62.6-26.8 0.1-20.2 3.1-37.4 9.2-51.2z" />
    </svg>
  );
};
export const Currency = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      width="18px"
      height="18px"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M8.5 14.6667C8.5 15.9553 9.54467 17 10.8333 17H13C14.3807 17 15.5 15.8807 15.5 14.5C15.5 13.1193 14.3807 12 13 12H11C9.61929 12 8.5 10.8807 8.5 9.5C8.5 8.11929 9.61929 7 11 7H13.1667C14.4553 7 15.5 8.04467 15.5 9.33333M12 5.5V7M12 17V18.5M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{" "}
      </g>
    </svg>
  );
};

export const Date = ({ fill = "none", width = "20px", height = "20px" }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill={"none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M20 10V7C20 5.89543 19.1046 5 18 5H6C4.89543 5 4 5.89543 4 7V10M20 10V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V10M20 10H4M8 3V7M16 3V7"
          stroke={fill}
          strokeWidth="2"
          strokeLinecap="round"
        ></path>{" "}
        <rect x="6" y="12" width="3" height="3" rx="0.5" fill="none"></rect>{" "}
        <rect x="10.5" y="12" width="3" height="3" rx="0.5" fill="none"></rect>{" "}
        <rect x="15" y="12" width="3" height="3" rx="0.5" fill="none"></rect>{" "}
      </g>
    </svg>
  );
};
export const Description = () => {
  return (
    <svg
      viewBox="0 0 512 512"
      width="15px"
      height="15px"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      stroke="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          fill="var(--ci-primary-color, #ffffff)"
          d="M334.627,16H48V496H472V153.373ZM440,166.627V168H320V48h1.373ZM80,464V48H288V200H440V464Z"
          className="ci-primary"
        ></path>{" "}
        <rect
          width="224"
          height="32"
          x="136"
          y="296"
          fill="var(--ci-primary-color, #ffffff)"
          className="ci-primary"
        ></rect>{" "}
        <rect
          width="224"
          height="32"
          x="136"
          y="376"
          fill="var(--ci-primary-color, #ffffff)"
          className="ci-primary"
        ></rect>{" "}
      </g>
    </svg>
  );
};

export const Businesses = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20"
      width="20"
      viewBox="0 0 24 24"
      fill="#ffffff"
    >
      <path
        d="M7.5 11H4.6C4.03995 11 3.75992 11 3.54601 11.109C3.35785 11.2049 3.20487 11.3578 3.10899 11.546C3 11.7599 3 12.0399 3 12.6V21M16.5 11H19.4C19.9601 11 20.2401 11 20.454 11.109C20.6422 11.2049 20.7951 11.3578 20.891 11.546C21 11.7599 21 12.0399 21 12.6V21M16.5 21V6.2C16.5 5.0799 16.5 4.51984 16.282 4.09202C16.0903 3.71569 15.7843 3.40973 15.408 3.21799C14.9802 3 14.4201 3 13.3 3H10.7C9.57989 3 9.01984 3 8.59202 3.21799C8.21569 3.40973 7.90973 3.71569 7.71799 4.09202C7.5 4.51984 7.5 5.0799 7.5 6.2V21M22 21H2M11 7H13M11 11H13M11 15H13"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Request = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="svg-icon"
      height="20"
      width="20"
      viewBox="0 0 1024 1024"
      version="1.1"
    >
      <path d="M446.603636 873.053091a34.909091 34.909091 0 0 1 0 69.818182H189.556364c-85.387636 0-154.647273-69.003636-154.647273-154.181818V165.818182C34.909091 80.64 104.168727 11.636364 189.556364 11.636364H714.007273c85.387636 0 154.647273 69.003636 154.647272 154.181818v251.415273a34.909091 34.909091 0 1 1-69.818181 0V165.818182c0-46.545455-37.934545-84.363636-84.829091-84.363637H189.556364C142.661818 81.454545 104.727273 119.249455 104.727273 165.818182v622.871273c0 46.545455 37.934545 84.363636 84.829091 84.363636H446.603636z m-187.554909-598.155636a34.909091 34.909091 0 0 1 0-69.818182h383.162182a34.909091 34.909091 0 0 1 0 69.818182H259.025455z m0 190.836363a34.909091 34.909091 0 0 1 0-69.818182h383.162182a34.909091 34.909091 0 0 1 0 69.818182H259.025455z m0 190.766546a34.909091 34.909091 0 0 1 0-69.818182h143.685818a34.909091 34.909091 0 0 1 0 69.818182h-143.685818z m489.821091 351.115636c-141.730909 0-256.651636-114.501818-256.651636-255.790545s114.920727-255.790545 256.651636-255.790546c141.730909 0 256.651636 114.501818 256.651637 255.767273 0 141.312-114.920727 255.813818-256.651637 255.813818z m0-60.509091c108.357818 0 196.142545-87.458909 196.142546-195.281454s-87.784727-195.281455-196.142546-195.281455c-108.357818 0-196.142545 87.458909-196.142545 195.258182 0 107.845818 87.784727 195.304727 196.142545 195.304727z m-46.08-155.694545l133.608727-133.026909a30.254545 30.254545 0 0 1 42.705455 42.891636l-154.530909 153.832727a30.254545 30.254545 0 0 1-42.24 0.418909l-85.364364-81.524363a30.254545 30.254545 0 0 1 41.797818-43.752728l64 61.137455z" />
    </svg>
  );
};

export const WeighingScale = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      fill="#ffffff"
      version="1.1"
      id="Layer_1"
      height="18"
      width="18"
      viewBox="0 0 92 92"
      enableBackground="new 0 0 92 92"
      xmlSpace="preserve"
    >
      <path
        id="XMLID_1594_"
        d="M72.8,24.9L53.4,66.7c-1.7,4.3-4.7,6.8-8,6.8c-2.7,0-5-1.4-6.3-3.6c-1.4-2.6-1.3-5.8,0.4-8.5v0l25.4-40.7  c1.3-2,3.9-2.7,6-1.6C73,20.2,73.8,22.7,72.8,24.9z M79.6,37c-1.5-1.6-4-1.7-5.7-0.2c-1.6,1.5-1.7,4-0.2,5.7  C80.3,49.7,84,59.1,84,69c0,2.2,1.8,4,4,4s4-1.8,4-4C92,57.1,87.6,45.7,79.6,37z M49.2,30.4c2.2,0.2,4.1-1.4,4.3-3.6  c0.2-2.2-1.4-4.1-3.6-4.3c-1.3-0.1-2.6-0.2-3.9-0.2c-25.4,0-46,21-46,46.8c0,2.2,1.8,4,4,4s4-1.8,4-4c0-21.4,17-38.8,38-38.8  C47.1,30.2,48.2,30.3,49.2,30.4z"
      />
    </svg>
  );
};

export const Weight = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      height="18"
      width="18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M12.0002 6L11.0064 9M16.5 6C17.8978 6 18.5967 6 19.1481 6.22836C19.8831 6.53284 20.4672 7.11687 20.7716 7.85195C21 8.40326 21 9.10218 21 10.5V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V10.5C3 9.10218 3 8.40326 3.22836 7.85195C3.53284 7.11687 4.11687 6.53284 4.85195 6.22836C5.40326 6 6.10218 6 7.5 6M10 17H14M10.5415 3H13.4588C14.5397 3 15.0802 3 15.4802 3.18541C16.0136 3.43262 16.4112 3.90199 16.5674 4.46878C16.6845 4.89387 16.5957 5.42698 16.418 6.4932C16.2862 7.28376 16.2203 7.67904 16.0449 7.98778C15.8111 8.39944 15.4388 8.71481 14.9943 8.87778C14.661 9 14.2602 9 13.4588 9H10.5415C9.74006 9 9.33933 9 9.00596 8.87778C8.56146 8.71481 8.18918 8.39944 7.95536 7.98778C7.77999 7.67904 7.71411 7.28376 7.58235 6.4932C7.40465 5.42698 7.3158 4.89387 7.43291 4.46878C7.58906 3.90199 7.98669 3.43262 8.52009 3.18541C8.92014 3 9.46061 3 10.5415 3Z"
          stroke="#ffffff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
    </svg>
  );
};

export const Brand = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      width="18"
      fill="#ffffff"
      className="svg-icon"
      viewBox="0 0 1024 1024"
      version="1.1"
    >
      <path d="M512 64C264.96 64 64 264.96 64 512s200.96 448 448 448 448-200.96 448-448S759.04 64 512 64zM512 896C300.256 896 128 723.744 128 512 128 300.256 300.256 128 512 128c211.744 0 384 172.256 384 384C896 723.744 723.744 896 512 896z" />
      <path d="M736 416c0-88.224-71.776-160-160-160l-256 0C302.336 256 288 270.336 288 288s14.336 32 32 32l256 0c52.928 0 96 43.072 96 96s-43.072 96-96 96l-160 0 0-96c0-17.664-14.336-32-32-32s-32 14.336-32 32l0 288-32 0c-17.664 0-32 14.304-32 32s14.336 32 32 32l128 0c17.664 0 32-14.304 32-32s-14.336-32-32-32l-32 0 0-128 78.912 0 118.464 177.76c0.896 1.376 2.08 2.464 3.168 3.648 0.512 0.544 0.864 1.088 1.408 1.6 2.624 2.528 5.6 4.512 8.8 5.952 0.672 0.352 1.408 0.576 2.112 0.8 3.552 1.344 7.296 2.208 11.072 2.24C639.968 768 640 768 640 768l64 0c17.696 0 32-14.304 32-32s-14.304-32-32-32l-46.88 0-85.312-128L576 576C664.224 576 736 504.224 736 416z" />
    </svg>
  );
};

export const SerialNum = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="svg-icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="#ffffff"
      height="17"
      width="17"
    >
      <path
        d="M950.9 930H73.1c-34.6 0-62.7-28.1-62.7-62.7V156.7c0-34.6 28.1-62.7 62.7-62.7h877.7c34.6 0 62.7 28.1 62.7 62.7v710.5c0.1 34.6-28.1 62.8-62.6 62.8zM73.1 135.8c-11.5 0-20.9 9.4-20.9 20.9v710.5c0 11.5 9.4 20.9 20.9 20.9h877.7c11.5 0 20.9-9.4 20.9-20.9V156.7c0-11.5-9.4-20.9-20.9-20.9H73.1z"
        fill="#ffffff"
      />
      <path
        d="M700.1 658.3c-11.6 0-20.9-9.3-20.9-20.9V386.6c0-11.5 9.3-20.9 20.9-20.9 11.6 0 20.9 9.4 20.9 20.9v250.8c0 11.5-9.4 20.9-20.9 20.9zM522.4 658.3c-11.5 0-20.9-9.3-20.9-20.9V386.6c0-11.5 9.4-20.9 20.9-20.9 11.6 0 20.9 9.4 20.9 20.9v250.8c0 11.5-9.3 20.9-20.9 20.9zM344.8 658.3c-11.5 0-20.9-9.3-20.9-20.9V386.6c0-11.5 9.4-20.9 20.9-20.9 11.5 0 20.9 9.4 20.9 20.9v250.8c0 11.5-9.3 20.9-20.9 20.9zM167.2 658.3c-11.5 0-20.9-9.3-20.9-20.9V386.6c0-11.5 9.4-20.9 20.9-20.9s20.9 9.4 20.9 20.9v250.8c0 11.5-9.4 20.9-20.9 20.9zM877.7 663.5c-11.6 0-20.9-9.3-20.9-20.9V391.8c0-11.5 9.3-20.9 20.9-20.9s20.9 9.4 20.9 20.9v250.8c0 11.6-9.3 20.9-20.9 20.9z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const Packaging = () => {
  return (
    <svg
      fill="#ffffff"
      height="16"
      width="16"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M495.297,22.27H194.786c-7.661,0-14.339,5.214-16.196,12.646l-5.187,20.744H16.706c-11.382,0-19.44,11.169-15.838,21.974 l32.533,97.6v264.41c0,27.617,22.468,50.085,50.085,50.085c3.337,0,341.592,0,345.031,0c27.617,0,50.085-22.468,50.085-50.085 V174.579l32.891-131.565C514.13,32.475,506.14,22.27,495.297,22.27z M144.701,456.341H83.486c-9.206,0-16.695-7.489-16.695-16.695 V189.22h77.91V456.341z M148.362,155.83H62.13L39.87,89.05h125.187L148.362,155.83z M445.212,439.646 c0,9.206-7.489,16.695-16.695,16.695H178.091V189.22h267.121V439.646z M448.871,155.83H182.779l25.043-100.17h266.092 L448.871,155.83z"></path>{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M395.127,389.561h-166.95c-9.22,0-16.695,7.475-16.695,16.695s7.475,16.695,16.695,16.695h166.95 c9.22,0,16.695-7.475,16.695-16.695S404.347,389.561,395.127,389.561z"></path>{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M406.936,260.89l-33.388-33.387c-6.517-6.524-17.13-6.492-23.616,0l-33.388,33.387c-3.259,3.259-4.888,7.528-4.891,11.799 c-0.001-4.271-1.632-8.541-4.891-11.799l-33.388-33.387c-6.497-6.503-17.102-6.52-23.616,0l-33.388,33.387 c-6.52,6.52-6.52,17.09,0,23.61c6.519,6.52,17.09,6.52,23.61,0l4.891-4.889v59.865c0,9.22,7.475,16.695,16.695,16.695 c9.22,0,16.695-7.475,16.695-16.695v-59.865l4.891,4.889c6.519,6.52,17.09,6.521,23.61,0c3.259-3.259,4.888-7.528,4.891-11.799 c0.001,4.271,1.632,8.541,4.891,11.799c6.519,6.52,17.09,6.52,23.61,0l4.891-4.889v59.865c0,9.22,7.475,16.695,16.695,16.695 s16.695-7.475,16.695-16.695v-59.865l4.891,4.889c6.519,6.52,17.09,6.521,23.61,0C413.456,277.98,413.456,267.41,406.936,260.89z"></path>{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

export const Condition = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="svg-icon"
      fill="#ffffff"
      height="18"
      width="18"
      viewBox="0 0 1024 1024"
      version="1.1"
    >
      <path
        d="M832 708.032A128.064 128.064 0 0 1 800 960a128 128 0 0 1-32-251.968V576a32 32 0 0 0-32-32H288a32 32 0 0 0-32 32v132.032A128.064 128.064 0 0 1 224 960a128 128 0 0 1-32-251.968V544a64 64 0 0 1 64-64h224V315.968A128.064 128.064 0 0 1 512 64a128 128 0 0 1 32 251.968V480h224a64 64 0 0 1 64 64v164.032zM512 256a64 64 0 1 0 0-128 64 64 0 0 0 0 128zM224 896a64 64 0 1 0 0-128 64 64 0 0 0 0 128z m576 0a64 64 0 1 0 0-128 64 64 0 0 0 0 128z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const Bank = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20px"
      width="20px"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M948.536889 454.826667c35.328 0 50.062222-45.397333 21.390222-66.304L533.475556 71.025778a36.352 36.352 0 0 0-42.979556 0L54.044444 388.551111c-28.700444 20.792889-13.937778 66.275556 21.475556 66.275556h70.741333v427.434666H64a9.159111 9.159111 0 0 0-9.130667 9.130667v59.448889c0 5.006222 4.096 9.130667 9.130667 9.130667h896a9.159111 9.159111 0 0 0 9.159111-9.130667v-59.448889a9.159111 9.159111 0 0 0-9.159111-9.130667h-82.289778V454.798222h70.855111zM512 151.608889l309.845333 225.365333H202.154667L511.971556 151.608889zM228.551111 454.826667h133.688889v427.406222h-133.688889V454.798222z m216.007111 0h133.688889v427.406222h-133.688889V454.798222z m350.862222 427.406222h-134.883555V454.798222h134.855111v427.434667z" />
    </svg>
  );
};

export const NumberIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 24 24"
      height="20px"
      width="20px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.003 7.754a.75.75 0 0 1 .75-.75h5.232a.75.75 0 0 1 .53 1.28l-2.776 2.777c.55.097 1.057.253 1.492.483.905.477 1.504 1.284 1.504 2.418 0 .966-.471 1.75-1.172 2.27-.687.511-1.587.77-2.521.77-1.367 0-2.274-.528-2.667-.756a.75.75 0 0 1 .755-1.297c.331.193.953.553 1.912.553.673 0 1.243-.188 1.627-.473.37-.275.566-.635.566-1.067 0-.5-.219-.836-.703-1.091-.538-.284-1.375-.443-2.471-.443a.75.75 0 0 1-.53-1.28l2.643-2.644h-3.421a.75.75 0 0 1-.75-.75ZM7.88 15.215a1.4 1.4 0 0 0-1.446.83.75.75 0 0 1-1.37-.61 2.899 2.899 0 0 1 2.986-1.71c.589.06 1.139.323 1.557.743.434.446.685 1.058.685 1.778 0 1.641-1.254 2.437-2.12 2.986-.538.341-1.18.694-1.495 1.273H9.75a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75c0-1.799 1.337-2.63 2.243-3.21 1.032-.659 1.55-1.031 1.55-1.8 0-.355-.116-.584-.26-.732a1.071 1.071 0 0 0-.652-.298Zm.234-13.121a.75.75 0 0 1 .386.656V9h1.252a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1 0-1.5H7V4.103l-.853.533a.749.749 0 1 1-.795-1.272l2-1.25a.749.749 0 0 1 .762-.02Z"></path>
    </svg>
  );
};

export const IFBNCode = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 512 512"
      height="20px"
      width="20px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="m384 400.33 35.13-.33A29 29 0 0 0 448 371.13V140.87A29 29 0 0 0 419.13 112l-35.13.33M128 112l-36.8.33c-15.88 0-27.2 13-27.2 28.87v230.27c0 15.87 11.32 28.86 27.2 28.86L128 400m256-208v128m-64-160v192m-64-176v160m-64-176v192m-64-160v128"
      ></path>
    </svg>
  );
};

export const SwiftCode = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20px"
      width="20px"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-barcode-icon lucide-barcode"
    >
      <path d="M3 5v14" />
      <path d="M8 5v14" />
      <path d="M12 5v14" />
      <path d="M17 5v14" />
      <path d="M21 5v14" />
    </svg>
  );
};

export const BranchCode = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20px"
      width="20px"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-split-icon lucide-split"
    >
      <path d="M16 3h5v5" />
      <path d="M8 3H3v5" />
      <path d="M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3" />
      <path d="m15 9 6-6" />
    </svg>
  );
};

export const PiggyBank = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      fill="white"
      stroke="currentColor"
      strokeWidth="2"
      data-name="Layer 1"
    >
      <rect x="1.48" y="1.5" width="21.04" height="19.13" rx="1.91" />
      <line className="cls-1" x1="4.35" y1="23.5" x2="4.35" y2="20.63" />
      <line className="cls-1" x1="19.65" y1="23.5" x2="19.65" y2="20.63" />
      <circle className="cls-1" cx="10.09" cy="11.07" r="4.78" />
      <line className="cls-1" x1="17.74" y1="9.15" x2="19.65" y2="9.15" />
      <line className="cls-1" x1="17.74" y1="12.98" x2="19.65" y2="12.98" />
      <line className="cls-1" x1="17.74" y1="16.8" x2="19.65" y2="16.8" />
      <line className="cls-1" x1="10.09" y1="4.37" x2="10.09" y2="11.07" />
      <line className="cls-1" x1="4.35" y1="15.85" x2="10.09" y2="11.07" />
      <line className="cls-1" x1="15.83" y1="15.85" x2="10.09" y2="11.07" />
    </svg>
  );
};

export const GroupNetwork = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9 6C9 6.39397 9.0776 6.78407 9.22836 7.14805C9.37913 7.51203 9.6001 7.84274 9.87868 8.12132C10.1573 8.3999 10.488 8.62087 10.852 8.77164C11.2159 8.9224 11.606 9 12 9C12.394 9 12.7841 8.9224 13.1481 8.77164C13.512 8.62087 13.8427 8.3999 14.1213 8.12132C14.3999 7.84274 14.6209 7.51203 14.7716 7.14805C14.9224 6.78407 15 6.39396 15 6C15 5.60603 14.9224 5.21593 14.7716 4.85195C14.6209 4.48797 14.3999 4.15725 14.1213 3.87868C13.8427 3.6001 13.512 3.37912 13.148 3.22836C12.7841 3.0776 12.394 3 12 3C11.606 3 11.2159 3.0776 10.8519 3.22836C10.488 3.37913 10.1573 3.6001 9.87868 3.87868C9.6001 4.15726 9.37912 4.48797 9.22836 4.85195C9.0776 5.21593 9 5.60604 9 6L9 6Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M4.43781 13.9015C4.09663 14.0985 3.79758 14.3607 3.55775 14.6733C3.31792 14.9858 3.142 15.3426 3.04004 15.7231C2.93807 16.1037 2.91206 16.5006 2.96348 16.8912C3.0149 17.2818 3.14275 17.6584 3.33974 17.9996C3.53672 18.3408 3.79897 18.6398 4.11153 18.8796C4.42408 19.1195 4.78081 19.2954 5.16136 19.3974C5.5419 19.4993 5.9388 19.5253 6.32939 19.4739C6.71999 19.4225 7.09663 19.2946 7.43781 19.0977C7.779 18.9007 8.07804 18.6384 8.31787 18.3259C8.5577 18.0133 8.73362 17.6566 8.83559 17.276C8.93756 16.8955 8.96357 16.4986 8.91215 16.108C8.86072 15.7174 8.73287 15.3408 8.53589 14.9996C8.33891 14.6584 8.07665 14.3594 7.7641 14.1195C7.45154 13.8797 7.09481 13.7038 6.71427 13.6018C6.33373 13.4998 5.93683 13.4738 5.54623 13.5252C5.15564 13.5767 4.779 13.7045 4.43781 13.9015L4.43781 13.9015Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M19.5622 13.9015C19.9034 14.0985 20.2024 14.3607 20.4422 14.6733C20.6821 14.9859 20.858 15.3426 20.96 15.7231C21.0619 16.1037 21.0879 16.5006 21.0365 16.8912C20.9851 17.2818 20.8572 17.6584 20.6603 17.9996C20.4633 18.3408 20.201 18.6398 19.8885 18.8796C19.5759 19.1195 19.2192 19.2954 18.8386 19.3974C18.4581 19.4993 18.0612 19.5253 17.6706 19.4739C17.28 19.4225 16.9034 19.2946 16.5622 19.0977C16.221 18.9007 15.922 18.6384 15.6821 18.3259C15.4423 18.0133 15.2664 17.6566 15.1644 17.276C15.0624 16.8955 15.0364 16.4986 15.0879 16.108C15.1393 15.7174 15.2671 15.3408 15.4641 14.9996C15.6611 14.6584 15.9234 14.3594 16.2359 14.1195C16.5485 13.8797 16.9052 13.7038 17.2857 13.6018C17.6663 13.4998 18.0632 13.4738 18.4538 13.5252C18.8444 13.5767 19.221 13.7045 19.5622 13.9015L19.5622 13.9015Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M9.06962 6.64319C9.02341 6.43253 8.99993 6.217 8.99993 6.0003C8.99993 5.60634 9.07753 5.21623 9.22829 4.85225C9.30001 4.67912 9.3876 4.51352 9.48973 4.35747C9.17327 4.44938 8.86149 4.55879 8.55584 4.68539C7.46391 5.13768 6.47176 5.80062 5.63603 6.63634C4.80031 7.47207 4.13737 8.46422 3.68508 9.55616C3.23279 10.6481 3 11.8184 3 13.0003C3 13.7255 3.08765 14.4464 3.25988 15.1475C3.34396 14.981 3.44359 14.8223 3.55768 14.6736C3.79752 14.361 4.09656 14.0988 4.43774 13.9018C4.62541 13.7935 4.82381 13.706 5.02936 13.6407C5.00983 13.4282 5 13.2145 5 13.0003C5 12.0811 5.18106 11.1708 5.53284 10.3215C5.88462 9.47224 6.40024 8.70057 7.05025 8.05056C7.63547 7.46533 8.31932 6.98905 9.06962 6.64319ZM14.9303 6.64313C15.6806 6.989 16.3645 7.4653 16.9497 8.05055C17.5998 8.70056 18.1154 9.47224 18.4672 10.3215C18.8189 11.1708 19 12.081 19 13.0003C19 13.2145 18.9902 13.4282 18.9706 13.6408C19.1761 13.7061 19.3745 13.7935 19.5621 13.9018C19.9033 14.0988 20.2023 14.361 20.4422 14.6736C20.5563 14.8223 20.656 14.9811 20.7401 15.1476C20.9123 14.4465 21 13.7256 21 13.0003C21 11.8184 20.7672 10.6481 20.3149 9.55615C19.8626 8.46422 19.1997 7.47206 18.364 6.63634C17.5282 5.80061 16.5361 5.13768 15.4441 4.68538C15.1385 4.55876 14.8266 4.44935 14.5101 4.35742C14.6122 4.51348 14.6999 4.6791 14.7716 4.85225C14.9223 5.21623 14.9999 5.60633 14.9999 6.0003C14.9999 6.21698 14.9765 6.43249 14.9303 6.64313ZM18.2303 19.4952C18.0439 19.5056 17.8565 19.4987 17.6705 19.4742C17.2799 19.4228 16.9033 19.2949 16.5621 19.098C16.3746 18.9897 16.1998 18.8617 16.0405 18.7164C15.6169 19.0159 15.1603 19.268 14.6788 19.4675C13.8295 19.8192 12.9193 20.0003 12 20.0003C11.0807 20.0003 10.1705 19.8192 9.32122 19.4675C8.83965 19.268 8.38304 19.0158 7.95941 18.7164C7.80015 18.8616 7.62531 18.9897 7.43775 19.098C7.09656 19.2949 6.71992 19.4228 6.32932 19.4742C6.1434 19.4987 5.95604 19.5056 5.7697 19.4952C6.5768 20.2694 7.52156 20.8868 8.55585 21.3152C9.64778 21.7675 10.8181 22.0003 12 22.0003C13.1819 22.0003 14.3522 21.7675 15.4442 21.3152C16.4784 20.8868 17.4232 20.2694 18.2303 19.4952Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MusharkaContract = () => {
  return (
    <svg
      viewBox="0 0 1024 1024"
      width="18px"
      height="18px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M287.68 266.112h447.296c13.12 0 23.68-10.496 23.68-23.616a23.552 23.552 0 0 0-23.68-23.552h-447.36a23.552 23.552 0 0 0-23.68 23.552c0 10.496 10.56 23.68 23.68 23.68z m0 165.248h281.536a23.552 23.552 0 1 0 0-47.232h-281.6a23.552 23.552 0 0 0-23.68 23.616c0 10.496 10.56 23.616 23.68 23.616zM858.624 1.28H163.968C108.8 1.28 64 45.824 64 100.928v823.424C64 979.392 108.736 1024 163.968 1024h694.656c55.232 0 99.968-44.608 99.968-99.648V100.928c0-55.04-44.736-99.648-99.968-99.648z m34.24 923.072a34.752 34.752 0 0 1-34.24 34.112H163.968a34.752 34.752 0 0 1-34.176-34.112V100.928c0-18.368 15.744-34.112 34.176-34.112h694.656c18.432 0 34.24 15.744 34.24 34.112v823.424z m-176.32-275.392l-55.232-104.896-55.296 104.96H495.552l81.536 104.896-26.304 104.896 110.528-52.48 110.464 52.48-26.24-104.96 81.536-104.896h-110.528zM403.456 546.688h-115.84a23.552 23.552 0 1 0 0 47.232h115.84c13.12 0 23.68-10.496 23.68-23.616 2.56-13.12-10.56-23.616-23.68-23.616z"
        fill="#000000"
      />
    </svg>
  );
};

export const Notepad = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      width="18px"
      height="18px"
      version="1.1"
      id="Layer_1"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <g>
            <path d="M422.741,42.667h-60.07V32.491C362.671,14.543,348.128,0,330.18,0H181.828c-17.947,0-32.491,14.543-32.491,32.491v10.176     H89.259c-25.734,0-46.592,20.858-46.592,46.592v376.149c0,25.734,20.858,46.592,46.592,46.592h333.483     c25.734,0,46.592-20.858,46.592-46.592V89.259C469.333,63.525,448.475,42.667,422.741,42.667z M192.004,42.667H320v42.667     H192.004V42.667z M426.667,465.408c0,2.17-1.755,3.925-3.925,3.925H89.259c-2.17,0-3.925-1.755-3.925-3.925V89.259     c0-2.17,1.755-3.925,3.925-3.925h60.075v10.176c0,17.947,14.543,32.491,32.491,32.491h0.004h148.348h0.004     c17.947,0,32.491-14.543,32.491-32.491V85.333h60.07c2.17,0,3.925,1.755,3.925,3.925V465.408z" />
            <path d="M349.984,181.617c-14.603-14.603-38.287-14.603-52.89,0L174.085,304.648c-2.553,2.554-4.417,5.714-5.415,9.184     l-18.496,64.277c-4.639,16.122,10.288,31.044,26.409,26.398l64.256-18.517c3.467-0.999,6.624-2.862,9.176-5.413l123.029-123.008     c14.604-14.604,14.604-38.288,0.001-52.891L349.984,181.617z M223.738,346.515l-21.89,6.308l6.302-21.902L323.54,215.512     l15.611,15.611L223.738,346.515z" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Download = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
    >
      <title />

      <g id="Complete">
        <g id="download">
          <g>
            <path
              d="M3,12.3v7a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2v-7"
              fill="none"
              stroke="#000000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />

            <g>
              <polyline
                data-name="Right"
                fill="none"
                id="Right-2"
                points="7.9 12.3 12 16.3 16.1 12.3"
                stroke="#000000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />

              <line
                fill="none"
                stroke="#000000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                x1="12"
                x2="12"
                y1="2.7"
                y2="14.2"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const PdfLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="svg-icon"
      width={25}
      height={25}
      viewBox="0 0 1024 1024"
      version="1.1"
    >
      <path d="M875.1 301.8L597.3 21.3c-4.5-4.5-9.4-8.3-14.7-11.5-1.4-0.8-2.8-1.6-4.3-2.3-0.9-0.5-1.9-0.9-2.8-1.3-9-4-18.9-6.2-29-6.2h-345c-39.8 0-73 32.2-73 72v880c0 39.8 33.2 72 73 72h623c39.8 0 71-32.2 71-72V352.5c0-19-7-37.2-20.4-50.7zM583.5 110.4L784.3 312H583.5V110.4z m240 841.6h-623V72h311v240c0 39.8 33.2 72 73 72h239v568z" />
      <path d="M333.2 576h-66.7v192h46v-64h22.1c40.4 0 75.6-20.2 75.6-65.7-0.1-47.3-34.7-62.3-77-62.3z m-0.9 92h-19.8v-56H331c22.2 0 34.5 7 34.5 26.4 0 18.7-10.8 29.6-33.2 29.6zM498 576h-55.5v192h58.1c55.8 0 94.4-30.4 94.4-97s-38.6-95-97-95z m-2.9 155h-5.6V613h5.6c30.9 0 52.7 12.8 52.7 58.3S526 731 495.1 731zM752.5 614v-38h-122v192h46v-73h65v-38h-65v-43z" />
    </svg>
  );
};

export const UnknownFile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="svg-icon"
      width={25}
      height={25}
      viewBox="0 0 1024 1024"
      version="1.1"
    >
      <path d="M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM790.2 326H602V137.8L790.2 326z m1.8 562H232V136h302v216c0 23.2 18.8 42 42 42h216v494z" />
      <path d="M402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-0.8-55.5-49.2-100.8-108.5-101.6-61.4-0.7-111.5 45.6-111.5 103z" />
      <path d="M512 744m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z" />
    </svg>
  );
};

export const Manufacturer = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      fill="black"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.50016 7.24988C5.08595 7.24988 4.75016 7.58566 4.75016 7.99988C4.75016 13.6348 3.85593 17.4217 2.53011 20.2499H2C1.58579 20.2499 1.25 20.5857 1.25 20.9999C1.25 21.4141 1.58579 21.7499 2 21.7499H2.98392C2.99438 21.7501 3.00482 21.7501 3.01525 21.7499L14.9851 21.7499C14.9955 21.7501 15.0059 21.7501 15.0164 21.7499H21C21.4142 21.7499 21.75 21.4141 21.75 20.9999C21.75 20.5857 21.4142 20.2499 21 20.2499H20.1921C18.6638 18.5165 17.9462 16.9204 17.5881 15.5556C17.2939 14.4342 17.2389 13.4741 17.1908 12.635C17.1785 12.4204 17.1667 12.2134 17.1514 12.0139C17.1214 11.623 16.7956 11.3212 16.4036 11.3212H13.3647C13.2898 10.2904 13.2502 9.18611 13.2502 7.99988C13.2502 7.58566 12.9144 7.24988 12.5002 7.24988L5.50016 7.24988ZM18.2595 20.2499H15.4702C14.5638 18.3164 13.8592 15.9349 13.504 12.8212H15.698C15.7453 13.648 15.8208 14.7304 16.1372 15.9363C16.4804 17.244 17.1033 18.7036 18.2595 20.2499ZM13.827 20.2499L4.17333 20.2499C5.38941 17.4025 6.17404 13.7658 6.24492 8.74988L11.7554 8.74988C11.8263 13.7658 12.6109 17.4025 13.827 20.2499Z"
        fill="black"
      />
      <path
        d="M18.7922 4.65956C19.2911 3.95139 19.754 3.74988 20.0831 3.74988C20.4139 3.74988 20.8819 3.95321 21.39 4.66383C21.6309 5.00078 22.0993 5.07864 22.4363 4.83773C22.7732 4.59682 22.8511 4.12838 22.6102 3.79142C21.9478 2.86505 21.0819 2.24988 20.0831 2.24988C19.0839 2.24988 18.2224 2.86536 17.5683 3.7923C17.2796 4.19237 17.063 4.24803 16.9851 4.24981C16.9212 4.25127 16.7238 4.22061 16.452 3.83369L16.4484 3.82862C15.7857 2.90185 14.9198 2.28708 13.9192 2.28708C12.9185 2.28708 12.0526 2.90185 11.39 3.82862C11.149 4.16558 11.2269 4.63402 11.5639 4.87493C11.9008 5.11584 12.3693 5.03798 12.6102 4.70103C13.1179 3.99081 13.5859 3.78708 13.9192 3.78708C14.2521 3.78708 14.7194 3.99038 15.2265 4.69876C15.6603 5.31493 16.2711 5.76654 17.0194 5.74942C17.7545 5.73261 18.3546 5.26767 18.7878 4.66571L18.7922 4.65956Z"
        fill="black"
      />
    </svg>
  );
};

export const Inspection = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="svg-icon"
      width="20px"
      height="20px"
      viewBox="0 0 1024 1024"
      version="1.1"
    >
      <path d="M812.9 714.2c0-79.4-64.9-143.9-144.4-143.3-77.9 0.6-141.6 64.2-142.2 142.2-0.6 79.5 63.9 144.4 143.3 144.4 26.5 0 51.3-7.2 72.6-19.8l33.6 35.1c9.5 10 25.4 10.3 35.3 0.8 10-9.5 10.3-25.4 0.8-35.3l-31.7-33.1c20.4-24.8 32.7-56.5 32.7-91z m-143.3 93.2c-51.4 0-93.3-41.8-93.3-93.3s41.8-93.3 93.3-93.3c51.4 0 93.3 41.8 93.3 93.3s-41.9 93.3-93.3 93.3zM713.2 443c0-17.1-13.1-31-29.2-31H321.4c-16.1 0-29.2 13.9-29.2 31s13.1 31 29.2 31H684c15.9 0 29-13.9 29.2-31zM321 529.9c-16.1 0-29.2 13.9-29.2 31s13.1 31 29.2 31h143.1c16 0 29.1-13.9 29.2-31 0-17.1-13.1-31-29.2-31H321zM684 284.5H321.4c-16.1 0-29.2 13.9-29.2 31s13.1 31 29.2 31H684c16 0 29.1-13.9 29.2-31 0-17.1-13.1-31-29.2-31z" />
      <path d="M521.3 851.5H228.4s-0.1-0.1-0.1 0V170.6s0.1-0.1 0-0.1h566.9s0.1 0.1 0.1 0V527c0 16.6 13.4 30 30 30s30-13.4 30-30V170.5c0-33.1-26.9-60-60-60h-567c-33.1 0-60 26.9-60 60v681c0 33.1 26.9 60 60 60h293c16.6 0 30-13.4 30-30s-13.4-30-30-30z" />
    </svg>
  );
};

export const Logo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 69 53"
      fill="none"
    >
      <g clipPath="url(#clip0_1680_1880)">
        <path
          d="M57.4766 7.61203H42.2813V8.74556H57.4766V7.61203ZM6.43568 8.1788C6.43568 9.01169 7.09761 9.68688 7.91415 9.68688C8.73069 9.68688 9.39262 9.01169 9.39262 8.1788C9.39262 7.3459 8.73069 6.67072 7.91415 6.67072C7.09761 6.67072 6.43568 7.3459 6.43568 8.1788ZM5.35341 8.1788C5.35341 6.73971 6.50333 5.57169 7.91415 5.57169C9.32498 5.57169 10.4701 6.74464 10.4701 8.1788C10.4701 9.61788 9.32015 10.7908 7.91415 10.7908C6.50333 10.7908 5.35341 9.61788 5.35341 8.1788ZM28.9702 7.61203H14.3547V8.74556H28.9751V7.61203H28.9702ZM43.2959 20.204C43.2959 18.5727 41.658 17.8285 40.1844 17.8285H38.6093V20.204H43.2959ZM36.8409 10.1699C34.5604 10.2241 33.2945 11.19 32.5166 12.6587H36.8409V10.1699ZM36.8409 17.8236H32.5263C33.2945 19.243 34.5652 20.1991 36.8167 20.1991H36.8409V17.8236ZM44.9918 17.799V25.3689H38.4547C35.9712 25.3689 33.7535 24.2009 32.2992 22.3725V25.3689H28.748C26.941 25.3689 25.3321 24.1713 24.2884 22.3134V25.3689H3.95708C1.7732 25.3689 0 23.5602 0 21.3326V12.6587H20.1429V17.8236H1.90365C1.90365 19.2676 2.56558 20.1991 4.03921 20.1991H23.4332C23.1868 19.2972 23.0515 18.3164 23.0515 17.2913V12.6538H24.8247V16.0593C24.8247 19.0113 26.6801 20.1991 28.9654 20.1991H31.072C30.8111 19.5091 30.642 18.7797 30.5743 18.0158L30.5695 17.8236H29.5355C28.5354 17.8236 27.7285 16.9956 27.7285 15.9804V12.6587H30.555C30.7628 8.39072 34.2222 5 38.4547 5H38.6093V12.6587H39.9525C42.7355 12.6587 44.9918 14.9602 44.9918 17.799ZM46.8761 18.1982H52.3068V12.6587H46.8761V18.1982ZM46.8761 20.204V25.3739H55.457C56.7857 25.3739 57.8728 26.4236 57.9695 27.7493H44.9918V32.9143H63.2504V5H61.4772V27.7444H59.5832V24.9747C59.5832 22.338 57.4863 20.204 54.9062 20.204H46.8761ZM69 32.9143H67.2268V5H69V32.9143ZM35.9954 35.2897C34.2608 35.2897 32.6278 34.3632 32.6278 32.9143H37.5367C39.3968 32.9143 41.3681 33.7274 41.3681 35.2897H35.9954ZM63.951 39.4049L60.3418 35.8417L56.7374 39.4049L52.5774 35.2897H43.1413V34.3534C43.1413 30.7014 40.2423 27.7444 36.6621 27.7444H30.8304V33.8457C30.8304 37.4927 33.7294 40.4547 37.3096 40.4547H41.3681C41.3681 41.7656 40.3245 42.8301 39.0393 42.8301H30.8691V47.9951H39.5224C41.5179 47.9951 43.1365 46.3441 43.1365 44.3087V40.4547H50.7656L56.7326 46.1075L60.337 42.5394L63.9462 46.1075L68.9952 41.1151V34.5111L63.951 39.4049ZM27.197 35.2897C27.197 33.7964 24.7426 32.9143 22.8824 32.9143H18.3842C18.3842 34.3435 20.0173 35.2897 21.7518 35.2897H27.197ZM28.9702 34.3534V48H9.35397C3.36762 48 0 43.7271 0 38.4587V35.2109H1.7732C1.7732 40.7454 5.1843 42.84 9.32981 42.84H27.2019V40.4645H23.0709C19.4955 40.4645 16.5917 37.5075 16.5917 33.8556V27.7444H22.4959C26.0713 27.7444 28.9702 30.7064 28.9702 34.3534ZM5.43071 27.7444H0V33.2839H5.43071V27.7444ZM9.53274 40.5138H14.688V35.2602H9.53274V40.5138ZM14.688 33.003H9.53274V27.7444H14.688V33.003Z"
          fill="#CCB16A"
        />
      </g>
      <defs>
        <clipPath id="clip0_1680_1880">
          <rect
            width="69"
            height="43"
            fill="white"
            transform="translate(0 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Requests = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 26 30"
      fill="none"
    >
      <path
        d="M21.052 25.6167H0.762683C0.340567 25.6167 0.00149573 25.3129 0.00149573 24.9347V0.681954C-0.0123442 0.502166 0.0706935 0.328578 0.216012 0.198387C0.361331 0.0681953 0.555089 0 0.755767 0H16.3326C16.5401 0 16.7339 0.0743951 16.8792 0.210786L21.5986 4.60009C21.737 4.73028 21.8132 4.89767 21.8132 5.07126V24.9347C21.8132 25.3129 21.4741 25.6167 21.052 25.6167ZM1.5308 24.2528H20.2977V5.34404L16.0142 1.36391H1.52388V24.2528H1.5308Z"
        fill="black"
      />
      <path
        d="M25.2321 30H4.94284C4.52072 30 4.18164 29.6962 4.18164 29.318V24.9287H5.70403V28.6361H24.4709V5.74721H20.9348V4.3833H25.239C25.4397 4.3833 25.6335 4.4577 25.7788 4.58169C25.9241 4.71188 26.0002 4.88547 26.0002 5.06526V29.318C25.9933 29.6962 25.6473 30 25.2321 30Z"
        fill="black"
      />
      <path
        d="M16.0488 1.27051V5.65981H20.7682L16.0488 1.27051Z"
        fill="black"
      />
      <path
        d="M16.8589 9.08904H6.08457C5.70398 9.08904 5.39258 8.81006 5.39258 8.46908C5.39258 8.1281 5.70398 7.84912 6.08457 7.84912H16.8589C17.2395 7.84912 17.5509 8.1281 17.5509 8.46908C17.5509 8.81006 17.2395 9.08904 16.8589 9.08904Z"
        fill="black"
      />
      <path
        d="M16.8589 11.9523H6.08457C5.70398 11.9523 5.39258 11.6733 5.39258 11.3324C5.39258 10.9914 5.70398 10.7124 6.08457 10.7124H16.8589C17.2395 10.7124 17.5509 10.9914 17.5509 11.3324C17.5509 11.6733 17.2395 11.9523 16.8589 11.9523Z"
        fill="black"
      />
    </svg>
  );
};

export const Inventory = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="svg-icon"
      width="22px"
      height="22px"
      viewBox="0 0 1024 1024"
      version="1.1"
    >
      <path
        d="M490.06 889.25l-340.3-0.31V288.26h673.63l2.99 186.57c0.3 18.54 15.43 33.39 33.93 33.39h0.55c18.75-0.31 33.7-15.73 33.4-34.49l-3.6-225.11c-0.08-4.61-1.11-9-2.87-12.99-1.25-3.53-2.96-6.94-5.23-10.08L779.77 83.57c-7.4-10.3-19.39-16.44-32.06-16.44H225.2c-12.61 0-24.56 6.1-32.03 16.37L90.38 225.55c-4.24 5.85-6.62 12.57-7.28 19.45-0.72 2.75-1.22 5.58-1.22 8.55v635.4c0 37.61 30.59 68.19 68.2 68.19h339.98c18.75 0 33.94-15.2 33.94-33.94 0-18.75-15.19-33.95-33.94-33.95zM239.69 135h493.53l61.79 85.38h-617.1L239.69 135z"
        fill="black"
      />
      <path
        d="M356.33 411.49c-18.74 0-33.94 15.19-33.94 33.94 0 18.74 15.19 33.94 33.94 33.94h267.63c18.74 0 33.94-15.19 33.94-33.94 0-18.74-15.19-33.94-33.94-33.94H356.33zM932.34 879.55l-87.73-87.72c-1.48-1.48-3.36-2.18-5.02-3.34 18.22-25.76 29.04-57.1 29.04-90.99 0-87.12-70.88-158-158.01-158s-158.03 70.88-158.03 158c0 87.14 70.89 158.03 158.03 158.03 29.67 0 57.36-8.37 81.11-22.66 1.44 2.45 2.63 5.02 4.73 7.12l87.73 87.72c13.3 13.3 34.86 13.3 48.16 0 13.29-13.29 13.29-34.86-0.01-48.16z m-221.72-91.89c-49.7 0-90.15-40.43-90.15-90.15 0-49.69 40.45-90.13 90.15-90.13s90.14 40.43 90.14 90.13c-0.01 49.71-40.44 90.15-90.14 90.15z"
        fill="black"
      />
    </svg>
  );
};

export const AppStore = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      width="800px"
      height="800px"
      viewBox="0 0 32 32"
      {...props}
    >
      <path d="M15.994 7.556l0.569-0.981c0.35-0.613 1.131-0.819 1.744-0.469s0.819 1.131 0.469 1.744l-5.469 9.469h3.956c1.281 0 2 1.506 1.444 2.55h-11.594c-0.706 0-1.275-0.569-1.275-1.275s0.569-1.275 1.275-1.275h3.25l4.162-7.213-1.3-2.256c-0.35-0.613-0.144-1.388 0.469-1.744 0.612-0.35 1.387-0.144 1.744 0.469zM11.075 21.181l-1.225 2.125c-0.35 0.613-1.131 0.819-1.744 0.469s-0.819-1.131-0.469-1.744l0.913-1.575c1.025-0.319 1.863-0.075 2.525 0.725zM21.631 17.325h3.319c0.706 0 1.275 0.569 1.275 1.275s-0.569 1.275-1.275 1.275h-1.844l1.244 2.156c0.35 0.613 0.143 1.387-0.469 1.744-0.613 0.35-1.388 0.144-1.744-0.469-2.094-3.631-3.669-6.35-4.712-8.162-1.069-1.844-0.306-3.694 0.45-4.319 0.837 1.438 2.087 3.606 3.756 6.5zM16 0.5c-8.563 0-15.5 6.938-15.5 15.5s6.938 15.5 15.5 15.5c8.563 0 15.5-6.938 15.5-15.5s-6.938-15.5-15.5-15.5zM29.5 16c0 7.419-6.006 13.5-13.5 13.5-7.419 0-13.5-6.006-13.5-13.5 0-7.419 6.006-13.5 13.5-13.5 7.419 0 13.5 6.006 13.5 13.5z" />
    </svg>
  );
};

export const PlayStore = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 3.65629C2 2.15127 3.59967 1.18549 4.93149 1.88645L20.7844 10.2301C22.2091 10.9799 22.2091 13.0199 20.7844 13.7698L4.9315 22.1134C3.59968 22.8144 2 21.8486 2 20.3436V3.65629ZM19.8529 11.9999L16.2682 10.1132L14.2243 11.9999L16.2682 13.8866L19.8529 11.9999ZM14.3903 14.875L12.75 13.3608L6.75782 18.8921L14.3903 14.875ZM12.75 10.639L14.3903 9.12488L6.75782 5.10777L12.75 10.639ZM4 5.28391L11.2757 11.9999L4 18.7159V5.28391Z"
        fill="#0F0F0F"
      />
    </svg>
  );
};

export const Jeweler = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 22 20"
      fill="none"
    >
      <path
        d="M16.5985 6.59999L17.363 2.013L20.4221 6.59999H16.5985ZM16.3191 7.69999H20.2472L12.7826 16.3438L16.3191 7.69999ZM5.67995 7.69999L9.21644 16.3438L1.75075 7.69999H5.67995ZM5.40055 6.59999H1.57695L4.63605 2.013L5.40055 6.59999ZM6.38065 5.79149L5.59855 1.1H9.89954L6.38065 5.79149ZM12.0995 1.1H16.4005L15.6184 5.79149L12.0995 1.1ZM7.14955 6.59999L10.9995 1.4663L14.8495 6.59999H7.14955ZM15.13 7.69999L10.9995 17.798L6.86905 7.69999H15.13ZM21.9071 6.84529L17.5071 0.245299C17.506 0.243099 17.5027 0.242 17.5016 0.2398C17.4554 0.1727 17.3949 0.1177 17.3223 0.0769998C17.3014 0.0648998 17.2783 0.0615998 17.2574 0.0516999C17.2178 0.0362999 17.1826 0.0142999 17.1397 0.00769996C17.1221 0.00439996 17.1045 0.0109999 17.0858 0.00879988C17.0737 0.00879988 17.0627 0 17.0495 0H4.94955C4.93635 0 4.92535 0.00879988 4.91215 0.00879988C4.89455 0.0109999 4.87805 0.00439996 4.85935 0.00769996C4.81645 0.0142999 4.78125 0.0362999 4.74275 0.0516999C4.72075 0.0615998 4.69765 0.0648998 4.67785 0.0769998C4.60525 0.1177 4.54365 0.1727 4.49855 0.2398C4.49635 0.242 4.49415 0.243099 4.49195 0.245299L0.0919555 6.84529C-0.0444444 7.05099 -0.0279445 7.32269 0.133755 7.50969L10.5837 19.6097C10.6068 19.6372 10.6387 19.6493 10.6662 19.6713C10.6904 19.69 10.7113 19.7109 10.7388 19.7252C10.9027 19.8154 11.0963 19.8154 11.2602 19.7252C11.2877 19.7109 11.3086 19.69 11.3328 19.6713C11.3603 19.6493 11.3922 19.6372 11.4164 19.6097L21.8664 7.50969C22.0281 7.32269 22.0446 7.05099 21.9071 6.84529Z"
        fill="#CCB16A"
      />
    </svg>
  );
};

export const Refinery = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.50016 7.24988C5.08595 7.24988 4.75016 7.58566 4.75016 7.99988C4.75016 13.6348 3.85593 17.4217 2.53011 20.2499H2C1.58579 20.2499 1.25 20.5857 1.25 20.9999C1.25 21.4141 1.58579 21.7499 2 21.7499H2.98392C2.99438 21.7501 3.00482 21.7501 3.01525 21.7499L14.9851 21.7499C14.9955 21.7501 15.0059 21.7501 15.0164 21.7499H21C21.4142 21.7499 21.75 21.4141 21.75 20.9999C21.75 20.5857 21.4142 20.2499 21 20.2499H20.1921C18.6638 18.5165 17.9462 16.9204 17.5881 15.5556C17.2939 14.4342 17.2389 13.4741 17.1908 12.635C17.1785 12.4204 17.1667 12.2134 17.1514 12.0139C17.1214 11.623 16.7956 11.3212 16.4036 11.3212H13.3647C13.2898 10.2904 13.2502 9.18611 13.2502 7.99988C13.2502 7.58566 12.9144 7.24988 12.5002 7.24988L5.50016 7.24988ZM18.2595 20.2499H15.4702C14.5638 18.3164 13.8592 15.9349 13.504 12.8212H15.698C15.7453 13.648 15.8208 14.7304 16.1372 15.9363C16.4804 17.244 17.1033 18.7036 18.2595 20.2499ZM13.827 20.2499L4.17333 20.2499C5.38941 17.4025 6.17404 13.7658 6.24492 8.74988L11.7554 8.74988C11.8263 13.7658 12.6109 17.4025 13.827 20.2499Z"
        fill="#CCB16A"
      />
      <path
        d="M18.7922 4.65956C19.2911 3.95139 19.754 3.74988 20.0831 3.74988C20.4139 3.74988 20.8819 3.95321 21.39 4.66383C21.6309 5.00078 22.0993 5.07864 22.4363 4.83773C22.7732 4.59682 22.8511 4.12838 22.6102 3.79142C21.9478 2.86505 21.0819 2.24988 20.0831 2.24988C19.0839 2.24988 18.2224 2.86536 17.5683 3.7923C17.2796 4.19237 17.063 4.24803 16.9851 4.24981C16.9212 4.25127 16.7238 4.22061 16.452 3.83369L16.4484 3.82862C15.7857 2.90185 14.9198 2.28708 13.9192 2.28708C12.9185 2.28708 12.0526 2.90185 11.39 3.82862C11.149 4.16558 11.2269 4.63402 11.5639 4.87493C11.9008 5.11584 12.3693 5.03798 12.6102 4.70103C13.1179 3.99081 13.5859 3.78708 13.9192 3.78708C14.2521 3.78708 14.7194 3.99038 15.2265 4.69876C15.6603 5.31493 16.2711 5.76654 17.0194 5.74942C17.7545 5.73261 18.3546 5.26767 18.7878 4.66571L18.7922 4.65956Z"
        fill="#CCB16A"
      />
    </svg>
  );
};

export const Investor = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="21"
      viewBox="0 0 31 21"
      fill="none"
    >
      <path
        d="M22.3273 3.67881C21.2027 4.08144 20.3046 5.19005 19.8874 6.65716L18.8343 3.55196L17.1216 3.57953C17.1216 3.57953 17.1057 3.57953 17.0978 3.5685C18.3654 3.12175 19.3469 1.75943 19.6728 0C20.0344 1.77598 21.0438 3.17139 22.3233 3.67881H22.3273Z"
        fill="#CCB16A"
      />
      <path
        d="M11.0195 20.9999H0.605484C0.405774 20.9999 0.218546 20.8855 0.10621 20.6995C-0.00612703 20.5134 -0.0310907 20.2702 0.0396398 20.0556L1.69557 15.057C1.78294 14.7851 2.01177 14.6086 2.26141 14.6086H9.36359C9.61739 14.6086 9.84206 14.7899 9.92943 15.057L11.5854 20.0556C11.6561 20.2702 11.6311 20.5087 11.5188 20.6995C11.4065 20.8902 11.2192 20.9999 11.0195 20.9999ZM1.48754 19.6072H10.1416L8.94753 16.0014H2.68163L1.48754 19.6072Z"
        fill="#CCB16A"
      />
      <path
        d="M20.1285 20.9999H10.8716C10.6941 20.9999 10.5276 20.8855 10.4278 20.6995C10.3279 20.5134 10.3057 20.2702 10.3686 20.0556L11.8405 15.057C11.9182 14.7851 12.1216 14.6086 12.3435 14.6086H18.6566C18.8822 14.6086 19.0819 14.7899 19.1595 15.057L20.6315 20.0556C20.6943 20.2702 20.6722 20.5087 20.5723 20.6995C20.4724 20.8902 20.306 20.9999 20.1285 20.9999ZM11.6519 19.6072H19.3445L18.283 16.0014H12.717L11.6556 19.6072H11.6519Z"
        fill="#CCB16A"
      />
      <path
        d="M30.3945 20.9999H19.9805C19.7808 20.9999 19.5935 20.8855 19.4812 20.6995C19.3689 20.5134 19.3439 20.2702 19.4146 20.0556L21.0706 15.057C21.1579 14.7851 21.3868 14.6086 21.6364 14.6086H28.7386C28.9924 14.6086 29.2171 14.7899 29.3044 15.057L30.9604 20.0556C31.0311 20.2702 31.0061 20.5087 30.8938 20.6995C30.7815 20.8902 30.5942 20.9999 30.3945 20.9999ZM20.8584 19.6072H29.5125L28.3184 16.0014H22.0566L20.8625 19.6072H20.8584Z"
        fill="#CCB16A"
      />
      <path
        d="M14.9615 15.1334H5.70459C5.52707 15.1334 5.36065 15.0189 5.26079 14.8329C5.16094 14.6469 5.13875 14.4036 5.20162 14.189L6.67355 9.19041C6.75122 8.91854 6.95462 8.74207 7.17652 8.74207H13.4896C13.7152 8.74207 13.9149 8.92331 13.9925 9.19041L15.4645 14.189C15.5274 14.4036 15.5052 14.6421 15.4053 14.8329C15.3055 15.0237 15.139 15.1334 14.9615 15.1334ZM6.48494 13.7406H14.1775L13.116 10.1348H7.55006L6.48864 13.7406H6.48494Z"
        fill="#CCB16A"
      />
      <path
        d="M25.2949 15.1334H16.038C15.8604 15.1334 15.694 15.0189 15.5942 14.8329C15.4943 14.6469 15.4721 14.4036 15.535 14.189L17.0069 9.19041C17.0846 8.91854 17.288 8.74207 17.5099 8.74207H23.8229C24.0485 8.74207 24.2483 8.92331 24.3259 9.19041L25.7979 14.189C25.8607 14.4036 25.8385 14.6421 25.7387 14.8329C25.6388 15.0237 25.4724 15.1334 25.2949 15.1334ZM16.8183 13.7406H24.5108L23.4494 10.1348H17.8834L16.822 13.7406H16.8183Z"
        fill="#CCB16A"
      />
      <path
        d="M20.1285 10.0435H10.8716C10.6941 10.0435 10.5276 9.91266 10.4278 9.70007C10.3279 9.48748 10.3057 9.20948 10.3686 8.96418L11.8405 3.25153C11.9182 2.94082 12.1216 2.73914 12.3435 2.73914H18.6566C18.8822 2.73914 19.0819 2.94627 19.1595 3.25153L20.6315 8.96418C20.6943 9.20948 20.6722 9.48203 20.5723 9.70007C20.4724 9.91811 20.306 10.0435 20.1285 10.0435ZM11.6519 8.45179H19.3445L18.283 4.33083H12.717L11.6556 8.45179H11.6519Z"
        fill="#CCB16A"
      />
      <path
        d="M12.9166 14.6086L10.9356 18.2608L9.04163 14.9375L12.9166 14.6086Z"
        fill="#CCB16A"
      />
      <path d="M14 10L15.327 16L17 10H14Z" fill="#CCB16A" />
      <path
        d="M18.5404 15.6125L19.8318 19.0265L21.2545 14.6086L18.0834 14.923L18.5404 15.6125Z"
        fill="#CCB16A"
      />
    </svg>
  );
};

export const ManufacturerReg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="31"
      viewBox="0 0 33 31"
      fill="none"
    >
      <path
        d="M0.582031 29.7061H32.6329"
        stroke="#CCB16A"
        strokeMiterlimit="10"
      />
      <path
        d="M25.7813 19.3697L17.0156 28.9084L8.25 19.3697L11.8209 15.4839H22.2104L25.7813 19.3697Z"
        stroke="#CCB16A"
        strokeMiterlimit="10"
      />
      <path d="M25.7813 19.3696H8.25" stroke="#CCB16A" strokeMiterlimit="10" />
      <path
        d="M17.0156 15.4839L20.1356 19.3697L22.2104 15.4839"
        stroke="#CCB16A"
        strokeLinejoin="bevel"
      />
      <path
        d="M11.8203 15.4839L13.8977 19.3697L17.015 15.4839"
        stroke="#CCB16A"
        strokeLinejoin="bevel"
      />
      <path
        d="M13.8984 19.3696L17.0158 28.9083L20.1358 19.3696"
        stroke="#CCB16A"
        strokeLinejoin="bevel"
      />
      <path
        d="M16.6055 10.5322V13.0439"
        stroke="#CCB16A"
        strokeMiterlimit="10"
      />
      <path
        d="M21.6813 0.550293H11.5312V4.95391H21.6813V0.550293Z"
        stroke="#CCB16A"
        strokeMiterlimit="10"
      />
      <path
        d="M19.6155 4.9541H13.5938V6.84601H19.6155V4.9541Z"
        stroke="#CCB16A"
        strokeMiterlimit="10"
      />
      <path
        d="M18.3845 6.8457L17.5269 10.5321H15.6857L14.8281 6.8457H18.3845Z"
        stroke="#CCB16A"
        strokeMiterlimit="10"
      />
      <path
        d="M21.6797 2.75195H32.9997"
        stroke="#CCB16A"
        strokeMiterlimit="10"
      />
      <path
        d="M0.210938 2.75195H11.5309"
        stroke="#CCB16A"
        strokeMiterlimit="10"
      />
      <path
        d="M21.6797 0.550293H32.9997"
        stroke="#CCB16A"
        strokeMiterlimit="10"
      />
      <path
        d="M0.210938 0.550293H11.5309"
        stroke="#CCB16A"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export const CaratType = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 22 20"
      fill="none"
    >
      <path
        d="M16.5985 6.59999L17.363 2.013L20.4221 6.59999H16.5985ZM16.3191 7.69999H20.2472L12.7826 16.3438L16.3191 7.69999ZM5.67995 7.69999L9.21644 16.3438L1.75075 7.69999H5.67995ZM5.40055 6.59999H1.57695L4.63605 2.013L5.40055 6.59999ZM6.38065 5.79149L5.59855 1.1H9.89954L6.38065 5.79149ZM12.0995 1.1H16.4005L15.6184 5.79149L12.0995 1.1ZM7.14955 6.59999L10.9995 1.4663L14.8495 6.59999H7.14955ZM15.13 7.69999L10.9995 17.798L6.86905 7.69999H15.13ZM21.9071 6.84529L17.5071 0.245299C17.506 0.243099 17.5027 0.242 17.5016 0.2398C17.4554 0.1727 17.3949 0.1177 17.3223 0.0769998C17.3014 0.0648998 17.2783 0.0615998 17.2574 0.0516999C17.2178 0.0362999 17.1826 0.0142999 17.1397 0.00769996C17.1221 0.00439996 17.1045 0.0109999 17.0858 0.00879988C17.0737 0.00879988 17.0627 0 17.0495 0H4.94955C4.93635 0 4.92535 0.00879988 4.91215 0.00879988C4.89455 0.0109999 4.87805 0.00439996 4.85935 0.00769996C4.81645 0.0142999 4.78125 0.0362999 4.74275 0.0516999C4.72075 0.0615998 4.69765 0.0648998 4.67785 0.0769998C4.60525 0.1177 4.54365 0.1727 4.49855 0.2398C4.49635 0.242 4.49415 0.243099 4.49195 0.245299L0.0919555 6.84529C-0.0444444 7.05099 -0.0279445 7.32269 0.133755 7.50969L10.5837 19.6097C10.6068 19.6372 10.6387 19.6493 10.6662 19.6713C10.6904 19.69 10.7113 19.7109 10.7388 19.7252C10.9027 19.8154 11.0963 19.8154 11.2602 19.7252C11.2877 19.7109 11.3086 19.69 11.3328 19.6713C11.3603 19.6493 11.3922 19.6372 11.4164 19.6097L21.8664 7.50969C22.0281 7.32269 22.0446 7.05099 21.9071 6.84529Z"
        fill="#fff"
      />
    </svg>
  );
};

export const OwnedAssets = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="svg-icon"
      width={18}
      height={18}
      viewBox="0 0 1024 1024"
      version="1.1"
    >
      <path d="M497.69083 562.529258L3.577293 281.264629 497.69083 0l522.731877 281.264629zM93.009607 281.264629l404.681223 229.841048 427.486463-229.841048-426.59214-230.28821z" />
      <path d="M497.69083 793.264629L3.577293 512l148.01048-84.066376 21.910917 38.903057-79.59476 45.163319 404.681223 229.841048 427.486463-229.841048-90.773799-48.740611 21.463755-39.350219 163.661135 88.09083-522.731877 281.264629z" />
      <path d="M497.69083 1024L3.577293 742.735371l131.465502-74.675982 22.358078 38.903056-63.496943 35.772926 404.681223 230.28821 427.486463-230.28821-67.968559-36.667249 21.016594-39.350218 141.303056 76.017467-522.731877 281.264629z" />
    </svg>
  );
};

export const TransactionStatus = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width="48"
      height="48"
    >
      <rect width="64" height="64" rx="12" fill="#6B7280" />

      <path
        fill="#FFFFFF"
        d="M52,7H12a6,6,0,0,0-6,6V51a6,6,0,0,0,6,6H52a6,6,0,0,0,6-6V13A6,6,0,0,0,52,7Zm2,44a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2H52a2,2,0,0,1,2,2Z"
      />
      <path
        fill="#FFFFFF"
        d="M45,29a2,2,0,0,0,0-4H22.83l2.58-2.59a2,2,0,0,0-2.82-2.82l-6,6a2,2,0,0,0-.44,2.18A2,2,0,0,0,18,29Z"
      />
      <path
        fill="#FFFFFF"
        d="M47,36H20a2,2,0,0,0,0,4H42.17l-2.58,2.59a2,2,0,1,0,2.82,2.82l6-6a2,2,0,0,0,.44-2.18A2,2,0,0,0,47,36Z"
      />
    </svg>
  );
};

export const Profile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="svg-icon"
      width={24}
      height={24}
      viewBox="0 0 1024 1024"
      version="1.1"
    >
      <path
        d="M480 64A416.64 416.64 0 0 0 64 480 416.64 416.64 0 0 0 480 896 416.64 416.64 0 0 0 896 480 416.64 416.64 0 0 0 480 64z m0 64C674.752 128 832 285.248 832 480a351.36 351.36 0 0 1-81.024 225.024 289.408 289.408 0 0 0-162.944-171.776A159.36 159.36 0 0 0 640 416C640 328 568 256 480 256A160.448 160.448 0 0 0 320 416c0 46.272 20.224 88 52.032 117.248a289.024 289.024 0 0 0-162.752 171.776A350.208 350.208 0 0 1 128 480C128 285.248 285.248 128 480 128z m0 192C533.504 320 576 362.496 576 416S533.504 512 480 512A95.36 95.36 0 0 1 384 416C384 362.496 426.496 320 480 320z m0 256c108.8 0 198.016 77.248 218.752 179.776A350.528 350.528 0 0 1 480 832a349.248 349.248 0 0 1-218.496-76.224A222.72 222.72 0 0 1 480 576z"
        fill=""
      />
    </svg>
  );
};

export const MaterialItem = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={24}
      height={24}
      viewBox="0 0 1024 1024"
    >
      <path
        d="M416.182857 532.626286l68.608 301.787428H73.435429L141.897143 532.626286h274.285714z m466.358857 0l68.608 301.787428H539.648l68.608-301.787428h274.285714z m-521.069714 68.461714H196.754286l-37.449143 164.571429h239.616l-37.449143-164.571429z m466.358857 0H662.966857l-37.449143 164.571429h239.616l-37.302857-164.571429z m-178.468571-411.355429l68.608 274.285715H306.468571l54.857143-274.285715h288.036572z m-53.540572 68.608H417.645714l-27.501714 137.216h239.908571l-34.230857-137.216z"
        stroke="white"
        fill="#FFFFFF"
      />
    </svg>
  );
};
